import { GetJobsOrderBy } from '../codegen-overrides';
import { GetWorkbenchListOrderBy } from '../codegen-overrides';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: number;
  Upload: any;
};

export enum ApprovalStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type IAsset = INode & {
  __typename?: 'Asset';
  contentType: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  scanned: Scalars['Boolean'];
  thumbnailUrl: Scalars['String'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
  user: IUser;
  userId: Scalars['ID'];
};

export type IBadge = {
  __typename?: 'Badge';
  badgeType?: Maybe<Scalars['Int']>;
  brand?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['String']>;
  serviceType?: Maybe<Scalars['Int']>;
  subServiceType?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  video?: Maybe<Scalars['String']>;
};

export type IBankAccount = {
  __typename?: 'BankAccount';
  accountNumberLast4?: Maybe<Scalars['Int']>;
  bankName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  meetsRequirements?: Maybe<Scalars['Boolean']>;
};

export type ICheckTwilioVerificationCodeResponse = {
  __typename?: 'CheckTwilioVerificationCodeResponse';
  channel: Scalars['String'];
  dateCreated: Scalars['Date'];
  dateUpdated: Scalars['Date'];
  status: Scalars['String'];
  to: Scalars['String'];
};

export type IClaim = {
  __typename?: 'Claim';
  adjuster?: Maybe<IClaimAdjuster>;
  assignmentDate?: Maybe<Scalars['String']>;
  assignmentName?: Maybe<Scalars['String']>;
  assignmentStatusHistory?: Maybe<Array<Maybe<IClaimAssignmentStatusInfo>>>;
  assignmentStatusInfo?: Maybe<IClaimAssignmentStatusInfo>;
  attachments?: Maybe<Array<Maybe<IClaimAttachment>>>;
  brand?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  catField?: Maybe<Scalars['String']>;
  catNumber?: Maybe<Scalars['String']>;
  claimStatus?: Maybe<IClaimStatus>;
  claimStatusId?: Maybe<Scalars['Int']>;
  consolidatedJobIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  coverageDetail?: Maybe<Scalars['String']>;
  dateCreated?: Maybe<Scalars['String']>;
  dateOfLoss?: Maybe<Scalars['String']>;
  deductibleAmount?: Maybe<Scalars['Float']>;
  estimateApprovalAdjuster?: Maybe<Scalars['Boolean']>;
  estimateApprovalInsured?: Maybe<Scalars['Boolean']>;
  estimateTotal?: Maybe<Scalars['Float']>;
  externalAssignmentStatusId?: Maybe<Scalars['String']>;
  externalClaimGuid?: Maybe<Scalars['String']>;
  externalClaimNumber?: Maybe<Scalars['String']>;
  fnolDate?: Maybe<Scalars['String']>;
  homeeAssignee?: Maybe<Scalars['String']>;
  homeeClaimId: Scalars['String'];
  howMuchToCollect?: Maybe<Scalars['Float']>;
  insured?: Maybe<IClaimInsured>;
  insuredAddress?: Maybe<IClaimInsuredAddress>;
  isHomeeCollectingDeductible?: Maybe<Scalars['Boolean']>;
  isPaymentSent?: Maybe<Scalars['Boolean']>;
  isReferralTypeMissing?: Maybe<Scalars['Boolean']>;
  isWaterMitigationAddressed?: Maybe<Scalars['Boolean']>;
  isWaterMitigationNeeded?: Maybe<Scalars['Boolean']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  lossAddress?: Maybe<IClaimLossAddress>;
  lossDetail?: Maybe<Scalars['String']>;
  lossType?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<IClaimNote>>>;
  paymentBreakdown?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  policyType?: Maybe<Scalars['String']>;
  referralChannel?: Maybe<Scalars['String']>;
  referralType?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  waterMitigationDateScheduled?: Maybe<Scalars['String']>;
};

export type IClaimAdjuster = {
  __typename?: 'ClaimAdjuster';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeeUserId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  primaryPhone?: Maybe<Scalars['String']>;
};

export type IClaimAssignmentStatusInfo = {
  __typename?: 'ClaimAssignmentStatusInfo';
  assignmentStatusId: Scalars['Int'];
  assignmentStatusReason?: Maybe<Scalars['String']>;
  communicationDate?: Maybe<Scalars['String']>;
  noteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  scheduledDate?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  statusDate?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type IClaimAttachment = {
  __typename?: 'ClaimAttachment';
  attachmentId: Scalars['String'];
  attachmentUrl?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  dateAdded?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  s3Location?: Maybe<IClaimAttachmentS3Location>;
  s3Path?: Maybe<Scalars['String']>;
  sha1?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type IClaimAttachmentS3Location = {
  __typename?: 'ClaimAttachmentS3Location';
  bucket?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type IClaimContactInfo = {
  __typename?: 'ClaimContactInfo';
  extenstion?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  number: Scalars['String'];
  type: Scalars['String'];
};

export type IClaimInsured = {
  __typename?: 'ClaimInsured';
  additionalPhones?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeeUserId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<IClaimContactInfo>>>;
  primaryPhone?: Maybe<Scalars['String']>;
  secondaryPhone?: Maybe<Scalars['String']>;
};

export type IClaimInsuredAddress = {
  __typename?: 'ClaimInsuredAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
};

export type IClaimLossAddress = {
  __typename?: 'ClaimLossAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
};

export type IClaimNote = {
  __typename?: 'ClaimNote';
  author?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  homeeAssignmentId?: Maybe<Scalars['String']>;
  noteId: Scalars['String'];
  noteText?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type IClaimStatus = {
  __typename?: 'ClaimStatus';
  claimStatusDescription?: Maybe<Scalars['String']>;
  claimStatusId: Scalars['Int'];
  claimStatusName?: Maybe<Scalars['String']>;
};

export type IComment = {
  __typename?: 'Comment';
  body: Scalars['String'];
  commentThreadId: Scalars['ID'];
  createdAt: Scalars['Date'];
  deleted: Scalars['Boolean'];
  hiddenBy?: Maybe<Scalars['ID']>;
  hiddenByName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isInternalOnly: Scalars['Boolean'];
  parentCommentId?: Maybe<Scalars['ID']>;
  replies: Array<IComment>;
  updatedAt: Scalars['Date'];
  userId: Scalars['ID'];
  userName: Scalars['String'];
  userRoles: Array<Scalars['Int']>;
};

export type ICompaniesReqConnection = {
  __typename?: 'CompaniesReqConnection';
  edges: Array<ICompanyV2>;
  totalCount: Scalars['Int'];
};

export type ICompany = INode & {
  __typename?: 'Company';
  accountId: Scalars['ID'];
  address?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  codeNumber: Scalars['Int'];
  companyServices: Array<ICompanyService>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  employeeCount: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  flatRateEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  jobReceivingPreferences: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  notifyAccept: Scalars['Boolean'];
  notifyComplete: Scalars['Boolean'];
  notifyInitiate: Scalars['Boolean'];
  notifyRequest: Scalars['Boolean'];
  rateAdjustment: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
  user: IUser;
  userId: Scalars['ID'];
  website?: Maybe<Scalars['String']>;
};

export type ICompanyAddress = {
  __typename?: 'CompanyAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  geo?: Maybe<IGeoCoordinate>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ICompanyAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  geo?: InputMaybe<IGeoCoordinateInput>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type ICompanyAddresses = {
  __typename?: 'CompanyAddresses';
  mailing?: Maybe<ICompanyAddress>;
  physical?: Maybe<ICompanyAddress>;
};

export type ICompanyAddressesInput = {
  mailing?: InputMaybe<ICompanyAddressInput>;
  physical?: InputMaybe<ICompanyAddressInput>;
};

export enum CompanyAvailability {
  Offline = 'offline',
  Online = 'online'
}

export type ICompanyEmployee = {
  __typename?: 'CompanyEmployee';
  roles?: Maybe<Array<Scalars['Int']>>;
  userId: Scalars['ID'];
};

export type ICompanyFlow = {
  __typename?: 'CompanyFlow';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum CompanyFlowLabel {
  HomeeManaged = 'HomeeManaged',
  JobNow = 'JobNow',
  ProManaged = 'ProManaged'
}

export enum CompanyOrderByType {
  DateCreated = 'dateCreated',
  Name = 'name'
}

export type ICompanyOrganization = {
  __typename?: 'CompanyOrganization';
  approved?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['ID']>;
  trained?: Maybe<Scalars['Boolean']>;
};

export type ICompanyService = {
  __typename?: 'CompanyService';
  id: Scalars['ID'];
  legacyService: Scalars['Int'];
  service: IService;
  serviceLicenses: Array<ICompanyServiceLicense>;
  status: Scalars['Int'];
  subCompanyServices: Array<ICompanyService>;
};

export type ICompanyServiceArea = {
  __typename?: 'CompanyServiceArea';
  marketId: Scalars['ID'];
  marketName: Scalars['String'];
  postalCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ICompanyServiceLicense = {
  __typename?: 'CompanyServiceLicense';
  id: Scalars['ID'];
  jurisdiction?: Maybe<Scalars['String']>;
  license?: Maybe<Scalars['String']>;
};

export enum CompanyStatus {
  Active = 'active',
  Deactivated = 'deactivated',
  Pending = 'pending',
  Suspended = 'suspended'
}

export type ICompanyV2 = INode & {
  __typename?: 'CompanyV2';
  acceptedTermsAndConditions?: Maybe<Scalars['Date']>;
  activeJobCount: Scalars['Int'];
  addresses: ICompanyAddresses;
  assignee?: Maybe<ICompanyV2UserInfo>;
  availability?: Maybe<CompanyAvailability>;
  averageRating?: Maybe<Scalars['Int']>;
  bankAccount?: Maybe<IBankAccount>;
  capacity?: Maybe<Scalars['Int']>;
  catCapacity?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  employeeCount: Scalars['Int'];
  flows: Array<ICompanyFlow>;
  founded?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  market?: Maybe<IMarket>;
  name: Scalars['String'];
  organizations?: Maybe<Array<Maybe<ICompanyOrganization>>>;
  owners: Array<IUser>;
  parent?: Maybe<ICompanyV2>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberAfterHours?: Maybe<Scalars['String']>;
  pointOfContact?: Maybe<IContactInfo>;
  profileGorillaStatus?: Maybe<Scalars['String']>;
  serviceAreas: Array<Maybe<ICompanyServiceArea>>;
  services: Array<Maybe<IService>>;
  servicesCount: Scalars['Int'];
  status: CompanyStatus;
  stripeId?: Maybe<Scalars['ID']>;
  subassignmentCount: Scalars['Int'];
  symbilityId?: Maybe<Scalars['ID']>;
  taxId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  website?: Maybe<Scalars['String']>;
  xactimateAddress?: Maybe<Scalars['String']>;
};

export type ICompanyV2UserInfo = {
  __typename?: 'CompanyV2UserInfo';
  userId?: Maybe<Scalars['ID']>;
};

export type IConnection = {
  edges: Array<INode>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IConsumerConnection = {
  __typename?: 'ConsumerConnection';
  edges: Array<IUser>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IConsumerReqConnection = {
  __typename?: 'ConsumerReqConnection';
  edges: Array<IConsumerRequest>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IConsumerRequest = IWorkbenchItem & {
  __typename?: 'ConsumerRequest';
  acceptedProviderRequest?: Maybe<IProviderRequest>;
  address?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['Date']>;
  assignedCompanyId?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  bucketLabel?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  codeNumber?: Maybe<Scalars['Int']>;
  commentThreadId?: Maybe<Scalars['ID']>;
  company?: Maybe<ICompanyV2>;
  consolidatedJobId: Scalars['ID'];
  consumer: IUser;
  consumerId: Scalars['ID'];
  consumerName?: Maybe<Scalars['String']>;
  contacts: Array<IContactInfo>;
  contactsMap: IContactMapInfo;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  declineReason?: Maybe<Scalars['String']>;
  diagnostic: Scalars['Boolean'];
  estimate?: Maybe<IJobEstimate>;
  estimateId?: Maybe<Scalars['ID']>;
  experienceMax: Scalars['Int'];
  experienceMin: Scalars['Int'];
  flatRate: Scalars['Int'];
  /** Indicates if authorized user is subscribed to notifications for this consumer request */
  following: Scalars['Boolean'];
  id: Scalars['ID'];
  /** @deprecated 4-22-2020 Use media instead */
  images: Array<IMedia>;
  installationModel?: Maybe<Scalars['String']>;
  installationOrderId?: Maybe<Scalars['ID']>;
  installationProducts?: Maybe<Scalars['String']>;
  installationVendor?: Maybe<Scalars['Int']>;
  internalAssignee?: Maybe<IContactInfo>;
  job?: Maybe<IJob>;
  /** @deprecated Use job - this is a 1:1 relationship now */
  jobs: Array<IJob>;
  lat: Scalars['Float'];
  leadRisk: Scalars['Int'];
  licensed: Scalars['Boolean'];
  lng: Scalars['Float'];
  logs: Array<IConsumerRequestLog>;
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  media: Array<IMedia>;
  networkInhouse?: Maybe<Scalars['Boolean']>;
  networkOpen?: Maybe<Scalars['Boolean']>;
  networkPreferred?: Maybe<Scalars['Boolean']>;
  networks: Array<Scalars['Int']>;
  /** @deprecated Use requestNote */
  note?: Maybe<INote>;
  organization?: Maybe<IOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['Int']>;
  property?: Maybe<IUserProperty>;
  propertyId?: Maybe<Scalars['ID']>;
  providerName?: Maybe<Scalars['String']>;
  /** @deprecated This will be removed in the near future (11-13-19) */
  providerRequests: IProviderReqConnection;
  referenceNumber?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['Date']>;
  requestNote?: Maybe<INote>;
  scheduledDate?: Maybe<Scalars['Date']>;
  scheduledDateTimezone?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceRequestType?: Maybe<IServiceRequestType>;
  serviceType: Scalars['Int'];
  serviceTypeLabel?: Maybe<Scalars['String']>;
  siteAccessNote?: Maybe<ISiteAccessNote>;
  state?: Maybe<State>;
  status: Scalars['Int'];
  /** utcOffset is in minutes; default is 0. This is required to print time in user's timezone instead of utc. */
  statusDescription: Scalars['String'];
  subBucket?: Maybe<Scalars['String']>;
  subBucketColor: Scalars['String'];
  subBucketLabel?: Maybe<Scalars['String']>;
  subServiceType?: Maybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
  tenantMobile?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userPartnerServiceOptionId?: Maybe<Scalars['ID']>;
  waiver: Scalars['Date'];
  workorder?: Maybe<IWorkorder>;
  workorderId?: Maybe<Scalars['ID']>;
  zipcode?: Maybe<Scalars['String']>;
};


export type IConsumerRequestProviderRequestsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<Scalars['Int']>>;
};


export type IConsumerRequestStatusDescriptionArgs = {
  utcOffset?: InputMaybe<Scalars['Int']>;
};

export type IConsumerRequestLog = {
  __typename?: 'ConsumerRequestLog';
  consumerRequest: IConsumerRequest;
  consumerRequestId: Scalars['ID'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  insertCounter: Scalars['Int'];
  statusNew: Scalars['Int'];
  statusOld: Scalars['Int'];
  user?: Maybe<IUser>;
  userId?: Maybe<Scalars['ID']>;
};

export type IContactInfo = IUserBase & {
  __typename?: 'ContactInfo';
  email?: Maybe<Scalars['String']>;
  /** How user is presented to end-user; i.e. Responsible Party, Provider, Policyholder, etc */
  label: Scalars['String'];
  mobile: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** Indicates most relevant user role if user has more than one; i.e. what profile they should be linked to */
  role?: Maybe<UserRole>;
  userId?: Maybe<Scalars['ID']>;
};

export type IContactMapInfo = {
  __typename?: 'ContactMapInfo';
  consumer?: Maybe<IContactInfo>;
  manager?: Maybe<IContactInfo>;
  propertyManager?: Maybe<IContactInfo>;
  provider?: Maybe<IContactInfo>;
  resident?: Maybe<IContactInfo>;
};

export type ICreateTwilioVerificationInstanceResponse = {
  __typename?: 'CreateTwilioVerificationInstanceResponse';
  channel: Scalars['String'];
  dateCreated: Scalars['Date'];
  dateUpdated: Scalars['Date'];
  sendCodeAttempts: Array<ISendCodeAttempt>;
  status: Scalars['String'];
  to: Scalars['String'];
};

export type IEstimate = INode & {
  __typename?: 'Estimate';
  claimId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['ID']>;
  lastUpdatedAt?: Maybe<Scalars['String']>;
  revision?: Maybe<IEstimateRevision>;
  revisions?: Maybe<IEstimateRevisions>;
  status?: Maybe<EstimateStatus>;
};

export type IEstimateAttachment = INode & {
  __typename?: 'EstimateAttachment';
  checksum?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  length?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  status?: Maybe<EstimateAttachmentStatus>;
  url: Scalars['String'];
};

export type IEstimateAttachmentPackage = {
  __typename?: 'EstimateAttachmentPackage';
  id: Scalars['ID'];
  revisionId: Scalars['ID'];
  status?: Maybe<EstimateAttachmentStatus>;
  url?: Maybe<Scalars['String']>;
};

export enum EstimateAttachmentStatus {
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type IEstimateAttachmentUrlLink = {
  __typename?: 'EstimateAttachmentUrlLink';
  attachmentId: Scalars['String'];
  url: Scalars['String'];
};

export type IEstimateAttachments = {
  __typename?: 'EstimateAttachments';
  count: Scalars['Int'];
  data: Array<Maybe<IEstimateAttachment>>;
};

export type IEstimateAttachmentsDownload = {
  __typename?: 'EstimateAttachmentsDownload';
  attachmentPackId?: Maybe<Scalars['String']>;
  carrierName?: Maybe<Scalars['String']>;
  status?: Maybe<EstimateAttachmentStatus>;
  userId?: Maybe<Scalars['String']>;
};

export type IEstimateDiffUrlSizes = {
  __typename?: 'EstimateDiffUrlSizes';
  a0?: Maybe<Scalars['String']>;
  a90?: Maybe<Scalars['String']>;
  a180?: Maybe<Scalars['String']>;
  a270?: Maybe<Scalars['String']>;
};

export enum EstimateDownloadType {
  Direct = 'DIRECT',
  Email = 'EMAIL'
}

export type IEstimateItemAction = {
  __typename?: 'EstimateItemAction';
  id: Scalars['ID'];
  name: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
  types?: Maybe<IEstimateItemTypes>;
};

export type IEstimateItemActions = {
  __typename?: 'EstimateItemActions';
  count: Scalars['Int'];
  id: Scalars['ID'];
  items: Array<Maybe<IEstimateItemAction>>;
};

export type IEstimateItemGrade = {
  __typename?: 'EstimateItemGrade';
  id: Scalars['ID'];
  name: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
};

export type IEstimateItemGrades = {
  __typename?: 'EstimateItemGrades';
  count: Scalars['Int'];
  id: Scalars['ID'];
  items: Array<Maybe<IEstimateItemGrade>>;
};

export type IEstimateItemTitle = {
  __typename?: 'EstimateItemTitle';
  actions?: Maybe<IEstimateItemActions>;
  id: Scalars['ID'];
  isNoteMandatory?: Maybe<Scalars['Boolean']>;
  measurementsUnit?: Maybe<Scalars['String']>;
  measurementsUnitHint?: Maybe<Scalars['String']>;
  measurementsUnitId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noteHint?: Maybe<Scalars['String']>;
};

export type IEstimateItemTitles = {
  __typename?: 'EstimateItemTitles';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateItemTitle>>;
};

export type IEstimateItemType = {
  __typename?: 'EstimateItemType';
  grades?: Maybe<IEstimateItemGrades>;
  id: Scalars['ID'];
  name: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
};

export type IEstimateItemTypes = {
  __typename?: 'EstimateItemTypes';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateItemType>>;
};

export type IEstimateLineItem = INode & {
  __typename?: 'EstimateLineItem';
  action?: Maybe<IEstimateLineItemSelection>;
  grade?: Maybe<IEstimateLineItemSelection>;
  id: Scalars['ID'];
  measurementUnit?: Maybe<Scalars['String']>;
  notes: Array<Maybe<IEstimateNote>>;
  quantity?: Maybe<Scalars['Float']>;
  roomId: Scalars['ID'];
  title?: Maybe<IEstimateItemTitle>;
  totalCost?: Maybe<Scalars['Float']>;
  type?: Maybe<IEstimateLineItemSelection>;
};

export type IEstimateLineItemSelection = {
  __typename?: 'EstimateLineItemSelection';
  id: Scalars['ID'];
  name: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
};

export type IEstimateLineItems = {
  __typename?: 'EstimateLineItems';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateLineItem>>;
};

export type IEstimateNote = {
  __typename?: 'EstimateNote';
  id: Scalars['ID'];
  note: Scalars['String'];
};

export type IEstimateNotes = {
  __typename?: 'EstimateNotes';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateNote>>;
};

export type IEstimatePdf = {
  __typename?: 'EstimatePdf';
  status?: Maybe<EstimateAttachmentStatus>;
  type?: Maybe<EstimateRevisionDocumentType>;
};

export type IEstimatePdfLink = {
  __typename?: 'EstimatePdfLink';
  url: Scalars['String'];
};

export type IEstimatePdfReqConnection = {
  __typename?: 'EstimatePdfReqConnection';
  types: Array<Maybe<IEstimatePdf>>;
};

export enum EstimatePricingModel {
  LineItems = 'LINE_ITEMS',
  Manual = 'MANUAL'
}

export type IEstimateRevision = INode & {
  __typename?: 'EstimateRevision';
  attachments?: Maybe<IEstimateAttachments>;
  customerTotalCost?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastUpdatedAt: Scalars['String'];
  revisionName?: Maybe<Scalars['String']>;
  revisionNumber?: Maybe<Scalars['Int']>;
  rooms: IEstimateRooms;
  status: EstimateStatus;
  totalCalcType?: Maybe<EstimatePricingModel>;
  totalCost?: Maybe<Scalars['Float']>;
};

export enum EstimateRevisionDocumentStatus {
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export enum EstimateRevisionDocumentType {
  WithoutPrices = 'WITHOUT_PRICES',
  WithCustomerTotal = 'WITH_CUSTOMER_TOTAL',
  WithPrices = 'WITH_PRICES'
}

export type IEstimateRevisionReqConnection = {
  __typename?: 'EstimateRevisionReqConnection';
  edges: Array<Maybe<IEstimateRevision>>;
  totalCount: Scalars['Int'];
};

export type IEstimateRevisions = {
  __typename?: 'EstimateRevisions';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateRevision>>;
};

export type IEstimateRoom = {
  __typename?: 'EstimateRoom';
  attachments?: Maybe<IEstimateAttachments>;
  id: Scalars['ID'];
  lineItems?: Maybe<IEstimateLineItems>;
  name?: Maybe<Scalars['String']>;
  notes: IEstimateNotes;
  revisionId: Scalars['ID'];
  totalCost?: Maybe<Scalars['Float']>;
};

export type IEstimateRooms = {
  __typename?: 'EstimateRooms';
  count: Scalars['Int'];
  items: Array<Maybe<IEstimateRoom>>;
};

export enum EstimateStatus {
  ClientAccepted = 'CLIENT_ACCEPTED',
  ClientRejected = 'CLIENT_REJECTED',
  ClientReviewRequested = 'CLIENT_REVIEW_REQUESTED',
  Draft = 'DRAFT',
  InnerReviewApproved = 'INNER_REVIEW_APPROVED',
  InnerReviewDeclined = 'INNER_REVIEW_DECLINED',
  InnerReviewFinished = 'INNER_REVIEW_FINISHED',
  InnerReviewModified = 'INNER_REVIEW_MODIFIED',
  InnerReviewRequested = 'INNER_REVIEW_REQUESTED',
  Scheduled = 'SCHEDULED',
  Started = 'STARTED'
}

export enum EstimateType {
  Manual = 'MANUAL',
  Upload = 'UPLOAD'
}

export type IEstimateUrls = {
  __typename?: 'EstimateUrls';
  large?: Maybe<IEstimateDiffUrlSizes>;
  medium?: Maybe<IEstimateDiffUrlSizes>;
  original?: Maybe<Scalars['String']>;
  small?: Maybe<IEstimateDiffUrlSizes>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type IFloatRange = {
  __typename?: 'FloatRange';
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type IGenerateTwilioCodeResponse = {
  __typename?: 'GenerateTwilioCodeResponse';
  code: Scalars['String'];
};

export type IGeoCoordinate = {
  __typename?: 'GeoCoordinate';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type IGeoCoordinateInput = {
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export { GetJobsOrderBy };

export type IGetPhoneTypeResponse = {
  __typename?: 'GetPhoneTypeResponse';
  type: Scalars['String'];
};

export { GetWorkbenchListOrderBy };

export type IIntRange = {
  __typename?: 'IntRange';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type IJob = IWorkbenchItem & {
  __typename?: 'Job';
  address?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['Date']>;
  assignedAt: Scalars['Date'];
  assignedCompanyId?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  bucketLabel?: Maybe<Scalars['String']>;
  claims?: Maybe<Array<Maybe<IClaim>>>;
  code?: Maybe<Scalars['String']>;
  codeNumber?: Maybe<Scalars['Float']>;
  commentThreadId?: Maybe<Scalars['ID']>;
  company?: Maybe<ICompanyV2>;
  companyId?: Maybe<Scalars['ID']>;
  consolidatedJobId: Scalars['ID'];
  consumer: IUser;
  consumerFlatRate?: Maybe<Scalars['Float']>;
  consumerId: Scalars['ID'];
  consumerName?: Maybe<Scalars['String']>;
  consumerRateBase: Scalars['Float'];
  consumerRateHour: Scalars['Float'];
  consumerRequest?: Maybe<IConsumerRequest>;
  consumerRequestId?: Maybe<Scalars['ID']>;
  contacts: Array<IContactInfo>;
  contactsMap: IContactMapInfo;
  createdAt: Scalars['Date'];
  diagnostic: Scalars['Boolean'];
  diagnosticNote?: Maybe<IJobDiagnosticNote>;
  diagnosticStatus?: Maybe<Scalars['Int']>;
  estimate?: Maybe<IJobEstimate>;
  estimateId?: Maybe<Scalars['ID']>;
  estimateJob?: Maybe<IJob>;
  estimateV2?: Maybe<IEstimate>;
  fasttrack: Scalars['Int'];
  finalizedAt?: Maybe<Scalars['Date']>;
  /** Indicates if authorized user is subscribed to notifications for this job */
  following: Scalars['Boolean'];
  id: Scalars['ID'];
  /** @deprecated 4-21-2020 Use media instead */
  images: Array<IMedia>;
  installationModel?: Maybe<Scalars['String']>;
  installationVendor?: Maybe<Scalars['Int']>;
  internalAssignee?: Maybe<IContactInfo>;
  invoice?: Maybe<IJobInvoice>;
  lat: Scalars['Float'];
  limitExtensions: Array<IJobLimitExtension>;
  limitLabor: Scalars['Int'];
  limitLaborNotified: Scalars['Int'];
  limitMaterials: Scalars['Int'];
  limitMaterialsNotified: Scalars['Int'];
  limitReached: Scalars['Int'];
  limitTotal: Scalars['Int'];
  limitTotalNotified: Scalars['Int'];
  limitType: Scalars['Int'];
  lineItems: Array<IJobLineItem>;
  linkedJobs: Array<IJob>;
  lng: Scalars['Float'];
  localCreatedAt?: Maybe<Scalars['Date']>;
  localFinalizedAt?: Maybe<Scalars['Date']>;
  lock?: Maybe<IJobLock>;
  locked: Scalars['Boolean'];
  logs: Array<IJobLog>;
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  materials: Array<IJobMaterial>;
  media: Array<IMedia>;
  note?: Maybe<INote>;
  organization?: Maybe<IOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
  partnerRateBase?: Maybe<Scalars['Float']>;
  partnerRateHour?: Maybe<Scalars['Float']>;
  /** Indicates whether or not provider is stopping for parts */
  partsStop: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  property?: Maybe<IUserProperty>;
  propertyId?: Maybe<Scalars['ID']>;
  provider: IUser;
  providerFlatRate?: Maybe<Scalars['Float']>;
  providerId: Scalars['ID'];
  providerName?: Maybe<Scalars['String']>;
  providerRateBase: Scalars['Float'];
  providerRateHour: Scalars['Float'];
  providerRequest?: Maybe<IProviderRequest>;
  providerRequestId?: Maybe<Scalars['ID']>;
  referenceNumber?: Maybe<Scalars['String']>;
  repairJob?: Maybe<IJob>;
  requestNote?: Maybe<INote>;
  resolutionAccepted?: Maybe<Scalars['Int']>;
  resolutionSuggested?: Maybe<Scalars['Int']>;
  scheduledDate?: Maybe<Scalars['Date']>;
  scheduledDateTimezone?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceRequestType?: Maybe<IServiceRequestType>;
  serviceType: Scalars['Int'];
  serviceTypeLabel?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Date']>;
  status: Scalars['Int'];
  statusDescription: Scalars['String'];
  stripeJobInvoice?: Maybe<IStripeJobInvoice>;
  subBucket?: Maybe<Scalars['String']>;
  subBucketColor: Scalars['String'];
  subBucketLabel?: Maybe<Scalars['String']>;
  subServiceId?: Maybe<Scalars['ID']>;
  subsidyFlatRate: Scalars['Float'];
  subsidyLevel: Scalars['Float'];
  subsidyRateBase: Scalars['Float'];
  subsidyRateHour: Scalars['Float'];
  tags: Array<Scalars['String']>;
  timeAdjustment: Scalars['Int'];
  transfers: Array<Maybe<IJobTransfer>>;
  updatedAt?: Maybe<Scalars['Date']>;
  userService: IUserService;
  workorder?: Maybe<IWorkorder>;
  workorderId?: Maybe<Scalars['ID']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type IJobConnection = {
  __typename?: 'JobConnection';
  edges: Array<IJob>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IJobDiagnosticNote = {
  __typename?: 'JobDiagnosticNote';
  createdAt?: Maybe<Scalars['Date']>;
  job: IJob;
  jobId: Scalars['ID'];
  note: Scalars['String'];
  noteEn?: Maybe<Scalars['String']>;
  noteEs?: Maybe<Scalars['String']>;
  scopeOfWork?: Maybe<Scalars['String']>;
  scopeOfWorkEn?: Maybe<Scalars['String']>;
  scopeOfWorkEs?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IJobEstimate = INode & {
  __typename?: 'JobEstimate';
  assets: Array<IAsset>;
  canStartToday: Scalars['Boolean'];
  /** Range of what pro would have earned if job was run on timer instead */
  comparedEarningsRange?: Maybe<IFloatRange>;
  completionConsolidatedJobId?: Maybe<Scalars['ID']>;
  completionJob?: Maybe<IJob>;
  completionJobId?: Maybe<Scalars['ID']>;
  /** Total amount the consumer pays */
  consumerTotal?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  deductible?: Maybe<Scalars['Float']>;
  estimateConsolidatedJobId: Scalars['ID'];
  estimateConsumerRequest?: Maybe<IConsumerRequest>;
  estimateConsumerRequestId?: Maybe<Scalars['ID']>;
  estimateJob?: Maybe<IJob>;
  estimateJobId?: Maybe<Scalars['ID']>;
  estimateStatus: JobEstimateStatus;
  /** User-readable description of estimate status */
  estimateStatusDescription: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  initialEstimateRevisionId: Scalars['ID'];
  items: Array<IJobEstimateItem>;
  /** Percent margin for Homee on labor costs */
  laborMargin?: Maybe<Scalars['Int']>;
  /** Range of expected labor time measured in seconds */
  laborTimeRange: IIntRange;
  latestEstimateRevisionId: Scalars['ID'];
  /** Percent margin for Homee on material costs */
  materialsMargin?: Maybe<Scalars['Int']>;
  nonRecoverableDepreciation?: Maybe<Scalars['Float']>;
  /** Total amount the pro is paid */
  proTotal?: Maybe<Scalars['Float']>;
  recoverableDepreciation?: Maybe<Scalars['Float']>;
  /** Total percent margin for Homee on job */
  totalMargin?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Date'];
};

export type IJobEstimateInputWhere = {
  consumerRequestCode?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  jobCode?: InputMaybe<Scalars['ID']>;
};

export type IJobEstimateItem = INode & {
  __typename?: 'JobEstimateItem';
  additionalNotes?: Maybe<Scalars['String']>;
  assets: Array<IAsset>;
  /** Amount consumer pays for labor */
  consumerLaborPrice?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  estimate: IJobEstimate;
  estimateId: Scalars['ID'];
  id: Scalars['ID'];
  initialItemRevisionId: Scalars['ID'];
  /** Range of expected labor time measured in seconds */
  laborTimeRange: IIntRange;
  latestItemRevisionId: Scalars['ID'];
  materials: Array<IJobEstimateItemMaterial>;
  measurements?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Amount paid to pro for labor */
  proLaborPrice?: Maybe<Scalars['Float']>;
  recommendedSolution?: Maybe<Scalars['String']>;
  status: RevisionStatus;
  /** Total amount consumer pays for materials */
  totalConsumerMaterialPrice?: Maybe<Scalars['Float']>;
  /** Total price of materials added by pro */
  totalProMaterialPrice?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Date'];
};

export type IJobEstimateItemMaterial = INode & {
  __typename?: 'JobEstimateItemMaterial';
  consumerPricePerUnit?: Maybe<Scalars['Float']>;
  consumerTotal?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  estimateItem: IJobEstimateItem;
  estimateItemId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  proPricePerUnit?: Maybe<Scalars['Float']>;
  proTotal?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  revisedBy?: Maybe<IUser>;
  revisedById?: Maybe<Scalars['ID']>;
  status: RevisionStatus;
  updatedAt: Scalars['Date'];
};

export enum JobEstimateStatus {
  AcceptedConsumer = 'ACCEPTED_CONSUMER',
  Cancelled = 'CANCELLED',
  DeclinedConsumer = 'DECLINED_CONSUMER',
  DeclinedExternal = 'DECLINED_EXTERNAL',
  DeclinedInternal = 'DECLINED_INTERNAL',
  Expired = 'EXPIRED',
  InternalModifiedSentToProForReview = 'INTERNAL_MODIFIED_SENT_TO_PRO_FOR_REVIEW',
  InternalModifying = 'INTERNAL_MODIFYING',
  ProviderStarted = 'PROVIDER_STARTED',
  SentForExternalReview = 'SENT_FOR_EXTERNAL_REVIEW',
  SentForInternalReview = 'SENT_FOR_INTERNAL_REVIEW',
  SentToConsumer = 'SENT_TO_CONSUMER'
}

export type IJobInvoice = {
  __typename?: 'JobInvoice';
  /** Flat rate for job seen by consumer */
  consumerFlatRate?: Maybe<Scalars['Float']>;
  /** Initial rate seen by consumer */
  consumerRateBase: Scalars['Float'];
  /** Rate per hour seen by consumer */
  consumerRateHour: Scalars['Float'];
  /** = consumerRateBase + consumerTotalHourly + consumerFlatRate + consumerTotalMaterials - discount */
  consumerTotalCost: Scalars['Float'];
  /** Calculated total hourly charge seen by consumer */
  consumerTotalHourly: Scalars['Float'];
  /** Calculated total material charge seen by consumer */
  consumerTotalMaterials: Scalars['Float'];
  /** Coterie insurance fee if applicable */
  coteriePremium?: Maybe<Scalars['Float']>;
  /** Applied to the job */
  discount?: Maybe<Scalars['Float']>;
  /** Billable time elapsed in seconds */
  elapsedTime: Scalars['Int'];
  elapsedTimeBillable?: Maybe<Scalars['Int']>;
  job: IJob;
  jobId: Scalars['ID'];
  /** Promocode used */
  promocode?: Maybe<Scalars['String']>;
  /** Flat rate for job seen by provider */
  providerFlatRate?: Maybe<Scalars['Float']>;
  /** Initial rate seen by provider */
  providerRateBase: Scalars['Float'];
  /** Rate per hour seen by provider */
  providerRateHour: Scalars['Float'];
  /** = providerRateBase + subsidyRateBase + providerTotalHourly + subsidyTotalHourly + providerFlatRate + subsidyFlatRate + providerTotalMaterials - coteriePremium */
  providerTotalCost: Scalars['Float'];
  /** Calculated total hourly charge seen by provider */
  providerTotalHourly: Scalars['Float'];
  /** Calculated total material charge seen by provider */
  providerTotalMaterials: Scalars['Float'];
  subsidyFlatRate: Scalars['Float'];
  subsidyLevel: Scalars['Float'];
  subsidyRateBase: Scalars['Float'];
  subsidyRateHour: Scalars['Float'];
  subsidyTotalHourly: Scalars['Float'];
  tip?: Maybe<Scalars['Float']>;
  /** Date & time job was updated */
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IJobLimitExtension = {
  __typename?: 'JobLimitExtension';
  consumerNote?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  currencyIncrease?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  job: IJob;
  jobId: Scalars['ID'];
  minutesIncrease?: Maybe<Scalars['Int']>;
  providerNote?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  statusDescription?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IJobLineItem = {
  __typename?: 'JobLineItem';
  billable?: Maybe<Scalars['Boolean']>;
  consumerTotal?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job: IJob;
  jobId: Scalars['ID'];
  jobMaterial?: Maybe<IJobMaterial>;
  jobMaterialId?: Maybe<Scalars['ID']>;
  lineItemType?: Maybe<Scalars['String']>;
  providerTotal?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  unitAmount?: Maybe<Scalars['Float']>;
  unitQuantity?: Maybe<Scalars['Float']>;
  unitType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export type IJobLock = {
  __typename?: 'JobLock';
  code: Scalars['String'];
  codeNumber: Scalars['Int'];
  createdAt?: Maybe<Scalars['Date']>;
  job: IJob;
  jobId: Scalars['ID'];
};

export type IJobLog = {
  __typename?: 'JobLog';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  insertCounter: Scalars['Int'];
  job: IJob;
  jobId: Scalars['ID'];
  statusCodeNew: Scalars['Int'];
  statusCodeOld: Scalars['Int'];
  user: IUser;
  userId: Scalars['ID'];
};

export type IJobMaterial = {
  __typename?: 'JobMaterial';
  consumerPrice: Scalars['Float'];
  createdAt: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  job: IJob;
  jobId: Scalars['ID'];
  partnerCost?: Maybe<Scalars['Float']>;
  providerPrice: Scalars['Float'];
  quantity: Scalars['Int'];
  rapidpassCode?: Maybe<Scalars['String']>;
  skipReimbursement: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum JobOrigin {
  OnDemand = 'ON_DEMAND',
  WorkOrder = 'WORK_ORDER'
}

export type IJobTransfer = {
  __typename?: 'JobTransfer';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  status?: Maybe<TransferStatus>;
  type?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum Language {
  English = 'ENGLISH',
  Espanol = 'ESPANOL',
  Francais = 'FRANCAIS'
}

export type ILineItemBody = {
  action?: InputMaybe<ILineItemsDetails>;
  grade?: InputMaybe<ILineItemsDetails>;
  measurementUnit?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Array<InputMaybe<ILineItemNote>>>;
  quantity?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<ILineItemsDetailsTitle>;
  totalCost?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<ILineItemsDetails>;
};

export type ILineItemNote = {
  id?: InputMaybe<Scalars['ID']>;
  note: Scalars['String'];
};

export type ILineItemsDetails = {
  id: Scalars['String'];
};

export type ILineItemsDetailsTitle = {
  id: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
};

export type IMarket = {
  __typename?: 'Market';
  adjustedColi?: Maybe<Scalars['String']>;
  coli?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  region: IRegion;
  regionId?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  subsidized: Scalars['Int'];
};

export type IMarketMeta = {
  __typename?: 'MarketMeta';
  activeJobs: Scalars['Int'];
  completedJobs: Scalars['Int'];
  electricalPros: Scalars['Int'];
  enRouteJobs: Scalars['Int'];
  handymanPros: Scalars['Int'];
  hvacPros: Scalars['Int'];
  inProgressJobs: Scalars['Int'];
  onlinePros: Scalars['Int'];
  pausedJobs: Scalars['Int'];
  plumbingPros: Scalars['Int'];
  smartHomePros: Scalars['Int'];
  suspendedJobs: Scalars['Int'];
};

export type IMeasurementUnits = {
  __typename?: 'MeasurementUnits';
  count: Scalars['Int'];
  data: Array<Maybe<IMetadataItemGrade>>;
};

export type IMedia = {
  __typename?: 'Media';
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  thumbnailUrl: Scalars['String'];
  updatedAt: Scalars['Date'];
  url: Scalars['String'];
};

export type IMention = {
  __typename?: 'Mention';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type IMetadata = {
  __typename?: 'Metadata';
  actions?: Maybe<IMetadataItemActions>;
  id: Scalars['ID'];
  isNoteMandatory?: Maybe<Scalars['Boolean']>;
  measurementsUnitHint?: Maybe<Scalars['String']>;
  measurementsUnitId?: Maybe<Scalars['ID']>;
  measurementsUnitName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noteHint?: Maybe<Scalars['String']>;
};

export type IMetadataItemAction = {
  __typename?: 'MetadataItemAction';
  id: Scalars['ID'];
  name: Scalars['ID'];
  types: IMetadataItemTypes;
};

export type IMetadataItemActions = {
  __typename?: 'MetadataItemActions';
  count: Scalars['Int'];
  data: Array<Maybe<IMetadataItemAction>>;
};

export type IMetadataItemGrade = {
  __typename?: 'MetadataItemGrade';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IMetadataItemGrades = {
  __typename?: 'MetadataItemGrades';
  count: Scalars['Int'];
  data: Array<Maybe<IMetadataItemGrade>>;
};

export type IMetadataItemType = {
  __typename?: 'MetadataItemType';
  grades: IMetadataItemGrades;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IMetadataItemTypes = {
  __typename?: 'MetadataItemTypes';
  count: Scalars['Int'];
  data: Array<Maybe<IMetadataItemType>>;
};

export type IMutation = {
  __typename?: 'Mutation';
  checkTwilioVerificationCode: ICheckTwilioVerificationCodeResponse;
  companyUpdateAssignee: Scalars['String'];
  companyUpdateAvailability: Scalars['String'];
  companyUpdateCapacity: Scalars['String'];
  companyUpdateFlows: Scalars['String'];
  companyUpdateOrganization: Scalars['String'];
  companyUpdateStatus: Scalars['String'];
  createEstimate?: Maybe<IEstimate>;
  createEstimatePdf: IEstimatePdfReqConnection;
  createEstimateRevision: IEstimateRevision;
  createLineItem: IEstimateLineItem;
  createRoom: IEstimateRoom;
  createTwilioVerificationInstance: ICreateTwilioVerificationInstanceResponse;
  deleteEstimateRevision: Scalars['String'];
  deleteEstimateRevisionAttachment: Scalars['String'];
  deleteLineItem: Scalars['String'];
  deleteRoom: Scalars['String'];
  deleteRoomAttachment: Scalars['String'];
  emailJobMedia: Scalars['String'];
  emailProviderReceipt: Scalars['String'];
  submitEstimate: Scalars['String'];
  updateCompanyDetails: ICompanyV2;
  updateEstimate: IEstimate;
  updateEstimateRevision?: Maybe<IEstimateRevision>;
  updateLineItem: IEstimateLineItem;
  updateRoom: IEstimateRoom;
  uploadEstimateAttachment: IEstimateAttachmentUrlLink;
  uploadRoomAttachment: IEstimateAttachmentUrlLink;
};


export type IMutationCheckTwilioVerificationCodeArgs = {
  code: Scalars['String'];
  to: Scalars['String'];
};


export type IMutationCompanyUpdateAssigneeArgs = {
  assigneeId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};


export type IMutationCompanyUpdateAvailabilityArgs = {
  availability?: InputMaybe<CompanyAvailability>;
  companyId: Scalars['ID'];
};


export type IMutationCompanyUpdateCapacityArgs = {
  capacity?: InputMaybe<Scalars['Int']>;
  catCapacity?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['ID'];
};


export type IMutationCompanyUpdateFlowsArgs = {
  companyId: Scalars['ID'];
  flows: Array<CompanyFlowLabel>;
};


export type IMutationCompanyUpdateOrganizationArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  companyId: Scalars['ID'];
  operationType: OperationType;
  organizationId: Scalars['ID'];
  trained?: InputMaybe<Scalars['Boolean']>;
};


export type IMutationCompanyUpdateStatusArgs = {
  companyId: Scalars['ID'];
  status?: InputMaybe<CompanyStatus>;
};


export type IMutationCreateEstimateArgs = {
  claimId?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
};


export type IMutationCreateEstimatePdfArgs = {
  id: Scalars['ID'];
};


export type IMutationCreateEstimateRevisionArgs = {
  id: Scalars['ID'];
  revisionName?: InputMaybe<Scalars['String']>;
  revisionNumber?: InputMaybe<Scalars['Int']>;
};


export type IMutationCreateLineItemArgs = {
  reqBody: ILineItemBody;
  roomId: Scalars['ID'];
};


export type IMutationCreateRoomArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IMutationCreateTwilioVerificationInstanceArgs = {
  method?: InputMaybe<VerificationMethod>;
  to: Scalars['String'];
};


export type IMutationDeleteEstimateRevisionArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteEstimateRevisionAttachmentArgs = {
  attachmentId: Scalars['ID'];
  revisionId: Scalars['ID'];
};


export type IMutationDeleteLineItemArgs = {
  id: Scalars['ID'];
};


export type IMutationDeleteRoomArgs = {
  revisionId: Scalars['ID'];
  roomId: Scalars['ID'];
};


export type IMutationDeleteRoomAttachmentArgs = {
  attachmentId: Scalars['ID'];
  roomId: Scalars['ID'];
};


export type IMutationEmailJobMediaArgs = {
  jobId: Scalars['ID'];
};


export type IMutationEmailProviderReceiptArgs = {
  consolidatedJobId: Scalars['ID'];
  sendToInternal?: InputMaybe<Scalars['Boolean']>;
};


export type IMutationSubmitEstimateArgs = {
  revisionId: Scalars['ID'];
};


export type IMutationUpdateCompanyDetailsArgs = {
  companyId: Scalars['ID'];
  details?: InputMaybe<IUpdateCompanyDetails>;
};


export type IMutationUpdateEstimateArgs = {
  claimId?: InputMaybe<Scalars['ID']>;
  estimateId: Scalars['ID'];
  jobId?: InputMaybe<Scalars['ID']>;
};


export type IMutationUpdateEstimateRevisionArgs = {
  customerTotalCost?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  jobId?: InputMaybe<Scalars['ID']>;
  revisionName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EstimateStatus>;
  totalCalcType?: InputMaybe<EstimatePricingModel>;
  totalCost?: InputMaybe<Scalars['Float']>;
};


export type IMutationUpdateLineItemArgs = {
  id: Scalars['ID'];
  reqBody: ILineItemBody;
};


export type IMutationUpdateRoomArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  revisionId: Scalars['ID'];
  totalCost: Scalars['Float'];
};


export type IMutationUploadEstimateAttachmentArgs = {
  carrierName?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  id: Scalars['ID'];
  length: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
};


export type IMutationUploadRoomAttachmentArgs = {
  carrierName?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  id: Scalars['ID'];
  length: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
};

export enum NetworkType {
  InHouse = 'IN_HOUSE',
  Open = 'OPEN',
  Preferred = 'PREFERRED'
}

export type INode = {
  id: Scalars['ID'];
};

export type INote = {
  __typename?: 'Note';
  id: Scalars['ID'];
  note: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type INotification = {
  __typename?: 'Notification';
  actionUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  readAt?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['Date'];
  user: IUser;
  userId: Scalars['ID'];
};

export type INotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<INotification>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export enum OperationType {
  Add = 'ADD',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type IOrganization = {
  __typename?: 'Organization';
  createdAt: Scalars['Date'];
  flatRateEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  networkInhouse: Scalars['Boolean'];
  networkOpen: Scalars['Boolean'];
  networkPreferred: Scalars['Boolean'];
  quickbooksId?: Maybe<Scalars['ID']>;
  referralCodeId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['Int']>;
  stripeId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IOrganizationCompany = INode & {
  __typename?: 'OrganizationCompany';
  company: ICompany;
  companyId: Scalars['ID'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  network: NetworkType;
  organization: IOrganization;
  organizationId: Scalars['ID'];
  status: OrganizationCompanyStatus;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type IOrganizationCompanyConnection = IConnection & {
  __typename?: 'OrganizationCompanyConnection';
  edges: Array<IOrganizationCompany>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export enum OrganizationCompanyStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  LegacyActive = 'LEGACY_ACTIVE'
}

export type IOrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<IOrganization>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IPageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type IPropertyDefaults = {
  __typename?: 'PropertyDefaults';
  directBill: Scalars['Int'];
  limitMaterials: Scalars['Int'];
  limitTotal: Scalars['Int'];
  limitType: Scalars['Int'];
  notifyComplete: Scalars['Boolean'];
  notifyInitiate: Scalars['Boolean'];
  notifyRequest: Scalars['Boolean'];
  paymentId?: Maybe<Scalars['ID']>;
  rateAdjustment: Scalars['Int'];
  requiresApproval: Scalars['Boolean'];
  user: IUser;
  userId: Scalars['ID'];
};

export type IPropertyManager = {
  __typename?: 'PropertyManager';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mobile: Scalars['String'];
  properties: Array<IUserProperty>;
  user: IUser;
};

export type IPropertyManagerConnection = {
  __typename?: 'PropertyManagerConnection';
  edges: Array<IPropertyManager>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IPropertySettings = {
  __typename?: 'PropertySettings';
  createdAt: Scalars['Date'];
  limitLabor: Scalars['Int'];
  limitMaterials: Scalars['Int'];
  limitTotal: Scalars['Int'];
  limitType: Scalars['Int'];
  notifyComplete: Scalars['Boolean'];
  notifyInitiate: Scalars['Boolean'];
  notifyRequest: Scalars['Boolean'];
  paymentId?: Maybe<Scalars['ID']>;
  rateAdjustment: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<IUser>;
  userId?: Maybe<Scalars['ID']>;
};

export type IProvider = {
  __typename?: 'Provider';
  availability?: Maybe<IUserAvailability>;
  available: Scalars['Boolean'];
  averageRating: IUserAvgRating;
  company?: Maybe<ICompany>;
  id: Scalars['ID'];
  jobs: IJobConnection;
  /** Provider's location */
  location?: Maybe<IUserLocation>;
  user: IUser;
};


export type IProviderJobsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};

export type IProviderConnection = {
  __typename?: 'ProviderConnection';
  edges: Array<IUser>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IProviderReqConnection = {
  __typename?: 'ProviderReqConnection';
  edges: Array<IProviderRequest>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IProviderRequest = {
  __typename?: 'ProviderRequest';
  companyId?: Maybe<Scalars['ID']>;
  consumerFlatRate?: Maybe<Scalars['Float']>;
  consumerRateBase: Scalars['Float'];
  consumerRateHour: Scalars['Float'];
  consumerRequest: IConsumerRequest;
  consumerRequestId: Scalars['ID'];
  createdAt: Scalars['Date'];
  delay?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  job?: Maybe<IJob>;
  logs: Array<IProviderRequestLog>;
  partnerRateBase?: Maybe<Scalars['Float']>;
  partnerRateHour?: Maybe<Scalars['Float']>;
  provider: IUser;
  providerFlatRate?: Maybe<Scalars['Float']>;
  providerId: Scalars['ID'];
  providerRateBase: Scalars['Float'];
  providerRateHour: Scalars['Float'];
  serviceId: Scalars['ID'];
  /**
   * Status - readable label
   *
   * Use 'statusCode' for integer constant value
   */
  status: Scalars['Int'];
  /**
   * Status constant
   *
   * Use 'status' for readable label
   */
  statusCode: Scalars['Int'];
  subServiceId?: Maybe<Scalars['ID']>;
  subsidyFlatRate: Scalars['Float'];
  subsidyLevel: Scalars['Float'];
  subsidyRateBase: Scalars['Float'];
  subsidyRateHour: Scalars['Float'];
  updatedAt?: Maybe<Scalars['Date']>;
  userService: IUserService;
};

export type IProviderRequestLog = {
  __typename?: 'ProviderRequestLog';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  insertCounter: Scalars['Int'];
  providerRequest: IProviderRequest;
  providerRequestId: Scalars['ID'];
  statusNew: Scalars['Int'];
  statusOld: Scalars['Int'];
  user?: Maybe<IUser>;
  userId?: Maybe<Scalars['ID']>;
};

export type IQuery = {
  __typename?: 'Query';
  Badge?: Maybe<IBadge>;
  ConsumerRequestLog?: Maybe<IConsumerRequestLog>;
  ConsumerRequestLogs: Array<IConsumerRequestLog>;
  JobLimitExtension?: Maybe<IJobLimitExtension>;
  Organization?: Maybe<IOrganization>;
  ProviderRequestLog?: Maybe<IProviderRequestLog>;
  ProviderRequestLogs: Array<IProviderRequestLog>;
  UserBadge?: Maybe<IUserBadge>;
  UserOrganizations: Array<IOrganization>;
  generateTwilioCode: IGenerateTwilioCodeResponse;
  getChildCompanies: ICompaniesReqConnection;
  getComments?: Maybe<Array<Maybe<IComment>>>;
  getCompaniesV2: ICompaniesReqConnection;
  getCompany?: Maybe<ICompany>;
  getCompanyEmployees: Array<Maybe<ICompanyEmployee>>;
  getCompanyV2?: Maybe<ICompanyV2>;
  getConsumerRequest?: Maybe<IConsumerRequest>;
  getConsumerRequestNote?: Maybe<INote>;
  getConsumerRequests: IConsumerReqConnection;
  getConsumers: IConsumerConnection;
  getEstimate?: Maybe<IEstimate>;
  getEstimateAttachmentsDownload: Scalars['String'];
  getEstimateDownloadPackage: Scalars['String'];
  getEstimatePdf?: Maybe<IEstimatePdfLink>;
  getEstimateRevision?: Maybe<IEstimateRevision>;
  getEstimateRevisionAttachments: IEstimateAttachments;
  getEstimateRevisions: IEstimateRevisionReqConnection;
  getItemAction?: Maybe<IEstimateItemAction>;
  getItemActions?: Maybe<IEstimateItemActions>;
  getItemGrade?: Maybe<IEstimateItemAction>;
  getItemGrades?: Maybe<IEstimateItemGrades>;
  getItemTitle?: Maybe<IEstimateItemTitle>;
  getItemTitles?: Maybe<IEstimateItemTitles>;
  getItemType?: Maybe<IEstimateItemAction>;
  getItemTypes?: Maybe<IEstimateItemTypes>;
  getJob?: Maybe<IJob>;
  getJobInvoice?: Maybe<IJobInvoice>;
  getJobLock?: Maybe<IJobLock>;
  getJobLog?: Maybe<IJobLog>;
  getJobLogs: Array<IJobLog>;
  /** Get note for job - Note: this will be deprecated once job_notes is implemented */
  getJobNote?: Maybe<INote>;
  getJobs: IJobConnection;
  getMarket?: Maybe<IMarket>;
  getMarkets: Array<IMarket>;
  getMatchingCompanyV2?: Maybe<ICompanyV2>;
  getMeasurementUnits?: Maybe<IMeasurementUnits>;
  getMetadata: Array<Maybe<IMetadata>>;
  getOrganizations: IOrganizationConnection;
  getPhoneType: IGetPhoneTypeResponse;
  getPropertyDefaults?: Maybe<IPropertyDefaults>;
  getPropertyManagers: IPropertyManagerConnection;
  getPropertySettings?: Maybe<IPropertySettings>;
  getProvider?: Maybe<IProvider>;
  getProviderRequest?: Maybe<IProviderRequest>;
  getProviderRequests: IProviderReqConnection;
  getProviders: IProviderConnection;
  getRegion?: Maybe<IRegion>;
  getRegions: Array<IRegion>;
  getRoomAttachmentDownload: IEstimatePdfLink;
  getRoomAttachments?: Maybe<IEstimateAttachments>;
  getRooms?: Maybe<IEstimateRooms>;
  getUser?: Maybe<IUser>;
  getUserCompanies: Array<Maybe<ICompanyV2>>;
  getUserLocation?: Maybe<IUserLocation>;
  getUserProfile?: Maybe<IUserProfile>;
  /** @deprecated use userProperties query */
  getUserProperties: Array<IUserProperty>;
  getWorkbenchList: IWorkbenchItemConnection;
  getWorkorder?: Maybe<IWorkorder>;
  getWorkorderAttachment?: Maybe<IWorkorderAttachment>;
  getWorkorderAttachments: Array<Maybe<IWorkorderAttachment>>;
  getWorkorderConsumerRequest?: Maybe<IWorkorderConsumerRequest>;
  getWorkorderConsumerRequests: IWorkorderConsumerRequestConnection;
  getWorkorderJob?: Maybe<IWorkorderJob>;
  getWorkorderJobs: IWorkorderJobConnection;
  getWorkorderNote?: Maybe<INote>;
  getWorkorders: IWorkorderConnection;
  getZipGeo?: Maybe<IZipGeo>;
  jobEstimate: IJobEstimate;
  marketMeta: IMarketMeta;
  /** Returns User from database with apiKey matching authorization header */
  me: IUser;
  mentions: Array<IMention>;
  notifications: INotificationConnection;
  organizationCompanies: IOrganizationCompanyConnection;
  service?: Maybe<IService>;
  serviceLicenseJurisdictions: Array<IServiceLicenseJurisdiction>;
  serviceRequestTypes: Array<IServiceRequestType>;
  services: Array<Maybe<IService>>;
  userPermissions: Array<Scalars['Int']>;
  userProperties: Array<IUserProperty>;
  userServices: Array<IUserService>;
  users: IUserConnection;
};


export type IQueryBadgeArgs = {
  id: Scalars['ID'];
};


export type IQueryConsumerRequestLogArgs = {
  id: Scalars['ID'];
};


export type IQueryConsumerRequestLogsArgs = {
  id: Scalars['ID'];
};


export type IQueryJobLimitExtensionArgs = {
  id: Scalars['ID'];
};


export type IQueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type IQueryProviderRequestLogArgs = {
  id: Scalars['ID'];
};


export type IQueryProviderRequestLogsArgs = {
  id: Scalars['ID'];
};


export type IQueryUserBadgeArgs = {
  id: Scalars['ID'];
};


export type IQueryUserOrganizationsArgs = {
  userId: Scalars['ID'];
};


export type IQueryGenerateTwilioCodeArgs = {
  phoneNumber: Scalars['String'];
};


export type IQueryGetChildCompaniesArgs = {
  id: Scalars['ID'];
};


export type IQueryGetCommentsArgs = {
  commentThreadId: Scalars['ID'];
};


export type IQueryGetCompaniesV2Args = {
  availability?: InputMaybe<CompanyAvailability>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  flows?: InputMaybe<Array<InputMaybe<CompanyFlowLabel>>>;
  hasSymbilityId?: InputMaybe<Scalars['Boolean']>;
  hasXactimateAddress?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CompanyOrderByType>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  services?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<CompanyStatus>;
};


export type IQueryGetCompanyArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetCompanyEmployeesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetCompanyV2Args = {
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetConsumerRequestArgs = {
  code?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetConsumerRequestNoteArgs = {
  consumerRequestId: Scalars['ID'];
};


export type IQueryGetConsumerRequestsArgs = {
  appointmentDateEnd?: InputMaybe<Scalars['String']>;
  appointmentDateStart?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<WorkbenchBucket>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  consumerId?: InputMaybe<Scalars['ID']>;
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  internalAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  jobOrigin?: InputMaybe<JobOrigin>;
  marketId?: InputMaybe<Scalars['ID']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']>>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  priority?: InputMaybe<Scalars['Int']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<Scalars['Int']>>;
  subBuckets?: InputMaybe<Array<SubBucket>>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
  vendors?: InputMaybe<Array<Scalars['Int']>>;
};


export type IQueryGetConsumersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['ID']>;
  organizationId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetEstimateArgs = {
  claimId?: InputMaybe<Scalars['ID']>;
  jobId?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetEstimateAttachmentsDownloadArgs = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type IQueryGetEstimateDownloadPackageArgs = {
  attachmentPackId: Scalars['ID'];
  downloadType: EstimateDownloadType;
};


export type IQueryGetEstimatePdfArgs = {
  id: Scalars['ID'];
  pdfType?: InputMaybe<EstimateRevisionDocumentType>;
};


export type IQueryGetEstimateRevisionArgs = {
  id: Scalars['ID'];
};


export type IQueryGetEstimateRevisionAttachmentsArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetEstimateRevisionsArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  sort?: InputMaybe<Scalars['String']>;
};


export type IQueryGetItemActionArgs = {
  id: Scalars['ID'];
};


export type IQueryGetItemActionsArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetItemGradeArgs = {
  id: Scalars['ID'];
};


export type IQueryGetItemGradesArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetItemTitleArgs = {
  id: Scalars['ID'];
};


export type IQueryGetItemTitlesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
};


export type IQueryGetItemTypeArgs = {
  id: Scalars['ID'];
};


export type IQueryGetItemTypesArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetJobArgs = {
  code?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type IQueryGetJobInvoiceArgs = {
  jobId: Scalars['ID'];
};


export type IQueryGetJobLockArgs = {
  jobId: Scalars['ID'];
};


export type IQueryGetJobLogArgs = {
  id: Scalars['ID'];
};


export type IQueryGetJobLogsArgs = {
  jobId: Scalars['ID'];
};


export type IQueryGetJobNoteArgs = {
  jobId: Scalars['ID'];
};


export type IQueryGetJobsArgs = {
  address?: InputMaybe<Scalars['String']>;
  appointmentDateEnd?: InputMaybe<Scalars['String']>;
  appointmentDateStart?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<WorkbenchBucket>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  completedDateEnd?: InputMaybe<Scalars['String']>;
  completedDateStart?: InputMaybe<Scalars['String']>;
  consolidatedJobIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  consumerId?: InputMaybe<Scalars['ID']>;
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  estimateStatuses?: InputMaybe<Array<JobEstimateStatus>>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  internalAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  jobOrigin?: InputMaybe<JobOrigin>;
  laborCostMax?: InputMaybe<Scalars['Float']>;
  laborCostMin?: InputMaybe<Scalars['Float']>;
  marketId?: InputMaybe<Scalars['ID']>;
  materialCostMax?: InputMaybe<Scalars['Float']>;
  materialCostMin?: InputMaybe<Scalars['Float']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']>>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  organizationProperties?: InputMaybe<Array<Scalars['String']>>;
  priority?: InputMaybe<Scalars['Int']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<Scalars['Int']>>;
  subBuckets?: InputMaybe<Array<SubBucket>>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
  totalCostMax?: InputMaybe<Scalars['Float']>;
  totalCostMin?: InputMaybe<Scalars['Float']>;
  vendors?: InputMaybe<Array<Scalars['Int']>>;
};


export type IQueryGetMarketArgs = {
  id: Scalars['ID'];
};


export type IQueryGetMarketsArgs = {
  regionId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<Scalars['Int']>>;
};


export type IQueryGetMatchingCompanyV2Args = {
  flow?: InputMaybe<CompanyFlowLabel>;
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  serviceId: Scalars['String'];
};


export type IQueryGetOrganizationsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetPhoneTypeArgs = {
  phoneNumber: Scalars['String'];
};


export type IQueryGetPropertyDefaultsArgs = {
  userId: Scalars['ID'];
};


export type IQueryGetPropertyManagersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  nameStartsWith?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetPropertySettingsArgs = {
  propertyId: Scalars['ID'];
};


export type IQueryGetProviderArgs = {
  id: Scalars['ID'];
};


export type IQueryGetProviderRequestArgs = {
  id: Scalars['ID'];
};


export type IQueryGetProviderRequestsArgs = {
  consumerRequestId?: InputMaybe<Scalars['ID']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['ID']>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<Scalars['Int']>>;
};


export type IQueryGetProvidersArgs = {
  available?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  marketId?: InputMaybe<Scalars['ID']>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetRegionArgs = {
  id: Scalars['ID'];
};


export type IQueryGetRoomAttachmentDownloadArgs = {
  attachmentId: Scalars['ID'];
  roomId: Scalars['ID'];
};


export type IQueryGetRoomAttachmentsArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetRoomsArgs = {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type IQueryGetUserArgs = {
  id: Scalars['ID'];
};


export type IQueryGetUserCompaniesArgs = {
  id: Scalars['ID'];
};


export type IQueryGetUserLocationArgs = {
  userId: Scalars['ID'];
};


export type IQueryGetUserProfileArgs = {
  id: Scalars['ID'];
};


export type IQueryGetUserPropertiesArgs = {
  propertyTypes?: InputMaybe<Array<Scalars['Int']>>;
  userId: Scalars['ID'];
};


export type IQueryGetWorkbenchListArgs = {
  appointmentDateEnd?: InputMaybe<Scalars['String']>;
  appointmentDateStart?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<WorkbenchBucket>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  completedDateEnd?: InputMaybe<Scalars['String']>;
  completedDateStart?: InputMaybe<Scalars['String']>;
  consumerId?: InputMaybe<Scalars['ID']>;
  consumerRequestStatuses?: InputMaybe<Array<Scalars['Int']>>;
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  estimateStatuses?: InputMaybe<Array<JobEstimateStatus>>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  internalAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  jobOrigin?: InputMaybe<JobOrigin>;
  jobStatuses?: InputMaybe<Array<Scalars['Int']>>;
  laborCostMax?: InputMaybe<Scalars['Float']>;
  laborCostMin?: InputMaybe<Scalars['Float']>;
  marketId?: InputMaybe<Scalars['ID']>;
  materialCostMax?: InputMaybe<Scalars['Float']>;
  materialCostMin?: InputMaybe<Scalars['Float']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']>>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  priority?: InputMaybe<Scalars['Int']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  subBuckets?: InputMaybe<Array<SubBucket>>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
  totalCostMax?: InputMaybe<Scalars['Float']>;
  totalCostMin?: InputMaybe<Scalars['Float']>;
  vendors?: InputMaybe<Array<Scalars['Int']>>;
  workorderStatuses?: InputMaybe<Array<Scalars['Int']>>;
};


export type IQueryGetWorkorderArgs = {
  id: Scalars['ID'];
};


export type IQueryGetWorkorderAttachmentArgs = {
  id: Scalars['ID'];
};


export type IQueryGetWorkorderAttachmentsArgs = {
  workorderId: Scalars['ID'];
};


export type IQueryGetWorkorderConsumerRequestArgs = {
  id: Scalars['ID'];
};


export type IQueryGetWorkorderConsumerRequestsArgs = {
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']>>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetWorkorderJobArgs = {
  id: Scalars['ID'];
};


export type IQueryGetWorkorderJobsArgs = {
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryGetWorkorderNoteArgs = {
  workorderId: Scalars['ID'];
};


export type IQueryGetWorkordersArgs = {
  appointmentDateEnd?: InputMaybe<Scalars['String']>;
  appointmentDateStart?: InputMaybe<Scalars['String']>;
  bucket?: InputMaybe<WorkbenchBucket>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  internalAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  marketId?: InputMaybe<Scalars['ID']>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  priority?: InputMaybe<Scalars['Int']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  statusCodes?: InputMaybe<Array<Scalars['Int']>>;
  subBuckets?: InputMaybe<Array<SubBucket>>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
};


export type IQueryGetZipGeoArgs = {
  zipCode: Scalars['String'];
};


export type IQueryJobEstimateArgs = {
  where: IJobEstimateInputWhere;
};


export type IQueryMarketMetaArgs = {
  id: Scalars['ID'];
};


export type IQueryMentionsArgs = {
  roles: Array<UserRoles>;
};


export type IQueryNotificationsArgs = {
  first?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};


export type IQueryOrganizationCompaniesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<OrganizationCompanyStatus>>;
};


export type IQueryServiceArgs = {
  id: Scalars['ID'];
};


export type IQueryServiceLicenseJurisdictionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type IQueryServicesArgs = {
  serviceUserType: ServiceUserType;
};


export type IQueryUserPermissionsArgs = {
  userId: Scalars['ID'];
};


export type IQueryUserPropertiesArgs = {
  propertyTypes?: InputMaybe<Array<Scalars['Int']>>;
  userId: Scalars['ID'];
};


export type IQueryUserServicesArgs = {
  providerId: Scalars['ID'];
};


export type IQueryUsersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<UserRole>>;
  sortOrder?: InputMaybe<SortOrder>;
  startAfter?: InputMaybe<Scalars['String']>;
};

export type IRegion = {
  __typename?: 'Region';
  id: Scalars['ID'];
  markets: Array<IMarket>;
  name: Scalars['String'];
};

export enum RevisionStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Suggested = 'SUGGESTED'
}

export type ISendCodeAttempt = {
  __typename?: 'SendCodeAttempt';
  channel: Scalars['String'];
  time: Scalars['String'];
};

export type IService = {
  __typename?: 'Service';
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  legacyId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  parentService?: Maybe<IService>;
  serviceUserType: ServiceUserType;
  subservices: Array<IService>;
  updatedAt: Scalars['Date'];
};

export type IServiceLicense = {
  __typename?: 'ServiceLicense';
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  license: Scalars['String'];
};

export type IServiceLicenseJurisdiction = {
  __typename?: 'ServiceLicenseJurisdiction';
  /** Flag that indicates if jursidiction is currently supported */
  active: Scalars['Boolean'];
  /** ANSI code used to identify geographic location - i.e. HI */
  ansiCode: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  /** Human-readable name of jurisdiction - i.e. Hawaii */
  label: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type IServiceRequestType = {
  __typename?: 'ServiceRequestType';
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export enum ServiceUserType {
  Consumer = 'consumer',
  Provider = 'provider'
}

export type ISiteAccessNote = {
  __typename?: 'SiteAccessNote';
  id: Scalars['ID'];
  note: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum SortOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

export enum State {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type IStripeJobInvoice = {
  __typename?: 'StripeJobInvoice';
  createdAt: Scalars['Date'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: Maybe<IJob>;
  jobId?: Maybe<Scalars['ID']>;
  organization: IOrganization;
  organizationId: Scalars['ID'];
  quickbookInvoiceNumber: Scalars['String'];
  status: Scalars['Int'];
  stripeHostedInvoiceUrl?: Maybe<Scalars['String']>;
  stripeInvoiceId?: Maybe<Scalars['String']>;
  stripeInvoiceNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum SubBucket {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Completing = 'completing',
  Draft = 'draft',
  EnRoute = 'en_route',
  InProgress = 'in_progress',
  Integrations = 'integrations',
  ManualAssign = 'manual_assign',
  NeedsAssignment = 'needs_assignment',
  OnSite = 'on_site',
  Paused = 'paused',
  PmApproval = 'pm_approval',
  Queued = 'queued',
  Rejected = 'rejected',
  Requested = 'requested',
  Scheduled = 'scheduled',
  ScheduledUpcoming = 'scheduled_upcoming',
  Suspended = 'suspended',
  Terminating = 'terminating',
  TimedOut = 'timed_out'
}

export type ITaxationNumber = {
  __typename?: 'TaxationNumber';
  administrativeArea?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  taxationNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum TimeUnitInternalName {
  Hours = 'HOURS',
  Minutes = 'MINUTES'
}

export enum TransferStatus {
  Failed = 'failed',
  Reversed = 'reversed',
  Skipped = 'skipped',
  Succeeded = 'succeeded'
}

export type IUpdateCompanyDetails = {
  addresses?: InputMaybe<ICompanyAddressesInput>;
  availability?: InputMaybe<CompanyAvailability>;
  averageRating?: InputMaybe<Scalars['String']>;
  capacity?: InputMaybe<Scalars['Int']>;
  catCapacity?: InputMaybe<Scalars['Int']>;
  dbaName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  flows?: InputMaybe<Array<InputMaybe<CompanyFlowLabel>>>;
  founded?: InputMaybe<Scalars['Int']>;
  hubspotId?: InputMaybe<Scalars['ID']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ownerUserIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  parentId?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberAfterHours?: InputMaybe<Scalars['String']>;
  pointOfContactUserId?: InputMaybe<Scalars['ID']>;
  preferEmailCommunication?: InputMaybe<Scalars['Boolean']>;
  preferSmsCommunication?: InputMaybe<Scalars['Boolean']>;
  symbilityId?: InputMaybe<Scalars['ID']>;
  website?: InputMaybe<Scalars['String']>;
  xactimateAddress?: InputMaybe<Scalars['String']>;
  xactimateVersion?: InputMaybe<Scalars['String']>;
};

export type IUser = {
  __typename?: 'User';
  /** Only visible if User apiKey matches Authorization header or authorized user has 'internal' role */
  apiKey?: Maybe<Scalars['String']>;
  availability?: Maybe<IUserAvailability>;
  averageRating: IUserAvgRating;
  companies: Array<ICompany>;
  createdAt?: Maybe<Scalars['Date']>;
  customMaterialsFee?: Maybe<Scalars['Float']>;
  email: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  hasHdBadge: Scalars['Boolean'];
  hubspotId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isGhost: Scalars['Boolean'];
  isInsured: Scalars['Boolean'];
  isInvoicable: Scalars['Boolean'];
  isProfileGorilla: Scalars['Boolean'];
  isTest: Scalars['Boolean'];
  jobCount: Scalars['Int'];
  location?: Maybe<IUserLocation>;
  registrationStatus?: Maybe<Scalars['Int']>;
  status: Scalars['Int'];
  stripeAccountId?: Maybe<Scalars['ID']>;
  stripeCustomerId?: Maybe<Scalars['ID']>;
  taxationNumbers: Array<ITaxationNumber>;
  updatedAt?: Maybe<Scalars['Date']>;
  userBadges: Array<IUserBadge>;
  userLegalEntity?: Maybe<IUserLegalEntity>;
  userMarket?: Maybe<IUserMarket>;
  userPreferences?: Maybe<IUserPreferences>;
  userProfile?: Maybe<IUserProfile>;
  userServices: Array<IUserService>;
  verified: Scalars['Int'];
};

export type IUserAvailability = {
  __typename?: 'UserAvailability';
  available: Scalars['Boolean'];
  companyId?: Maybe<Scalars['ID']>;
  groupId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['Date'];
  userId: Scalars['ID'];
};

export type IUserAvgRating = {
  __typename?: 'UserAvgRating';
  /** Total number of ratings */
  count: Scalars['Int'];
  /** Average rating (1 - 5) */
  rating: Scalars['Float'];
};

export type IUserBadge = {
  __typename?: 'UserBadge';
  badge?: Maybe<IBadge>;
  badgeId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<IUser>;
  userId?: Maybe<Scalars['ID']>;
};

export type IUserBase = {
  userId?: Maybe<Scalars['ID']>;
};

export type IUserConnection = {
  __typename?: 'UserConnection';
  edges: Array<IUser>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IUserLegalEntity = {
  __typename?: 'UserLegalEntity';
  dobDay?: Maybe<Scalars['Int']>;
  dobMonth?: Maybe<Scalars['Int']>;
  dobYear?: Maybe<Scalars['Int']>;
};

export type IUserLocation = {
  __typename?: 'UserLocation';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  updatedAt: Scalars['Date'];
  userId: Scalars['ID'];
};

export type IUserLoginResponse = {
  __typename?: 'UserLoginResponse';
  token: Scalars['String'];
  user: IUser;
};

export type IUserMarket = {
  __typename?: 'UserMarket';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type IUserPreferences = {
  __typename?: 'UserPreferences';
  createdAt: Scalars['Date'];
  language: Language;
  marketingEmailPreference: Scalars['Boolean'];
  marketingPushPreference: Scalars['Boolean'];
  marketingSmsPreference: Scalars['Boolean'];
  updatedAt: Scalars['Date'];
  user: IUser;
  userId: Scalars['ID'];
};

export type IUserProfile = {
  __typename?: 'UserProfile';
  company?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  ecobeeBadge?: Maybe<Scalars['Int']>;
  fergusonBadge?: Maybe<Scalars['Int']>;
  firstName: Scalars['String'];
  hdBadge?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  lotSize?: Maybe<Scalars['Float']>;
  mobile: Scalars['String'];
  referralCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userId: Scalars['ID'];
  veteran: Scalars['Int'];
  veteranBranch?: Maybe<Scalars['Int']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type IUserProperty = {
  __typename?: 'UserProperty';
  address: Scalars['String'];
  class: Scalars['Int'];
  code: Scalars['String'];
  codeNumber: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use latitude */
  lat: Scalars['Float'];
  latitude: Scalars['Float'];
  /** @deprecated Use longitude */
  lng: Scalars['Float'];
  longitude: Scalars['Float'];
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  residentCount: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  unit?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user: IUser;
  userId: Scalars['ID'];
  zipCode?: Maybe<Scalars['String']>;
};

export type IUserRegistrationResponse = {
  __typename?: 'UserRegistrationResponse';
  token: Scalars['String'];
  user: IUser;
};

export enum UserRole {
  Consumer = 'consumer',
  Internal = 'internal',
  Provider = 'provider'
}

export enum UserRoles {
  Consumer = 'Consumer',
  Internal = 'Internal',
  Provider = 'Provider'
}

/** A single service offered by user */
export type IUserService = {
  __typename?: 'UserService';
  experience: Scalars['Int'];
  id: Scalars['ID'];
  legacyService: Scalars['Int'];
  /** @deprecated Replaced by serviceLicenses */
  license?: Maybe<Scalars['String']>;
  service: IService;
  serviceLicenses: Array<IServiceLicense>;
  startYear?: Maybe<Scalars['Int']>;
  status: Scalars['Int'];
  subUserServices: Array<IUserService>;
  /** @deprecated Replaced by legacyService */
  type: Scalars['Int'];
};

export enum VerificationMethod {
  Call = 'CALL',
  Sms = 'SMS'
}

export enum VeteranBranch {
  AirForce = 'air_force',
  Army = 'army',
  CoastGuard = 'coast_guard',
  MarineCorps = 'marine_corps',
  Navy = 'navy'
}

export enum WorkbenchBucket {
  Active = 'active',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Drafts = 'drafts',
  NeedsApproval = 'needs_approval',
  NeedsAssignment = 'needs_assignment',
  Queued = 'queued',
  Rejected = 'rejected',
  Requests = 'requests',
  Suspended = 'suspended',
  Upcoming = 'upcoming'
}

export type IWorkbenchItem = {
  address?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['Date']>;
  assignedCompanyId?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  bucketLabel?: Maybe<Scalars['String']>;
  commentThreadId?: Maybe<Scalars['ID']>;
  company?: Maybe<ICompanyV2>;
  consolidatedJobId: Scalars['ID'];
  consumer: IUser;
  consumerId: Scalars['ID'];
  consumerName?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  /** Indicates if authorized user is subscribed to notifications for this workbench item */
  following: Scalars['Boolean'];
  id: Scalars['ID'];
  internalAssignee?: Maybe<IContactInfo>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  media: Array<IMedia>;
  note?: Maybe<INote>;
  organization?: Maybe<IOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['Int']>;
  property?: Maybe<IUserProperty>;
  propertyId?: Maybe<Scalars['ID']>;
  providerName?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  requestNote?: Maybe<INote>;
  scheduledDate?: Maybe<Scalars['Date']>;
  scheduledDateTimezone?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceRequestType?: Maybe<IServiceRequestType>;
  serviceType?: Maybe<Scalars['Int']>;
  serviceTypeLabel?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  statusDescription: Scalars['String'];
  subBucket?: Maybe<Scalars['String']>;
  subBucketColor: Scalars['String'];
  subBucketLabel?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type IWorkbenchItemConnection = {
  __typename?: 'WorkbenchItemConnection';
  edges: Array<IWorkbenchItem>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IWorkorder = IWorkbenchItem & {
  __typename?: 'Workorder';
  address?: Maybe<Scalars['String']>;
  appointmentDate?: Maybe<Scalars['Date']>;
  assignedCompanyId?: Maybe<Scalars['String']>;
  attachments: Array<IWorkorderAttachment>;
  bucket?: Maybe<Scalars['String']>;
  bucketLabel?: Maybe<Scalars['String']>;
  claims?: Maybe<Array<Maybe<IClaim>>>;
  commentThreadId?: Maybe<Scalars['ID']>;
  company?: Maybe<ICompanyV2>;
  consolidatedJobId: Scalars['ID'];
  consumer: IUser;
  consumerId: Scalars['ID'];
  consumerName?: Maybe<Scalars['String']>;
  consumerRequestId?: Maybe<Scalars['ID']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  /** @deprecated Replaced by referenceNumber */
  externalId?: Maybe<Scalars['ID']>;
  /** Indicates if authorized user is subscribed to notifications for this work order */
  following: Scalars['Boolean'];
  id: Scalars['ID'];
  /** @deprecated 4-22-2020 Use media instead */
  images: Array<IMedia>;
  integrationOrganizationId?: Maybe<Scalars['String']>;
  integrationOrganizationName?: Maybe<Scalars['String']>;
  internalAssignee?: Maybe<IContactInfo>;
  jobId?: Maybe<Scalars['ID']>;
  lat: Scalars['Float'];
  limitTotal?: Maybe<Scalars['Int']>;
  lng: Scalars['Float'];
  market?: Maybe<IMarket>;
  marketId?: Maybe<Scalars['ID']>;
  media: Array<IMedia>;
  name?: Maybe<Scalars['String']>;
  /** @deprecated Use requestNote */
  note?: Maybe<INote>;
  notifyResident: Scalars['Boolean'];
  occupied: Scalars['Boolean'];
  organization?: Maybe<IOrganization>;
  organizationId?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['Int']>;
  property?: Maybe<IUserProperty>;
  propertyId?: Maybe<Scalars['ID']>;
  providerName?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  requestNote?: Maybe<INote>;
  residentMobile?: Maybe<Scalars['String']>;
  residentName?: Maybe<Scalars['String']>;
  scheduledDate?: Maybe<Scalars['Date']>;
  scheduledDateTimezone?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceRequestType?: Maybe<IServiceRequestType>;
  serviceType?: Maybe<Scalars['Int']>;
  serviceTypeLabel?: Maybe<Scalars['String']>;
  state?: Maybe<State>;
  status: Scalars['Int'];
  statusDescription: Scalars['String'];
  subBucket?: Maybe<Scalars['String']>;
  subBucketColor: Scalars['String'];
  subBucketLabel?: Maybe<Scalars['String']>;
  /** @deprecated Use serviceRequestType */
  type?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  workorderConsumerRequest?: Maybe<IWorkorderConsumerRequest>;
  workorderJob?: Maybe<IWorkorderJob>;
  zipcode?: Maybe<Scalars['String']>;
};

export type IWorkorderAttachment = {
  __typename?: 'WorkorderAttachment';
  contentType: Scalars['String'];
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  url: Scalars['String'];
  workorder: IWorkorder;
  workorderId: Scalars['ID'];
};

export type IWorkorderConnection = {
  __typename?: 'WorkorderConnection';
  edges: Array<IWorkorder>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IWorkorderConsumerRequest = {
  __typename?: 'WorkorderConsumerRequest';
  createdAt: Scalars['Date'];
  diagnostic: Scalars['Int'];
  experienceMax: Scalars['Int'];
  experienceMin: Scalars['Int'];
  id: Scalars['ID'];
  installationOrderId?: Maybe<Scalars['ID']>;
  installationVendor?: Maybe<Scalars['Int']>;
  licensed: Scalars['Boolean'];
  networkType?: Maybe<Scalars['Int']>;
  releaseDate?: Maybe<Scalars['Date']>;
  serviceType?: Maybe<Scalars['Int']>;
  status: Scalars['Int'];
  subServiceBrand?: Maybe<Scalars['String']>;
  subServiceType?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  workorder: IWorkorder;
  workorderId: Scalars['ID'];
};

export type IWorkorderConsumerRequestConnection = {
  __typename?: 'WorkorderConsumerRequestConnection';
  edges: Array<IWorkorderConsumerRequest>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IWorkorderJob = {
  __typename?: 'WorkorderJob';
  /** @deprecated 6-18-2020 won't in use any more */
  assignReason?: Maybe<Scalars['String']>;
  company?: Maybe<ICompany>;
  companyId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  partnerRateBase?: Maybe<Scalars['Float']>;
  partnerRateHour?: Maybe<Scalars['Float']>;
  provider?: Maybe<IUser>;
  providerId?: Maybe<Scalars['ID']>;
  serviceId?: Maybe<Scalars['ID']>;
  serviceType?: Maybe<Scalars['Int']>;
  status: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
  userService?: Maybe<IUserService>;
  workorder: IWorkorder;
  workorderId: Scalars['ID'];
};

export type IWorkorderJobConnection = {
  __typename?: 'WorkorderJobConnection';
  edges: Array<IWorkorderJob>;
  pageInfo: IPageInfo;
  totalCount: Scalars['Int'];
};

export type IZipGeo = {
  __typename?: 'ZipGeo';
  dst?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
  tzName?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type ICheckTwilioVerificationCodeMutationVariables = Exact<{
  to: Scalars['String'];
  code: Scalars['String'];
}>;


export type ICheckTwilioVerificationCodeMutation = { __typename?: 'Mutation', checkTwilioVerificationCode: { __typename?: 'CheckTwilioVerificationCodeResponse', status: string } };

export type ICompanyUpdateAssigneeMutationVariables = Exact<{
  companyId: Scalars['ID'];
  assignee?: InputMaybe<Scalars['String']>;
}>;


export type ICompanyUpdateAssigneeMutation = { __typename?: 'Mutation', companyUpdateAssignee: string };

export type ICompanyUpdateAvailabilityMutationVariables = Exact<{
  id: Scalars['ID'];
  availability?: InputMaybe<CompanyAvailability>;
}>;


export type ICompanyUpdateAvailabilityMutation = { __typename?: 'Mutation', companyUpdateAvailability: string };

export type ICompanyUpdateCapacityMutationVariables = Exact<{
  companyId: Scalars['ID'];
  capacity?: InputMaybe<Scalars['Int']>;
  catCapacity?: InputMaybe<Scalars['Int']>;
}>;


export type ICompanyUpdateCapacityMutation = { __typename?: 'Mutation', companyUpdateCapacity: string };

export type ICompanyUpdateFlowsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  flows: Array<CompanyFlowLabel> | CompanyFlowLabel;
}>;


export type ICompanyUpdateFlowsMutation = { __typename?: 'Mutation', companyUpdateFlows: string };

export type ICompanyUpdateOrgsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  organizationId: Scalars['ID'];
  trained?: InputMaybe<Scalars['Boolean']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  operationType: OperationType;
}>;


export type ICompanyUpdateOrgsMutation = { __typename?: 'Mutation', companyUpdateOrganization: string };

export type ICompanyUpdateStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: InputMaybe<CompanyStatus>;
}>;


export type ICompanyUpdateStatusMutation = { __typename?: 'Mutation', companyUpdateStatus: string };

export type ICreateEstimateMutationVariables = Exact<{
  jobId: Scalars['ID'];
  claimId?: InputMaybe<Scalars['ID']>;
}>;


export type ICreateEstimateMutation = { __typename?: 'Mutation', createEstimate?: { __typename?: 'Estimate', id: string, jobId?: string | null, status?: EstimateStatus | null, claimId?: string | null, revision?: { __typename?: 'EstimateRevision', id: string, revisionNumber?: number | null, revisionName?: string | null, totalCost?: number | null, totalCalcType?: EstimatePricingModel | null, customerTotalCost?: number | null, status: EstimateStatus, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, rooms: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, revisionId: string, totalCost?: number | null, name?: string | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> }, lineItems?: { __typename?: 'EstimateLineItems', count: number, items: Array<{ __typename?: 'EstimateLineItem', id: string, roomId: string, quantity?: number | null, totalCost?: number | null, measurementUnit?: string | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } | null> } | null } | null> } } | null } | null };

export type ICreateEstimateLineItemMutationVariables = Exact<{
  roomId: Scalars['ID'];
  reqBody: ILineItemBody;
}>;


export type ICreateEstimateLineItemMutation = { __typename?: 'Mutation', createLineItem: { __typename?: 'EstimateLineItem', id: string, roomId: string, quantity?: number | null, totalCost?: number | null, measurementUnit?: string | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } };

export type ICreateEstimatePdfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ICreateEstimatePdfMutation = { __typename?: 'Mutation', createEstimatePdf: { __typename?: 'EstimatePdfReqConnection', types: Array<{ __typename?: 'EstimatePdf', status?: EstimateAttachmentStatus | null, type?: EstimateRevisionDocumentType | null } | null> } };

export type ICreateEstimateRevisionMutationVariables = Exact<{
  id: Scalars['ID'];
  revisionName?: InputMaybe<Scalars['String']>;
  revisionNumber?: InputMaybe<Scalars['Int']>;
}>;


export type ICreateEstimateRevisionMutation = { __typename?: 'Mutation', createEstimateRevision: { __typename?: 'EstimateRevision', id: string, revisionNumber?: number | null, revisionName?: string | null, totalCost?: number | null, totalCalcType?: EstimatePricingModel | null, customerTotalCost?: number | null, status: EstimateStatus, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, rooms: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, revisionId: string, totalCost?: number | null, name?: string | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> }, lineItems?: { __typename?: 'EstimateLineItems', count: number, items: Array<{ __typename?: 'EstimateLineItem', id: string, roomId: string, measurementUnit?: string | null, quantity?: number | null, totalCost?: number | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } | null> } | null } | null> } } };

export type ICreateEstimateRoomMutationVariables = Exact<{
  revisionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type ICreateEstimateRoomMutation = { __typename?: 'Mutation', createRoom: { __typename?: 'EstimateRoom', id: string, name?: string | null, totalCost?: number | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } } };

export type ICreateTwilioVerificationServiceMutationVariables = Exact<{
  to: Scalars['String'];
  method?: InputMaybe<VerificationMethod>;
}>;


export type ICreateTwilioVerificationServiceMutation = { __typename?: 'Mutation', createTwilioVerificationInstance: { __typename?: 'CreateTwilioVerificationInstanceResponse', status: string } };

export type IDeleteEstimateAttachmentMutationVariables = Exact<{
  revisionId: Scalars['ID'];
  attachmentId: Scalars['ID'];
}>;


export type IDeleteEstimateAttachmentMutation = { __typename?: 'Mutation', deleteEstimateRevisionAttachment: string };

export type IDeleteEstimateLineItemMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
}>;


export type IDeleteEstimateLineItemMutation = { __typename?: 'Mutation', deleteLineItem: string };

export type IDeleteEstimateRevisionMutationVariables = Exact<{
  revisionId: Scalars['ID'];
}>;


export type IDeleteEstimateRevisionMutation = { __typename?: 'Mutation', deleteEstimateRevision: string };

export type IDeleteEstimateRoomMutationVariables = Exact<{
  roomId: Scalars['ID'];
  revisionId: Scalars['ID'];
}>;


export type IDeleteEstimateRoomMutation = { __typename?: 'Mutation', deleteRoom: string };

export type IDeleteRoomAttachmentMutationVariables = Exact<{
  roomId: Scalars['ID'];
  attachmentId: Scalars['ID'];
}>;


export type IDeleteRoomAttachmentMutation = { __typename?: 'Mutation', deleteRoomAttachment: string };

export type IEmailJobMediaMutationVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type IEmailJobMediaMutation = { __typename?: 'Mutation', emailJobMedia: string };

export type IEmailProviderReceiptMutationVariables = Exact<{
  consolidatedJobId: Scalars['ID'];
  sendToInternal?: InputMaybe<Scalars['Boolean']>;
}>;


export type IEmailProviderReceiptMutation = { __typename?: 'Mutation', emailProviderReceipt: string };

export type ISubmitEstimateMutationVariables = Exact<{
  revisionId: Scalars['ID'];
}>;


export type ISubmitEstimateMutation = { __typename?: 'Mutation', submitEstimate: string };

export type IUpdateCompanyDetailsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  details?: InputMaybe<IUpdateCompanyDetails>;
}>;


export type IUpdateCompanyDetailsMutation = { __typename?: 'Mutation', updateCompanyDetails: { __typename?: 'CompanyV2', description?: string | null, phoneNumber?: string | null, phoneNumberAfterHours?: string | null, acceptedTermsAndConditions?: number | null, servicesCount: number, averageRating?: number | null, stripeId?: string | null, symbilityId?: string | null, id: string, name: string, website?: string | null, status: CompanyStatus, availability?: CompanyAvailability | null, logo?: string | null, employeeCount: number, activeJobCount: number, capacity?: number | null, profileGorillaStatus?: string | null, catCapacity?: number | null, subassignmentCount: number, xactimateAddress?: string | null, assignee?: { __typename?: 'CompanyV2UserInfo', userId?: string | null } | null, parent?: { __typename?: 'CompanyV2', id: string, name: string } | null, services: Array<{ __typename?: 'Service', id: string, iconName?: string | null, name?: string | null } | null>, serviceAreas: Array<{ __typename?: 'CompanyServiceArea', marketId: string, marketName: string, postalCodes?: Array<string | null> | null } | null>, owners: Array<{ __typename?: 'User', hubspotId?: string | null, status: number, isProfileGorilla: boolean, externalId?: string | null, isActive: boolean, email: string, isGhost: boolean, id: string, stripeAccountId?: string | null, stripeCustomerId?: string | null, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string } | null }>, organizations?: Array<{ __typename?: 'CompanyOrganization', trained?: boolean | null, approved?: boolean | null, name?: string | null, organizationId?: string | null } | null> | null, bankAccount?: { __typename?: 'BankAccount', id: string, bankName?: string | null, accountNumberLast4?: number | null, meetsRequirements?: boolean | null } | null, flows: Array<{ __typename?: 'CompanyFlow', code?: string | null, name?: string | null, description?: string | null }>, pointOfContact?: { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string } | null, addresses: { __typename?: 'CompanyAddresses', physical?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null, mailing?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null } } };

export type IUpdateEstimateMutationVariables = Exact<{
  jobId?: InputMaybe<Scalars['ID']>;
  claimId?: InputMaybe<Scalars['ID']>;
  estimateId: Scalars['ID'];
}>;


export type IUpdateEstimateMutation = { __typename?: 'Mutation', updateEstimate: { __typename?: 'Estimate', id: string, claimId?: string | null, jobId?: string | null } };

export type IUpdateEstimateLineItemMutationVariables = Exact<{
  lineItemId: Scalars['ID'];
  reqBody: ILineItemBody;
}>;


export type IUpdateEstimateLineItemMutation = { __typename?: 'Mutation', updateLineItem: { __typename?: 'EstimateLineItem', id: string, roomId: string, quantity?: number | null, totalCost?: number | null, measurementUnit?: string | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } };

export type IUpdateEstimateRevisionMutationVariables = Exact<{
  revisionId: Scalars['ID'];
  revisionName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EstimateStatus>;
  totalCost?: InputMaybe<Scalars['Float']>;
  totalCalcType?: InputMaybe<EstimatePricingModel>;
  customerTotalCost?: InputMaybe<Scalars['Float']>;
  jobId?: InputMaybe<Scalars['ID']>;
}>;


export type IUpdateEstimateRevisionMutation = { __typename?: 'Mutation', updateEstimateRevision?: { __typename?: 'EstimateRevision', id: string, revisionNumber?: number | null, revisionName?: string | null, status: EstimateStatus, totalCost?: number | null, customerTotalCost?: number | null, totalCalcType?: EstimatePricingModel | null, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null } | null> } | null, rooms: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, revisionId: string, totalCost?: number | null, name?: string | null, lineItems?: { __typename?: 'EstimateLineItems', count: number, items: Array<{ __typename?: 'EstimateLineItem', id: string, measurementUnit?: string | null, roomId: string, quantity?: number | null, totalCost?: number | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } | null> } | null } | null> } } | null };

export type IUpdateEstimateRoomMutationVariables = Exact<{
  roomId: Scalars['ID'];
  revisionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  totalCost: Scalars['Float'];
  note?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['ID']>;
}>;


export type IUpdateEstimateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'EstimateRoom', id: string, name?: string | null, totalCost?: number | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } } };

export type IUpdateEstimateStatusMutationVariables = Exact<{
  revisionId: Scalars['ID'];
  status?: InputMaybe<EstimateStatus>;
}>;


export type IUpdateEstimateStatusMutation = { __typename?: 'Mutation', updateEstimateRevision?: { __typename?: 'EstimateRevision', id: string, status: EstimateStatus, revisionNumber?: number | null, revisionName?: string | null, totalCost?: number | null } | null };

export type IUploadEstimateAttachmentMutationVariables = Exact<{
  revisionId: Scalars['ID'];
  file: Scalars['Upload'];
  length: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  carrierName?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
}>;


export type IUploadEstimateAttachmentMutation = { __typename?: 'Mutation', uploadEstimateAttachment: { __typename?: 'EstimateAttachmentUrlLink', attachmentId: string, url: string } };

export type IUploadRoomAttachmentMutationVariables = Exact<{
  id: Scalars['ID'];
  file: Scalars['Upload'];
  length: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  carrierName: Scalars['String'];
}>;


export type IUploadRoomAttachmentMutation = { __typename?: 'Mutation', uploadRoomAttachment: { __typename?: 'EstimateAttachmentUrlLink', attachmentId: string, url: string } };

export type IAddressCompanyCellFragment = { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null };

export type IAvailableProvidersInMarketQueryVariables = Exact<{
  marketId: Scalars['ID'];
  serviceTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
}>;


export type IAvailableProvidersInMarketQuery = { __typename?: 'Query', getProviders: { __typename?: 'ProviderConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'User', email: string, id: string, jobCount: number, averageRating: { __typename?: 'UserAvgRating', rating: number }, companies: Array<{ __typename?: 'Company', name: string }>, location?: { __typename?: 'UserLocation', lat: number, lng: number } | null, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, veteran: number, zipcode?: string | null } | null, userServices: Array<{ __typename?: 'UserService', id: string, license?: string | null, type: number }> }> } };

export type ICompanyRowFieldsFragment = { __typename?: 'CompanyV2', id: string, name: string, website?: string | null, status: CompanyStatus, availability?: CompanyAvailability | null, logo?: string | null, employeeCount: number, activeJobCount: number, capacity?: number | null, profileGorillaStatus?: string | null, catCapacity?: number | null, subassignmentCount: number, xactimateAddress?: string | null, pointOfContact?: { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string } | null, services: Array<{ __typename?: 'Service', id: string, iconName?: string | null, name?: string | null } | null>, addresses: { __typename?: 'CompanyAddresses', physical?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null, mailing?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null } };

export type IEstimateAttachmentSubFieldsFragment = { __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null };

export type IEstimateLineItemSubfieldsFragment = { __typename?: 'EstimateLineItem', type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> };

export type IGenerateTwilioCodeQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type IGenerateTwilioCodeQuery = { __typename?: 'Query', generateTwilioCode: { __typename?: 'GenerateTwilioCodeResponse', code: string } };

export type IGetChildCompaniesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetChildCompaniesQuery = { __typename?: 'Query', getChildCompanies: { __typename?: 'CompaniesReqConnection', totalCount: number, edges: Array<{ __typename?: 'CompanyV2', employeeCount: number, activeJobCount: number, servicesCount: number, id: string, name: string, website?: string | null, status: CompanyStatus, availability?: CompanyAvailability | null, logo?: string | null, capacity?: number | null, profileGorillaStatus?: string | null, catCapacity?: number | null, subassignmentCount: number, xactimateAddress?: string | null, addresses: { __typename?: 'CompanyAddresses', physical?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, city: string, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null, mailing?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, state?: string | null, postalCode?: string | null, country?: string | null, city: string, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null }, serviceAreas: Array<{ __typename?: 'CompanyServiceArea', postalCodes?: Array<string | null> | null, marketName: string, marketId: string } | null>, pointOfContact?: { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string } | null, services: Array<{ __typename?: 'Service', id: string, iconName?: string | null, name?: string | null } | null> }> } };

export type IGetAssociatedClaimJobsQueryVariables = Exact<{
  consolidatedJobIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type IGetAssociatedClaimJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'JobConnection', edges: Array<{ __typename?: 'Job', id: string, code?: string | null, serviceType: number, subBucketLabel?: string | null, estimateId?: string | null, consumerRequestId?: string | null, workorderId?: string | null, serviceRequestType?: { __typename?: 'ServiceRequestType', name: string } | null }> } };

export type IGetCommentsQueryVariables = Exact<{
  commentThreadId: Scalars['ID'];
}>;


export type IGetCommentsQuery = { __typename?: 'Query', getComments?: Array<{ __typename?: 'Comment', id: string, userId: string, userName: string, userRoles: Array<number>, body: string, updatedAt: number, createdAt: number, deleted: boolean, isInternalOnly: boolean, hiddenBy?: string | null, hiddenByName?: string | null, replies: Array<{ __typename?: 'Comment', id: string, userId: string, userName: string, userRoles: Array<number>, body: string, updatedAt: number, createdAt: number, deleted: boolean, isInternalOnly: boolean, hiddenBy?: string | null, hiddenByName?: string | null }> } | null> | null };

export type IGetCommentsIdQueryVariables = Exact<{
  commentThreadId: Scalars['ID'];
}>;


export type IGetCommentsIdQuery = { __typename?: 'Query', getComments?: Array<{ __typename?: 'Comment', id: string, deleted: boolean, isInternalOnly: boolean, replies: Array<{ __typename?: 'Comment', id: string, deleted: boolean, isInternalOnly: boolean }> } | null> | null };

export type IGetCompaniesV2ListQueryVariables = Exact<{
  status?: InputMaybe<CompanyStatus>;
  availability?: InputMaybe<CompanyAvailability>;
  services?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  orderBy?: InputMaybe<CompanyOrderByType>;
  hasXactimateAddress?: InputMaybe<Scalars['Boolean']>;
}>;


export type IGetCompaniesV2ListQuery = { __typename?: 'Query', getCompaniesV2: { __typename?: 'CompaniesReqConnection', totalCount: number, edges: Array<{ __typename?: 'CompanyV2', servicesCount: number, id: string, name: string, website?: string | null, status: CompanyStatus, availability?: CompanyAvailability | null, logo?: string | null, employeeCount: number, activeJobCount: number, capacity?: number | null, profileGorillaStatus?: string | null, catCapacity?: number | null, subassignmentCount: number, xactimateAddress?: string | null, serviceAreas: Array<{ __typename?: 'CompanyServiceArea', postalCodes?: Array<string | null> | null, marketName: string, marketId: string } | null>, pointOfContact?: { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string } | null, services: Array<{ __typename?: 'Service', id: string, iconName?: string | null, name?: string | null } | null>, addresses: { __typename?: 'CompanyAddresses', physical?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null, mailing?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null } }> } };

export type IGetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', externalId?: string | null, employeeCount: number, name: string, address?: string | null, marketId?: string | null, website?: string | null, description?: string | null, createdAt: number, code: string, codeNumber: number, updatedAt?: number | null, accountId: string } | null };

export type IGetCompanyEmployeesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetCompanyEmployeesQuery = { __typename?: 'Query', getCompanyEmployees: Array<{ __typename?: 'CompanyEmployee', userId: string, roles?: Array<number> | null } | null> };

export type IGetCompanyNameQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type IGetCompanyNameQuery = { __typename?: 'Query', getCompanyV2?: { __typename?: 'CompanyV2', id: string, name: string } | null };

export type IGetCompanyOptionsQueryVariables = Exact<{
  status?: InputMaybe<CompanyStatus>;
  availability?: InputMaybe<CompanyAvailability>;
  services?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  serviceAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<CompanyOrderByType>;
  hasSymbilityId?: InputMaybe<Scalars['Boolean']>;
  flows?: InputMaybe<Array<InputMaybe<CompanyFlowLabel>> | InputMaybe<CompanyFlowLabel>>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type IGetCompanyOptionsQuery = { __typename?: 'Query', getCompaniesV2: { __typename?: 'CompaniesReqConnection', totalCount: number, edges: Array<{ __typename?: 'CompanyV2', id: string, name: string }> } };

export type IGetCompanyV2QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetCompanyV2Query = { __typename?: 'Query', getCompanyV2?: { __typename?: 'CompanyV2', description?: string | null, phoneNumber?: string | null, phoneNumberAfterHours?: string | null, acceptedTermsAndConditions?: number | null, servicesCount: number, averageRating?: number | null, stripeId?: string | null, symbilityId?: string | null, id: string, name: string, website?: string | null, status: CompanyStatus, availability?: CompanyAvailability | null, logo?: string | null, employeeCount: number, activeJobCount: number, capacity?: number | null, profileGorillaStatus?: string | null, catCapacity?: number | null, subassignmentCount: number, xactimateAddress?: string | null, assignee?: { __typename?: 'CompanyV2UserInfo', userId?: string | null } | null, parent?: { __typename?: 'CompanyV2', id: string, name: string } | null, services: Array<{ __typename?: 'Service', id: string, iconName?: string | null, name?: string | null } | null>, serviceAreas: Array<{ __typename?: 'CompanyServiceArea', marketId: string, marketName: string, postalCodes?: Array<string | null> | null } | null>, owners: Array<{ __typename?: 'User', hubspotId?: string | null, status: number, isProfileGorilla: boolean, externalId?: string | null, isActive: boolean, email: string, isGhost: boolean, id: string, stripeAccountId?: string | null, stripeCustomerId?: string | null, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string } | null }>, organizations?: Array<{ __typename?: 'CompanyOrganization', trained?: boolean | null, approved?: boolean | null, name?: string | null, organizationId?: string | null } | null> | null, bankAccount?: { __typename?: 'BankAccount', id: string, bankName?: string | null, accountNumberLast4?: number | null, meetsRequirements?: boolean | null } | null, flows: Array<{ __typename?: 'CompanyFlow', code?: string | null, name?: string | null, description?: string | null }>, pointOfContact?: { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string } | null, addresses: { __typename?: 'CompanyAddresses', physical?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null, mailing?: { __typename?: 'CompanyAddress', addressLine1: string, addressLine2?: string | null, city: string, state?: string | null, postalCode?: string | null, country?: string | null, geo?: { __typename?: 'GeoCoordinate', latitude?: number | null, longitude?: number | null } | null } | null } } | null };

export type IGetConsumerRequestQueryVariables = Exact<{
  code?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  utcOffset?: InputMaybe<Scalars['Int']>;
}>;


export type IGetConsumerRequestQuery = { __typename?: 'Query', getConsumerRequest?: { __typename?: 'ConsumerRequest', appointmentDate?: number | null, scheduledDate?: number | null, assignedCompanyId?: string | null, bucket?: string | null, bucketLabel?: string | null, code?: string | null, commentThreadId?: string | null, consolidatedJobId: string, subBucket?: string | null, subBucketLabel?: string | null, serviceType: number, serviceTypeLabel?: string | null, providerName?: string | null, consumerName?: string | null, statusDescription: string, createdAt: number, declineReason?: string | null, diagnostic: boolean, estimateId?: string | null, flatRate: number, following: boolean, id: string, lat: number, lng: number, referenceNumber?: string | null, releaseDate?: number | null, status: number, tags: Array<string>, consumerId: string, propertyId?: string | null, address?: string | null, networks: Array<number>, updatedAt?: number | null, acceptedProviderRequest?: { __typename?: 'ProviderRequest', id: string } | null, contacts: Array<{ __typename?: 'ContactInfo', userId?: string | null, name?: string | null, mobile: string, email?: string | null, label: string, role?: UserRole | null }>, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, siteAccessNote?: { __typename?: 'SiteAccessNote', note: string } | null, media: Array<{ __typename?: 'Media', contentType?: string | null, createdAt: number, id: string, url: string, thumbnailUrl: string }>, jobs: Array<{ __typename?: 'Job', id: string, code?: string | null, status: number }>, note?: { __typename?: 'Note', note: string, updatedAt: number } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, property?: { __typename?: 'UserProperty', id: string, name: string, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, providerRequests: { __typename?: 'ProviderReqConnection', edges: Array<{ __typename?: 'ProviderRequest', id: string, providerId: string, status: number }> }, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null, residentName?: string | null, residentMobile?: string | null, attachments: Array<{ __typename?: 'WorkorderAttachment', id: string, contentType: string, url: string }>, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null, workorderConsumerRequest?: { __typename?: 'WorkorderConsumerRequest', networkType?: number | null, tags?: string | null, serviceType?: number | null } | null } | null } | null };

export type IGetEstimateQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['ID']>;
  claimId?: InputMaybe<Scalars['ID']>;
}>;


export type IGetEstimateQuery = { __typename?: 'Query', getEstimate?: { __typename?: 'Estimate', id: string, status?: EstimateStatus | null, claimId?: string | null, jobId?: string | null, revision?: { __typename?: 'EstimateRevision', id: string, revisionNumber?: number | null, revisionName?: string | null, totalCost?: number | null, totalCalcType?: EstimatePricingModel | null, status: EstimateStatus, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, rooms: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, revisionId: string, totalCost?: number | null, name?: string | null, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> }, lineItems?: { __typename?: 'EstimateLineItems', count: number, items: Array<{ __typename?: 'EstimateLineItem', id: string, roomId: string, quantity?: number | null, totalCost?: number | null, measurementUnit?: string | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } | null> } | null } | null> } } | null } | null };

export type IGetEstimateAttachmentsDownloadQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
}>;


export type IGetEstimateAttachmentsDownloadQuery = { __typename?: 'Query', getEstimateAttachmentsDownload: string };

export type IGetEstimatePdfDownloadQueryVariables = Exact<{
  revisionId: Scalars['ID'];
  pdfType?: InputMaybe<EstimateRevisionDocumentType>;
}>;


export type IGetEstimatePdfDownloadQuery = { __typename?: 'Query', getEstimatePdf?: { __typename?: 'EstimatePdfLink', url: string } | null };

export type IGetEstimateRevisionStatusQueryVariables = Exact<{
  revisionId: Scalars['ID'];
}>;


export type IGetEstimateRevisionStatusQuery = { __typename?: 'Query', getEstimateRevision?: { __typename?: 'EstimateRevision', status: EstimateStatus } | null };

export type IGetEstimateRoomAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetEstimateRoomAttachmentsQuery = { __typename?: 'Query', getRoomAttachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null };

export type IGetEstimateRoomQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetEstimateRoomQuery = { __typename?: 'Query', getRooms?: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, name?: string | null, revisionId: string } | null> } | null };

export type IGetItemActionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetItemActionsQuery = { __typename?: 'Query', getItemActions?: { __typename?: 'EstimateItemActions', count: number, items: Array<{ __typename?: 'EstimateItemAction', id: string, name: string, types?: { __typename?: 'EstimateItemTypes', count: number, items: Array<{ __typename?: 'EstimateItemType', id: string, name: string, grades?: { __typename?: 'EstimateItemGrades', count: number, items: Array<{ __typename?: 'EstimateItemGrade', id: string, name: string } | null> } | null } | null> } | null } | null> } | null };

export type IGetJobQueryVariables = Exact<{
  code?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type IGetJobQuery = { __typename?: 'Query', getJob?: { __typename?: 'Job', address?: string | null, appointmentDate?: number | null, scheduledDate?: number | null, scheduledDateTimezone?: string | null, assignedCompanyId?: string | null, bucket?: string | null, bucketLabel?: string | null, following: boolean, subBucket?: string | null, subBucketLabel?: string | null, serviceType: number, serviceTypeLabel?: string | null, providerName?: string | null, consumerName?: string | null, statusDescription: string, code?: string | null, consolidatedJobId: string, companyId?: string | null, consumerId: string, consumerRequestId?: string | null, commentThreadId?: string | null, createdAt: number, diagnostic: boolean, diagnosticStatus?: number | null, id: string, lat: number, limitReached: number, limitTotal: number, lng: number, locked: boolean, marketId?: string | null, partsStop: boolean, propertyId?: string | null, providerId: string, organizationId?: string | null, referenceNumber?: string | null, resolutionAccepted?: number | null, resolutionSuggested?: number | null, status: number, tags: Array<string>, workorderId?: string | null, updatedAt?: number | null, repairJob?: { __typename?: 'Job', code?: string | null } | null, estimateJob?: { __typename?: 'Job', code?: string | null } | null, company?: { __typename?: 'CompanyV2', id: string, name: string } | null, consumer: { __typename: 'User', customMaterialsFee?: number | null, id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, consumerRequest?: { __typename?: 'ConsumerRequest', createdAt: number, id: string, networks: Array<number>, releaseDate?: number | null, status: number, updatedAt?: number | null, media: Array<{ __typename?: 'Media', contentType?: string | null, createdAt: number, id: string, url: string, thumbnailUrl: string }>, note?: { __typename?: 'Note', note: string, updatedAt: number } | null } | null, contacts: Array<{ __typename?: 'ContactInfo', userId?: string | null, name?: string | null, mobile: string, email?: string | null, label: string, role?: UserRole | null }>, claims?: Array<{ __typename?: 'Claim', homeeClaimId: string, attachments?: Array<{ __typename?: 'ClaimAttachment', attachmentId: string, contentType?: string | null, filename?: string | null, documentType?: string | null, externalId?: string | null, location?: string | null, s3Path?: string | null, type?: string | null, visibility?: string | null, dateAdded?: string | null, s3Location?: { __typename?: 'ClaimAttachmentS3Location', bucket?: string | null, path?: string | null } | null } | null> | null } | null> | null, diagnosticNote?: { __typename?: 'JobDiagnosticNote', createdAt?: number | null, note: string, noteEn?: string | null, noteEs?: string | null, scopeOfWork?: string | null, scopeOfWorkEn?: string | null, scopeOfWorkEs?: string | null, updatedAt?: number | null } | null, estimate?: { __typename?: 'JobEstimate', id: string, estimateJobId?: string | null, estimateStatus: JobEstimateStatus } | null, estimateV2?: { __typename?: 'Estimate', id: string, status?: EstimateStatus | null, jobId?: string | null, claimId?: string | null, lastUpdatedAt?: string | null, revision?: { __typename?: 'EstimateRevision', id: string, revisionNumber?: number | null, revisionName?: string | null, totalCost?: number | null, totalCalcType?: EstimatePricingModel | null, customerTotalCost?: number | null, status: EstimateStatus, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, rooms: { __typename?: 'EstimateRooms', count: number, items: Array<{ __typename?: 'EstimateRoom', id: string, totalCost?: number | null, name?: string | null, notes: { __typename?: 'EstimateNotes', count: number, items: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> }, attachments?: { __typename?: 'EstimateAttachments', count: number, data: Array<{ __typename?: 'EstimateAttachment', id: string, url: string, name?: string | null, length?: number | null, contentType?: string | null, note?: string | null, status?: EstimateAttachmentStatus | null, checksum?: string | null } | null> } | null, lineItems?: { __typename?: 'EstimateLineItems', count: number, items: Array<{ __typename?: 'EstimateLineItem', id: string, roomId: string, measurementUnit?: string | null, quantity?: number | null, totalCost?: number | null, title?: { __typename?: 'EstimateItemTitle', id: string, isNoteMandatory?: boolean | null, measurementsUnitId?: string | null, measurementsUnitHint?: string | null, measurementsUnit?: string | null, name: string, noteHint?: string | null } | null, grade?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, type?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, action?: { __typename?: 'EstimateLineItemSelection', id: string, name: string } | null, notes: Array<{ __typename?: 'EstimateNote', id: string, note: string } | null> } | null> } | null } | null> } } | null } | null, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, media: Array<{ __typename?: 'Media', contentType?: string | null, createdAt: number, id: string, url: string, thumbnailUrl: string }>, invoice?: { __typename?: 'JobInvoice', consumerFlatRate?: number | null, consumerRateBase: number, consumerRateHour: number, consumerTotalCost: number, consumerTotalHourly: number, consumerTotalMaterials: number, coteriePremium?: number | null, discount?: number | null, elapsedTime: number, promocode?: string | null, providerFlatRate?: number | null, providerRateBase: number, providerRateHour: number, providerTotalCost: number, providerTotalHourly: number, providerTotalMaterials: number, subsidyFlatRate: number, subsidyLevel: number, subsidyRateBase: number, subsidyRateHour: number, subsidyTotalHourly: number, tip?: number | null } | null, lineItems: Array<{ __typename?: 'JobLineItem', id: string, lineItemType?: string | null, description?: string | null, consumerTotal?: number | null, providerTotal?: number | null, jobMaterialId?: string | null }>, limitExtensions: Array<{ __typename?: 'JobLimitExtension', consumerNote?: string | null, createdAt?: number | null, currencyIncrease?: number | null, id: string, minutesIncrease?: number | null, providerNote?: string | null, status: number, updatedAt?: number | null }>, linkedJobs: Array<{ __typename?: 'Job', id: string, code?: string | null }>, market?: { __typename?: 'Market', id: string, name: string } | null, materials: Array<{ __typename?: 'JobMaterial', id: string, consumerPrice: number, createdAt: number, description: string, providerPrice: number, quantity: number, rapidpassCode?: string | null, skipReimbursement: boolean, updatedAt?: number | null }>, note?: { __typename?: 'Note', note: string, updatedAt: number } | null, property?: { __typename?: 'UserProperty', id: string, name: string, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, provider: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null, transfers: Array<{ __typename?: 'JobTransfer', id: string, amount: number, status?: TransferStatus | null, type?: number | null, createdAt?: number | null, updatedAt?: number | null } | null>, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null, residentName?: string | null, residentMobile?: string | null, property?: { __typename?: 'UserProperty', id: string, name: string, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null, attachments: Array<{ __typename?: 'WorkorderAttachment', contentType: string, id: string, url: string }>, media: Array<{ __typename?: 'Media', contentType?: string | null, createdAt: number, id: string, url: string, thumbnailUrl: string }>, note?: { __typename?: 'Note', note: string, updatedAt: number } | null, workorderJob?: { __typename?: 'WorkorderJob', assignReason?: string | null } | null } | null, userService: { __typename?: 'UserService', id: string, experience: number } } | null };

export type IGetJobTimerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetJobTimerQuery = { __typename?: 'Query', getJob?: { __typename?: 'Job', id: string, timeAdjustment: number, invoice?: { __typename?: 'JobInvoice', elapsedTime: number } | null } | null };

export type IGetJobsListQueryVariables = Exact<{
  bucket?: InputMaybe<WorkbenchBucket>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  consumerId?: InputMaybe<Scalars['ID']>;
  consumerRequestStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  createdDateEnd?: InputMaybe<Scalars['String']>;
  createdDateStart?: InputMaybe<Scalars['String']>;
  completedDateEnd?: InputMaybe<Scalars['String']>;
  completedDateStart?: InputMaybe<Scalars['String']>;
  appointmentDateEnd?: InputMaybe<Scalars['String']>;
  appointmentDateStart?: InputMaybe<Scalars['String']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  internalAssigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  jobStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  laborCostMax?: InputMaybe<Scalars['Float']>;
  laborCostMin?: InputMaybe<Scalars['Float']>;
  marketId?: InputMaybe<Scalars['ID']>;
  materialCostMax?: InputMaybe<Scalars['Float']>;
  materialCostMin?: InputMaybe<Scalars['Float']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  jobOrigin?: InputMaybe<JobOrigin>;
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priority?: InputMaybe<Scalars['Int']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['ID']>;
  providerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  subBuckets?: InputMaybe<Array<SubBucket> | SubBucket>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
  totalCostMax?: InputMaybe<Scalars['Float']>;
  totalCostMin?: InputMaybe<Scalars['Float']>;
  utcOffset?: InputMaybe<Scalars['Int']>;
  workorderStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  estimateStatuses?: InputMaybe<Array<JobEstimateStatus> | JobEstimateStatus>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type IGetJobsListQuery = { __typename?: 'Query', getWorkbenchList: { __typename?: 'WorkbenchItemConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'ConsumerRequest', code?: string | null, statusDescription: string, tags: Array<string>, releaseDate?: number | null, updatedAt?: number | null, consumerName?: string | null, address?: string | null, assignedCompanyId?: string | null, bucket?: string | null, bucketLabel?: string | null, createdAt: number, appointmentDate?: number | null, scheduledDate?: number | null, scheduledDateTimezone?: string | null, consumerId: string, following: boolean, id: string, lat: number, lng: number, priority?: number | null, referenceNumber?: string | null, serviceType: number, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketLabel?: string | null, consumerReqStatus: number, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, acceptedProviderRequest?: { __typename?: 'ProviderRequest', id: string } | null, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null, type?: number | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null, workorderConsumerRequest?: { __typename?: 'WorkorderConsumerRequest', tags?: string | null } | null } | null, contactsMap: { __typename?: 'ContactMapInfo', manager?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, propertyManager?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, consumer?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, resident?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, provider?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null }, property?: { __typename?: 'UserProperty', id: string, name: string, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, company?: { __typename?: 'CompanyV2', id: string, name: string } | null, requestNote?: { __typename?: 'Note', note: string, updatedAt: number } | null } | { __typename: 'Job', statusDescription: string, tags: Array<string>, code?: string | null, limitReached: number, consumerRequestId?: string | null, finalizedAt?: number | null, updatedAt?: number | null, consumerName?: string | null, address?: string | null, assignedCompanyId?: string | null, bucket?: string | null, bucketLabel?: string | null, createdAt: number, appointmentDate?: number | null, scheduledDate?: number | null, scheduledDateTimezone?: string | null, consumerId: string, following: boolean, id: string, lat: number, lng: number, priority?: number | null, referenceNumber?: string | null, serviceType: number, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketLabel?: string | null, jobStatus: number, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, estimate?: { __typename?: 'JobEstimate', id: string, estimateJobId?: string | null } | null, consumerRequest?: { __typename?: 'ConsumerRequest', id: string, status: number } | null, property?: { __typename?: 'UserProperty', id: string, name: string, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null, type?: number | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null } | null, contactsMap: { __typename?: 'ContactMapInfo', manager?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, propertyManager?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, consumer?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, resident?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null, provider?: { __typename?: 'ContactInfo', name?: string | null, label: string, role?: UserRole | null, mobile: string, email?: string | null, userId?: string | null } | null }, company?: { __typename?: 'CompanyV2', id: string, name: string } | null, requestNote?: { __typename?: 'Note', note: string, updatedAt: number } | null } | { __typename: 'Workorder', statusDescription: string, type?: number | null, consumerName?: string | null, zipcode?: string | null, residentName?: string | null, updatedAt?: number | null, integrationOrganizationId?: string | null, integrationOrganizationName?: string | null, address?: string | null, assignedCompanyId?: string | null, bucket?: string | null, bucketLabel?: string | null, createdAt: number, appointmentDate?: number | null, scheduledDate?: number | null, scheduledDateTimezone?: string | null, consumerId: string, following: boolean, id: string, lat: number, lng: number, priority?: number | null, referenceNumber?: string | null, serviceType?: number | null, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketLabel?: string | null, workorderStatus: number, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, property?: { __typename?: 'UserProperty', id: string, name: string, class: number, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, market?: { __typename?: 'Market', id: string, name: string, status: number } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null, workorderConsumerRequest?: { __typename?: 'WorkorderConsumerRequest', id: string, serviceType?: number | null, tags?: string | null } | null, workorderJob?: { __typename?: 'WorkorderJob', id: string, serviceType?: number | null, provider?: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } | null } | null, company?: { __typename?: 'CompanyV2', id: string, name: string } | null, requestNote?: { __typename?: 'Note', note: string, updatedAt: number } | null }> } };

export type IGetMarketsQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type IGetMarketsQuery = { __typename?: 'Query', getMarkets: Array<{ __typename?: 'Market', id: string, regionId?: string | null, name: string, coli?: string | null, adjustedColi?: string | null, subsidized: number, status: number }> };

export type IGetMatchingCompanyV2QueryVariables = Exact<{
  postalCode: Scalars['String'];
  serviceId: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  flow?: InputMaybe<CompanyFlowLabel>;
}>;


export type IGetMatchingCompanyV2Query = { __typename?: 'Query', getMatchingCompanyV2?: { __typename?: 'CompanyV2', id: string, name: string } | null };

export type IGetMeasurementUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetMeasurementUnitsQuery = { __typename?: 'Query', getMeasurementUnits?: { __typename?: 'MeasurementUnits', count: number, data: Array<{ __typename?: 'MetadataItemGrade', id: string, name: string } | null> } | null };

export type IGetMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetMetadataQuery = { __typename?: 'Query', getMetadata: Array<{ __typename?: 'Metadata', id: string, name: string, isNoteMandatory?: boolean | null, measurementsUnitHint?: string | null, measurementsUnitId?: string | null, measurementsUnitName?: string | null, actions?: { __typename?: 'MetadataItemActions', count: number, data: Array<{ __typename?: 'MetadataItemAction', id: string, name: string, types: { __typename?: 'MetadataItemTypes', count: number, data: Array<{ __typename?: 'MetadataItemType', id: string, name: string, grades: { __typename?: 'MetadataItemGrades', count: number, data: Array<{ __typename?: 'MetadataItemGrade', id: string, name: string } | null> } } | null> } } | null> } | null } | null> };

export type IGetPhoneTypeQueryVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type IGetPhoneTypeQuery = { __typename?: 'Query', getPhoneType: { __typename?: 'GetPhoneTypeResponse', type: string } };

export type IGetRoomAttachmentDownloadQueryVariables = Exact<{
  roomId: Scalars['ID'];
  attachmentId: Scalars['ID'];
}>;


export type IGetRoomAttachmentDownloadQuery = { __typename?: 'Query', getRoomAttachmentDownload: { __typename?: 'EstimatePdfLink', url: string } };

export type IGetUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetUserQuery = { __typename?: 'Query', getUser?: { __typename: 'User', isProfileGorilla: boolean, externalId?: string | null, registrationStatus?: number | null, jobCount: number, verified: number, status: number, createdAt?: number | null, isActive: boolean, id: string, email: string, availability?: { __typename?: 'UserAvailability', available: boolean } | null, taxationNumbers: Array<{ __typename?: 'TaxationNumber', id: string, taxationNumber: string, description?: string | null, administrativeArea?: string | null }>, userMarket?: { __typename?: 'UserMarket', name: string, id: string } | null, userPreferences?: { __typename?: 'UserPreferences', language: Language } | null, userLegalEntity?: { __typename?: 'UserLegalEntity', dobDay?: number | null, dobMonth?: number | null, dobYear?: number | null } | null, userServices: Array<{ __typename?: 'UserService', id: string, status: number, legacyService: number, experience: number, startYear?: number | null, service: { __typename?: 'Service', id: string, name?: string | null, iconName?: string | null, legacyId?: number | null }, serviceLicenses: Array<{ __typename?: 'ServiceLicense', id: string, license: string, jurisdiction: string }>, subUserServices: Array<{ __typename?: 'UserService', id: string, status: number, legacyService: number, service: { __typename?: 'Service', id: string, name?: string | null, iconName?: string | null } }> }>, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } | null };

export type IGetUserContactQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetUserContactQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', email: string, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string } | null } | null };

export type IGetUserPropertiesQueryVariables = Exact<{
  userId: Scalars['ID'];
  propertyTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type IGetUserPropertiesQuery = { __typename?: 'Query', getUserProperties: Array<{ __typename?: 'UserProperty', address: string, id: string, lat: number, lng: number, name: string, imageUrl?: string | null }> };

export type IGetWorkbenchBucketTotalQueryVariables = Exact<{
  bucket?: InputMaybe<WorkbenchBucket>;
  marketId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
}>;


export type IGetWorkbenchBucketTotalQuery = { __typename?: 'Query', getWorkbenchList: { __typename?: 'WorkbenchItemConnection', totalCount: number } };

export type IGetWorkbenchListQueryVariables = Exact<{
  bucket?: InputMaybe<WorkbenchBucket>;
  companyId?: InputMaybe<Scalars['ID']>;
  consumerId?: InputMaybe<Scalars['ID']>;
  consumerRequestStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  dateEnd?: InputMaybe<Scalars['String']>;
  dateStart?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  includeTestResults?: InputMaybe<Scalars['Boolean']>;
  internalAssigneeId?: InputMaybe<Scalars['ID']>;
  jobStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  laborCostMax?: InputMaybe<Scalars['Float']>;
  laborCostMin?: InputMaybe<Scalars['Float']>;
  marketId?: InputMaybe<Scalars['ID']>;
  materialCostMax?: InputMaybe<Scalars['Float']>;
  materialCostMin?: InputMaybe<Scalars['Float']>;
  networkTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  orderBy?: InputMaybe<GetWorkbenchListOrderBy>;
  jobOrigin?: InputMaybe<JobOrigin>;
  organizationIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  propertyId?: InputMaybe<Scalars['ID']>;
  providerId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  residentId?: InputMaybe<Scalars['ID']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  serviceTypes?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
  subBuckets?: InputMaybe<Array<SubBucket> | SubBucket>;
  thirdPartyOrigin?: InputMaybe<Scalars['Boolean']>;
  totalCostMax?: InputMaybe<Scalars['Float']>;
  totalCostMin?: InputMaybe<Scalars['Float']>;
  utcOffset?: InputMaybe<Scalars['Int']>;
  workorderStatuses?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  scheduledDateEnd?: InputMaybe<Scalars['String']>;
  scheduledDateStart?: InputMaybe<Scalars['String']>;
  nullScheduledDate?: InputMaybe<Scalars['Boolean']>;
  nullAppointmentDate?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type IGetWorkbenchListQuery = { __typename?: 'Query', getWorkbenchList: { __typename?: 'WorkbenchItemConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'ConsumerRequest', code?: string | null, statusDescription: string, releaseDate?: number | null, updatedAt?: number | null, address?: string | null, bucket?: string | null, bucketLabel?: string | null, consumerName?: string | null, createdAt: number, following: boolean, id: string, lat: number, lng: number, priority?: number | null, propertyId?: string | null, providerName?: string | null, referenceNumber?: string | null, serviceType: number, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketColor: string, subBucketLabel?: string | null, scheduledDate?: number | null, consumerReqStatus: number, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null } | null, property?: { __typename?: 'UserProperty', id: string, name: string, class: number, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, providerRequests: { __typename?: 'ProviderReqConnection', edges: Array<{ __typename?: 'ProviderRequest', id: string, providerId: string, status: number }> }, note?: { __typename?: 'Note', note: string, updatedAt: number } | null } | { __typename: 'Job', statusDescription: string, code?: string | null, consumerRequestId?: string | null, finalizedAt?: number | null, limitReached: number, locked: boolean, updatedAt?: number | null, partsStop: boolean, address?: string | null, bucket?: string | null, bucketLabel?: string | null, consumerName?: string | null, createdAt: number, following: boolean, id: string, lat: number, lng: number, priority?: number | null, propertyId?: string | null, providerName?: string | null, referenceNumber?: string | null, serviceType: number, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketColor: string, subBucketLabel?: string | null, scheduledDate?: number | null, jobStatus: number, consumerRequest?: { __typename?: 'ConsumerRequest', id: string, status: number } | null, invoice?: { __typename?: 'JobInvoice', consumerFlatRate?: number | null, consumerRateBase: number, consumerRateHour: number, consumerTotalCost: number, consumerTotalHourly: number, consumerTotalMaterials: number, coteriePremium?: number | null, elapsedTime: number, providerFlatRate?: number | null, providerRateBase: number, providerRateHour: number, providerTotalCost: number, providerTotalHourly: number, providerTotalMaterials: number, subsidyFlatRate: number, subsidyLevel: number, subsidyRateBase: number, subsidyRateHour: number, subsidyTotalHourly: number, tip?: number | null } | null, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, property?: { __typename?: 'UserProperty', id: string, name: string, class: number, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, provider: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, workorder?: { __typename?: 'Workorder', id: string, priority?: number | null } | null, note?: { __typename?: 'Note', note: string, updatedAt: number } | null } | { __typename: 'Workorder', statusDescription: string, zipcode?: string | null, occupied: boolean, residentName?: string | null, residentMobile?: string | null, updatedAt?: number | null, integrationOrganizationId?: string | null, integrationOrganizationName?: string | null, address?: string | null, bucket?: string | null, bucketLabel?: string | null, consumerName?: string | null, createdAt: number, following: boolean, id: string, lat: number, lng: number, priority?: number | null, propertyId?: string | null, providerName?: string | null, referenceNumber?: string | null, serviceType?: number | null, serviceTypeLabel?: string | null, status: number, subBucket?: string | null, subBucketColor: string, subBucketLabel?: string | null, scheduledDate?: number | null, workorderStatus: number, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, property?: { __typename?: 'UserProperty', id: string, name: string, class: number, user: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } } | null, market?: { __typename?: 'Market', id: string, name: string, status: number } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, workorderConsumerRequest?: { __typename?: 'WorkorderConsumerRequest', id: string, serviceType?: number | null } | null, workorderJob?: { __typename?: 'WorkorderJob', id: string, serviceType?: number | null, provider?: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } | null } | null, note?: { __typename?: 'Note', note: string, updatedAt: number } | null }> } };

export type IGetWorkorderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IGetWorkorderQuery = { __typename?: 'Query', getWorkorder?: { __typename?: 'Workorder', appointmentDate?: number | null, scheduledDate?: number | null, scheduledDateTimezone?: string | null, assignedCompanyId?: string | null, consolidatedJobId: string, createdAt: number, commentThreadId?: string | null, consumerId: string, following: boolean, id: string, lat: number, limitTotal?: number | null, lng: number, referenceNumber?: string | null, serviceId?: string | null, serviceType?: number | null, serviceTypeLabel?: string | null, status: number, statusDescription: string, subBucketLabel?: string | null, priority?: number | null, propertyId?: string | null, providerName?: string | null, address?: string | null, residentName?: string | null, residentMobile?: string | null, integrationOrganizationId?: string | null, integrationOrganizationName?: string | null, updatedAt?: number | null, zipcode?: string | null, attachments: Array<{ __typename?: 'WorkorderAttachment', contentType: string, id: string, url: string }>, company?: { __typename?: 'CompanyV2', name: string } | null, claims?: Array<{ __typename?: 'Claim', homeeClaimId: string, attachments?: Array<{ __typename?: 'ClaimAttachment', attachmentId: string, contentType?: string | null, dateAdded?: string | null, thumbnailUrl?: string | null, attachmentUrl?: string | null, type?: string | null } | null> | null } | null> | null, internalAssignee?: { __typename?: 'ContactInfo', name?: string | null, email?: string | null, mobile: string, userId?: string | null } | null, media: Array<{ __typename?: 'Media', contentType?: string | null, createdAt: number, id: string, url: string }>, note?: { __typename?: 'Note', updatedAt: number, note: string } | null, organization?: { __typename?: 'Organization', id: string, name?: string | null } | null, consumer: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null }, workorderConsumerRequest?: { __typename?: 'WorkorderConsumerRequest', createdAt: number, id: string, networkType?: number | null, releaseDate?: number | null, serviceType?: number | null } | null, workorderJob?: { __typename?: 'WorkorderJob', assignReason?: string | null, createdAt: number, id: string, providerId?: string | null, serviceType?: number | null } | null, serviceRequestType?: { __typename?: 'ServiceRequestType', id: string, name: string } | null } | null };

export type IJobEstimateQueryVariables = Exact<{
  where: IJobEstimateInputWhere;
}>;


export type IJobEstimateQuery = { __typename?: 'Query', jobEstimate: { __typename?: 'JobEstimate', deductible?: number | null, recoverableDepreciation?: number | null, nonRecoverableDepreciation?: number | null, id: string, estimateStatus: JobEstimateStatus, estimateStatusDescription: string, updatedAt: number, proTotal?: number | null, consumerTotal?: number | null, laborMargin?: number | null, materialsMargin?: number | null, totalMargin?: number | null, canStartToday: boolean, expiresAt?: number | null, estimateJob?: { __typename?: 'Job', code?: string | null, id: string, consumerId: string, providerId: string, provider: { __typename?: 'User', id: string, email: string, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string } | null } } | null, estimateConsumerRequest?: { __typename?: 'ConsumerRequest', code?: string | null, id: string, consumerId: string } | null, completionJob?: { __typename?: 'Job', id: string, code?: string | null } | null, laborTimeRange: { __typename?: 'IntRange', min: number, max: number }, comparedEarningsRange?: { __typename?: 'FloatRange', min: number, max: number } | null, assets: Array<{ __typename?: 'Asset', id: string, thumbnailUrl: string, url: string, scanned: boolean, contentType: string }>, items: Array<{ __typename?: 'JobEstimateItem', id: string, name: string, proLaborPrice?: number | null, consumerLaborPrice?: number | null, totalProMaterialPrice?: number | null, totalConsumerMaterialPrice?: number | null, recommendedSolution?: string | null, measurements?: string | null, additionalNotes?: string | null, materials: Array<{ __typename?: 'JobEstimateItemMaterial', id: string, quantity: number, name?: string | null, proPricePerUnit?: number | null, proTotal?: number | null, consumerPricePerUnit?: number | null, consumerTotal?: number | null }>, laborTimeRange: { __typename?: 'IntRange', min: number, max: number }, assets: Array<{ __typename?: 'Asset', id: string, thumbnailUrl: string, url: string, contentType: string }> }> } };

export type IMarketMetaQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IMarketMetaQuery = { __typename?: 'Query', marketMeta: { __typename?: 'MarketMeta', activeJobs: number, enRouteJobs: number, inProgressJobs: number, pausedJobs: number, suspendedJobs: number, completedJobs: number, onlinePros: number, handymanPros: number, plumbingPros: number, hvacPros: number, electricalPros: number, smartHomePros: number } };

export type IMentionsQueryVariables = Exact<{
  roles: Array<UserRoles> | UserRoles;
}>;


export type IMentionsQuery = { __typename?: 'Query', mentions: Array<{ __typename?: 'Mention', email: string, id: string, firstName: string, lastName: string }> };

export type INotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  startAfter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type INotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'NotificationConnection', totalCount: number, edges: Array<{ __typename?: 'Notification', actionUrl?: string | null, createdAt: number, iconName?: string | null, id: string, message: string, readAt?: number | null, updatedAt: number, userId: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null } } };

export type IOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, networkInhouse: boolean, networkOpen: boolean, networkPreferred: boolean } | null };

export type IPointOfContactCompanyCellFragment = { __typename?: 'ContactInfo', userId?: string | null, name?: string | null, email?: string | null, mobile: string };

export type IProsThatRecievedRequestQueryVariables = Exact<{
  consumerRequestId: Scalars['ID'];
}>;


export type IProsThatRecievedRequestQuery = { __typename?: 'Query', getProviderRequests: { __typename?: 'ProviderReqConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'ProviderRequest', id: string, provider: { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null } }> } };

export type IServiceRequestTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type IServiceRequestTypesQuery = { __typename?: 'Query', serviceRequestTypes: Array<{ __typename?: 'ServiceRequestType', id: string, name: string }> };

export type IServicesCompanyCellFragment = { __typename?: 'Service', id: string, iconName?: string | null, name?: string | null };

export type IUserFieldsFragment = { __typename: 'User', id: string, email: string, averageRating: { __typename?: 'UserAvgRating', rating: number }, userProfile?: { __typename?: 'UserProfile', firstName: string, lastName: string, mobile: string, zipcode?: string | null } | null };

export type IUserOrganizationsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type IUserOrganizationsQuery = { __typename?: 'Query', userOrganizations: Array<{ __typename?: 'Organization', id: string, name?: string | null, networkInhouse: boolean, networkOpen: boolean, networkPreferred: boolean, internalName?: string | null }> };

export type IUserPermissionsQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type IUserPermissionsQuery = { __typename?: 'Query', userPermissions: Array<number> };

export type IUserServicesQueryVariables = Exact<{
  providerId: Scalars['ID'];
}>;


export type IUserServicesQuery = { __typename?: 'Query', userServices: Array<{ __typename?: 'UserService', id: string, type: number }> };

export type IZipGeoQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;


export type IZipGeoQuery = { __typename?: 'Query', getZipGeo?: { __typename?: 'ZipGeo', zipCode: string, timeZone?: string | null, tzName?: string | null } | null };

export const PointOfContactCompanyCellFragmentDoc = gql`
    fragment PointOfContactCompanyCell on ContactInfo {
  userId
  name
  email
  mobile
}
    `;
export const ServicesCompanyCellFragmentDoc = gql`
    fragment ServicesCompanyCell on Service {
  id
  iconName
  name
}
    `;
export const AddressCompanyCellFragmentDoc = gql`
    fragment AddressCompanyCell on CompanyAddress {
  addressLine1
  addressLine2
  city
  state
  postalCode
  country
  geo {
    latitude
    longitude
  }
}
    `;
export const CompanyRowFieldsFragmentDoc = gql`
    fragment CompanyRowFields on CompanyV2 {
  id
  name
  website
  status
  availability
  logo
  pointOfContact {
    ...PointOfContactCompanyCell
  }
  services {
    ...ServicesCompanyCell
  }
  addresses {
    physical {
      ...AddressCompanyCell
    }
    mailing {
      ...AddressCompanyCell
    }
  }
  employeeCount
  activeJobCount
  capacity
  profileGorillaStatus
  logo
  catCapacity
  subassignmentCount
  xactimateAddress
}
    ${PointOfContactCompanyCellFragmentDoc}
${ServicesCompanyCellFragmentDoc}
${AddressCompanyCellFragmentDoc}`;
export const EstimateAttachmentSubFieldsFragmentDoc = gql`
    fragment EstimateAttachmentSubFields on EstimateAttachment {
  id
  url
  name
  length
  contentType
  note
  status
  checksum
}
    `;
export const EstimateLineItemSubfieldsFragmentDoc = gql`
    fragment EstimateLineItemSubfields on EstimateLineItem {
  type {
    id
    name
  }
  action {
    id
    name
  }
  grade {
    id
    name
  }
  notes {
    id
    note
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  __typename
  id
  email
  averageRating {
    rating
  }
  userProfile {
    firstName
    lastName
    mobile
    zipcode
  }
}
    `;
export const CheckTwilioVerificationCodeDocument = gql`
    mutation checkTwilioVerificationCode($to: String!, $code: String!) {
  checkTwilioVerificationCode(to: $to, code: $code) {
    status
  }
}
    `;
export type ICheckTwilioVerificationCodeMutationFn = Apollo.MutationFunction<ICheckTwilioVerificationCodeMutation, ICheckTwilioVerificationCodeMutationVariables>;

/**
 * __useCheckTwilioVerificationCodeMutation__
 *
 * To run a mutation, you first call `useCheckTwilioVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckTwilioVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkTwilioVerificationCodeMutation, { data, loading, error }] = useCheckTwilioVerificationCodeMutation({
 *   variables: {
 *      to: // value for 'to'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCheckTwilioVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<ICheckTwilioVerificationCodeMutation, ICheckTwilioVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICheckTwilioVerificationCodeMutation, ICheckTwilioVerificationCodeMutationVariables>(CheckTwilioVerificationCodeDocument, options);
      }
export type CheckTwilioVerificationCodeMutationHookResult = ReturnType<typeof useCheckTwilioVerificationCodeMutation>;
export type CheckTwilioVerificationCodeMutationResult = Apollo.MutationResult<ICheckTwilioVerificationCodeMutation>;
export type CheckTwilioVerificationCodeMutationOptions = Apollo.BaseMutationOptions<ICheckTwilioVerificationCodeMutation, ICheckTwilioVerificationCodeMutationVariables>;
export const CompanyUpdateAssigneeDocument = gql`
    mutation companyUpdateAssignee($companyId: ID!, $assignee: String) {
  companyUpdateAssignee(companyId: $companyId, assigneeId: $assignee)
}
    `;
export type ICompanyUpdateAssigneeMutationFn = Apollo.MutationFunction<ICompanyUpdateAssigneeMutation, ICompanyUpdateAssigneeMutationVariables>;

/**
 * __useCompanyUpdateAssigneeMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateAssigneeMutation, { data, loading, error }] = useCompanyUpdateAssigneeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      assignee: // value for 'assignee'
 *   },
 * });
 */
export function useCompanyUpdateAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateAssigneeMutation, ICompanyUpdateAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateAssigneeMutation, ICompanyUpdateAssigneeMutationVariables>(CompanyUpdateAssigneeDocument, options);
      }
export type CompanyUpdateAssigneeMutationHookResult = ReturnType<typeof useCompanyUpdateAssigneeMutation>;
export type CompanyUpdateAssigneeMutationResult = Apollo.MutationResult<ICompanyUpdateAssigneeMutation>;
export type CompanyUpdateAssigneeMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateAssigneeMutation, ICompanyUpdateAssigneeMutationVariables>;
export const CompanyUpdateAvailabilityDocument = gql`
    mutation companyUpdateAvailability($id: ID!, $availability: CompanyAvailability) {
  companyUpdateAvailability(companyId: $id, availability: $availability)
}
    `;
export type ICompanyUpdateAvailabilityMutationFn = Apollo.MutationFunction<ICompanyUpdateAvailabilityMutation, ICompanyUpdateAvailabilityMutationVariables>;

/**
 * __useCompanyUpdateAvailabilityMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateAvailabilityMutation, { data, loading, error }] = useCompanyUpdateAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      availability: // value for 'availability'
 *   },
 * });
 */
export function useCompanyUpdateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateAvailabilityMutation, ICompanyUpdateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateAvailabilityMutation, ICompanyUpdateAvailabilityMutationVariables>(CompanyUpdateAvailabilityDocument, options);
      }
export type CompanyUpdateAvailabilityMutationHookResult = ReturnType<typeof useCompanyUpdateAvailabilityMutation>;
export type CompanyUpdateAvailabilityMutationResult = Apollo.MutationResult<ICompanyUpdateAvailabilityMutation>;
export type CompanyUpdateAvailabilityMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateAvailabilityMutation, ICompanyUpdateAvailabilityMutationVariables>;
export const CompanyUpdateCapacityDocument = gql`
    mutation companyUpdateCapacity($companyId: ID!, $capacity: Int, $catCapacity: Int) {
  companyUpdateCapacity(
    companyId: $companyId
    capacity: $capacity
    catCapacity: $catCapacity
  )
}
    `;
export type ICompanyUpdateCapacityMutationFn = Apollo.MutationFunction<ICompanyUpdateCapacityMutation, ICompanyUpdateCapacityMutationVariables>;

/**
 * __useCompanyUpdateCapacityMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateCapacityMutation, { data, loading, error }] = useCompanyUpdateCapacityMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      capacity: // value for 'capacity'
 *      catCapacity: // value for 'catCapacity'
 *   },
 * });
 */
export function useCompanyUpdateCapacityMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateCapacityMutation, ICompanyUpdateCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateCapacityMutation, ICompanyUpdateCapacityMutationVariables>(CompanyUpdateCapacityDocument, options);
      }
export type CompanyUpdateCapacityMutationHookResult = ReturnType<typeof useCompanyUpdateCapacityMutation>;
export type CompanyUpdateCapacityMutationResult = Apollo.MutationResult<ICompanyUpdateCapacityMutation>;
export type CompanyUpdateCapacityMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateCapacityMutation, ICompanyUpdateCapacityMutationVariables>;
export const CompanyUpdateFlowsDocument = gql`
    mutation companyUpdateFlows($companyId: ID!, $flows: [CompanyFlowLabel!]!) {
  companyUpdateFlows(companyId: $companyId, flows: $flows)
}
    `;
export type ICompanyUpdateFlowsMutationFn = Apollo.MutationFunction<ICompanyUpdateFlowsMutation, ICompanyUpdateFlowsMutationVariables>;

/**
 * __useCompanyUpdateFlowsMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateFlowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateFlowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateFlowsMutation, { data, loading, error }] = useCompanyUpdateFlowsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      flows: // value for 'flows'
 *   },
 * });
 */
export function useCompanyUpdateFlowsMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateFlowsMutation, ICompanyUpdateFlowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateFlowsMutation, ICompanyUpdateFlowsMutationVariables>(CompanyUpdateFlowsDocument, options);
      }
export type CompanyUpdateFlowsMutationHookResult = ReturnType<typeof useCompanyUpdateFlowsMutation>;
export type CompanyUpdateFlowsMutationResult = Apollo.MutationResult<ICompanyUpdateFlowsMutation>;
export type CompanyUpdateFlowsMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateFlowsMutation, ICompanyUpdateFlowsMutationVariables>;
export const CompanyUpdateOrgsDocument = gql`
    mutation companyUpdateOrgs($companyId: ID!, $organizationId: ID!, $trained: Boolean, $approved: Boolean, $operationType: OperationType!) {
  companyUpdateOrganization(
    companyId: $companyId
    organizationId: $organizationId
    trained: $trained
    approved: $approved
    operationType: $operationType
  )
}
    `;
export type ICompanyUpdateOrgsMutationFn = Apollo.MutationFunction<ICompanyUpdateOrgsMutation, ICompanyUpdateOrgsMutationVariables>;

/**
 * __useCompanyUpdateOrgsMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateOrgsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateOrgsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateOrgsMutation, { data, loading, error }] = useCompanyUpdateOrgsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      organizationId: // value for 'organizationId'
 *      trained: // value for 'trained'
 *      approved: // value for 'approved'
 *      operationType: // value for 'operationType'
 *   },
 * });
 */
export function useCompanyUpdateOrgsMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateOrgsMutation, ICompanyUpdateOrgsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateOrgsMutation, ICompanyUpdateOrgsMutationVariables>(CompanyUpdateOrgsDocument, options);
      }
export type CompanyUpdateOrgsMutationHookResult = ReturnType<typeof useCompanyUpdateOrgsMutation>;
export type CompanyUpdateOrgsMutationResult = Apollo.MutationResult<ICompanyUpdateOrgsMutation>;
export type CompanyUpdateOrgsMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateOrgsMutation, ICompanyUpdateOrgsMutationVariables>;
export const CompanyUpdateStatusDocument = gql`
    mutation companyUpdateStatus($id: ID!, $status: CompanyStatus) {
  companyUpdateStatus(companyId: $id, status: $status)
}
    `;
export type ICompanyUpdateStatusMutationFn = Apollo.MutationFunction<ICompanyUpdateStatusMutation, ICompanyUpdateStatusMutationVariables>;

/**
 * __useCompanyUpdateStatusMutation__
 *
 * To run a mutation, you first call `useCompanyUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyUpdateStatusMutation, { data, loading, error }] = useCompanyUpdateStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCompanyUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<ICompanyUpdateStatusMutation, ICompanyUpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICompanyUpdateStatusMutation, ICompanyUpdateStatusMutationVariables>(CompanyUpdateStatusDocument, options);
      }
export type CompanyUpdateStatusMutationHookResult = ReturnType<typeof useCompanyUpdateStatusMutation>;
export type CompanyUpdateStatusMutationResult = Apollo.MutationResult<ICompanyUpdateStatusMutation>;
export type CompanyUpdateStatusMutationOptions = Apollo.BaseMutationOptions<ICompanyUpdateStatusMutation, ICompanyUpdateStatusMutationVariables>;
export const CreateEstimateDocument = gql`
    mutation createEstimate($jobId: ID!, $claimId: ID) {
  createEstimate(jobId: $jobId, claimId: $claimId) {
    id
    jobId
    status
    claimId
    jobId
    revision {
      id
      revisionNumber
      revisionName
      totalCost
      totalCalcType
      customerTotalCost
      status
      attachments {
        count
        data {
          id
          url
          name
          length
          contentType
          note
          status
          checksum
        }
      }
      rooms {
        count
        items {
          id
          revisionId
          totalCost
          name
          notes {
            items {
              id
              note
            }
            count
          }
          lineItems {
            count
            items {
              id
              roomId
              quantity
              totalCost
              measurementUnit
              title {
                id
                isNoteMandatory
                measurementsUnitId
                measurementsUnitHint
                measurementsUnit
                name
                noteHint
              }
              ...EstimateLineItemSubfields
            }
          }
        }
      }
    }
  }
}
    ${EstimateLineItemSubfieldsFragmentDoc}`;
export type ICreateEstimateMutationFn = Apollo.MutationFunction<ICreateEstimateMutation, ICreateEstimateMutationVariables>;

/**
 * __useCreateEstimateMutation__
 *
 * To run a mutation, you first call `useCreateEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateMutation, { data, loading, error }] = useCreateEstimateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useCreateEstimateMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEstimateMutation, ICreateEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEstimateMutation, ICreateEstimateMutationVariables>(CreateEstimateDocument, options);
      }
export type CreateEstimateMutationHookResult = ReturnType<typeof useCreateEstimateMutation>;
export type CreateEstimateMutationResult = Apollo.MutationResult<ICreateEstimateMutation>;
export type CreateEstimateMutationOptions = Apollo.BaseMutationOptions<ICreateEstimateMutation, ICreateEstimateMutationVariables>;
export const CreateEstimateLineItemDocument = gql`
    mutation createEstimateLineItem($roomId: ID!, $reqBody: LineItemBody!) {
  createLineItem(roomId: $roomId, reqBody: $reqBody) {
    id
    roomId
    quantity
    totalCost
    measurementUnit
    title {
      id
      isNoteMandatory
      measurementsUnitId
      measurementsUnitHint
      measurementsUnit
      name
      noteHint
    }
    ...EstimateLineItemSubfields
  }
}
    ${EstimateLineItemSubfieldsFragmentDoc}`;
export type ICreateEstimateLineItemMutationFn = Apollo.MutationFunction<ICreateEstimateLineItemMutation, ICreateEstimateLineItemMutationVariables>;

/**
 * __useCreateEstimateLineItemMutation__
 *
 * To run a mutation, you first call `useCreateEstimateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateLineItemMutation, { data, loading, error }] = useCreateEstimateLineItemMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      reqBody: // value for 'reqBody'
 *   },
 * });
 */
export function useCreateEstimateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEstimateLineItemMutation, ICreateEstimateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEstimateLineItemMutation, ICreateEstimateLineItemMutationVariables>(CreateEstimateLineItemDocument, options);
      }
export type CreateEstimateLineItemMutationHookResult = ReturnType<typeof useCreateEstimateLineItemMutation>;
export type CreateEstimateLineItemMutationResult = Apollo.MutationResult<ICreateEstimateLineItemMutation>;
export type CreateEstimateLineItemMutationOptions = Apollo.BaseMutationOptions<ICreateEstimateLineItemMutation, ICreateEstimateLineItemMutationVariables>;
export const CreateEstimatePdfDocument = gql`
    mutation createEstimatePdf($id: ID!) {
  createEstimatePdf(id: $id) {
    types {
      status
      type
    }
  }
}
    `;
export type ICreateEstimatePdfMutationFn = Apollo.MutationFunction<ICreateEstimatePdfMutation, ICreateEstimatePdfMutationVariables>;

/**
 * __useCreateEstimatePdfMutation__
 *
 * To run a mutation, you first call `useCreateEstimatePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimatePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimatePdfMutation, { data, loading, error }] = useCreateEstimatePdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateEstimatePdfMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEstimatePdfMutation, ICreateEstimatePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEstimatePdfMutation, ICreateEstimatePdfMutationVariables>(CreateEstimatePdfDocument, options);
      }
export type CreateEstimatePdfMutationHookResult = ReturnType<typeof useCreateEstimatePdfMutation>;
export type CreateEstimatePdfMutationResult = Apollo.MutationResult<ICreateEstimatePdfMutation>;
export type CreateEstimatePdfMutationOptions = Apollo.BaseMutationOptions<ICreateEstimatePdfMutation, ICreateEstimatePdfMutationVariables>;
export const CreateEstimateRevisionDocument = gql`
    mutation createEstimateRevision($id: ID!, $revisionName: String, $revisionNumber: Int) {
  createEstimateRevision(
    id: $id
    revisionName: $revisionName
    revisionNumber: $revisionNumber
  ) {
    id
    revisionNumber
    revisionName
    totalCost
    totalCalcType
    customerTotalCost
    status
    attachments {
      count
      data {
        id
        url
        name
        length
        contentType
        note
        status
        checksum
      }
    }
    rooms {
      count
      items {
        id
        revisionId
        totalCost
        name
        notes {
          items {
            id
            note
          }
          count
        }
        lineItems {
          count
          items {
            id
            roomId
            measurementUnit
            title {
              id
              isNoteMandatory
              measurementsUnitId
              measurementsUnitHint
              measurementsUnit
              name
              noteHint
            }
            grade {
              id
              name
            }
            type {
              id
              name
            }
            action {
              id
              name
            }
            quantity
            totalCost
            notes {
              id
              note
            }
          }
        }
      }
    }
  }
}
    `;
export type ICreateEstimateRevisionMutationFn = Apollo.MutationFunction<ICreateEstimateRevisionMutation, ICreateEstimateRevisionMutationVariables>;

/**
 * __useCreateEstimateRevisionMutation__
 *
 * To run a mutation, you first call `useCreateEstimateRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateRevisionMutation, { data, loading, error }] = useCreateEstimateRevisionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      revisionName: // value for 'revisionName'
 *      revisionNumber: // value for 'revisionNumber'
 *   },
 * });
 */
export function useCreateEstimateRevisionMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEstimateRevisionMutation, ICreateEstimateRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEstimateRevisionMutation, ICreateEstimateRevisionMutationVariables>(CreateEstimateRevisionDocument, options);
      }
export type CreateEstimateRevisionMutationHookResult = ReturnType<typeof useCreateEstimateRevisionMutation>;
export type CreateEstimateRevisionMutationResult = Apollo.MutationResult<ICreateEstimateRevisionMutation>;
export type CreateEstimateRevisionMutationOptions = Apollo.BaseMutationOptions<ICreateEstimateRevisionMutation, ICreateEstimateRevisionMutationVariables>;
export const CreateEstimateRoomDocument = gql`
    mutation createEstimateRoom($revisionId: ID!, $name: String, $note: String) {
  createRoom(id: $revisionId, name: $name, note: $note) {
    id
    name
    totalCost
    notes {
      count
      items {
        id
        note
      }
    }
  }
}
    `;
export type ICreateEstimateRoomMutationFn = Apollo.MutationFunction<ICreateEstimateRoomMutation, ICreateEstimateRoomMutationVariables>;

/**
 * __useCreateEstimateRoomMutation__
 *
 * To run a mutation, you first call `useCreateEstimateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstimateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstimateRoomMutation, { data, loading, error }] = useCreateEstimateRoomMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      name: // value for 'name'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateEstimateRoomMutation(baseOptions?: Apollo.MutationHookOptions<ICreateEstimateRoomMutation, ICreateEstimateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateEstimateRoomMutation, ICreateEstimateRoomMutationVariables>(CreateEstimateRoomDocument, options);
      }
export type CreateEstimateRoomMutationHookResult = ReturnType<typeof useCreateEstimateRoomMutation>;
export type CreateEstimateRoomMutationResult = Apollo.MutationResult<ICreateEstimateRoomMutation>;
export type CreateEstimateRoomMutationOptions = Apollo.BaseMutationOptions<ICreateEstimateRoomMutation, ICreateEstimateRoomMutationVariables>;
export const CreateTwilioVerificationServiceDocument = gql`
    mutation createTwilioVerificationService($to: String!, $method: VerificationMethod) {
  createTwilioVerificationInstance(to: $to, method: $method) {
    status
  }
}
    `;
export type ICreateTwilioVerificationServiceMutationFn = Apollo.MutationFunction<ICreateTwilioVerificationServiceMutation, ICreateTwilioVerificationServiceMutationVariables>;

/**
 * __useCreateTwilioVerificationServiceMutation__
 *
 * To run a mutation, you first call `useCreateTwilioVerificationServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioVerificationServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioVerificationServiceMutation, { data, loading, error }] = useCreateTwilioVerificationServiceMutation({
 *   variables: {
 *      to: // value for 'to'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useCreateTwilioVerificationServiceMutation(baseOptions?: Apollo.MutationHookOptions<ICreateTwilioVerificationServiceMutation, ICreateTwilioVerificationServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateTwilioVerificationServiceMutation, ICreateTwilioVerificationServiceMutationVariables>(CreateTwilioVerificationServiceDocument, options);
      }
export type CreateTwilioVerificationServiceMutationHookResult = ReturnType<typeof useCreateTwilioVerificationServiceMutation>;
export type CreateTwilioVerificationServiceMutationResult = Apollo.MutationResult<ICreateTwilioVerificationServiceMutation>;
export type CreateTwilioVerificationServiceMutationOptions = Apollo.BaseMutationOptions<ICreateTwilioVerificationServiceMutation, ICreateTwilioVerificationServiceMutationVariables>;
export const DeleteEstimateAttachmentDocument = gql`
    mutation deleteEstimateAttachment($revisionId: ID!, $attachmentId: ID!) {
  deleteEstimateRevisionAttachment(
    attachmentId: $attachmentId
    revisionId: $revisionId
  )
}
    `;
export type IDeleteEstimateAttachmentMutationFn = Apollo.MutationFunction<IDeleteEstimateAttachmentMutation, IDeleteEstimateAttachmentMutationVariables>;

/**
 * __useDeleteEstimateAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteEstimateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstimateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstimateAttachmentMutation, { data, loading, error }] = useDeleteEstimateAttachmentMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteEstimateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEstimateAttachmentMutation, IDeleteEstimateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEstimateAttachmentMutation, IDeleteEstimateAttachmentMutationVariables>(DeleteEstimateAttachmentDocument, options);
      }
export type DeleteEstimateAttachmentMutationHookResult = ReturnType<typeof useDeleteEstimateAttachmentMutation>;
export type DeleteEstimateAttachmentMutationResult = Apollo.MutationResult<IDeleteEstimateAttachmentMutation>;
export type DeleteEstimateAttachmentMutationOptions = Apollo.BaseMutationOptions<IDeleteEstimateAttachmentMutation, IDeleteEstimateAttachmentMutationVariables>;
export const DeleteEstimateLineItemDocument = gql`
    mutation deleteEstimateLineItem($lineItemId: ID!) {
  deleteLineItem(id: $lineItemId)
}
    `;
export type IDeleteEstimateLineItemMutationFn = Apollo.MutationFunction<IDeleteEstimateLineItemMutation, IDeleteEstimateLineItemMutationVariables>;

/**
 * __useDeleteEstimateLineItemMutation__
 *
 * To run a mutation, you first call `useDeleteEstimateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstimateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstimateLineItemMutation, { data, loading, error }] = useDeleteEstimateLineItemMutation({
 *   variables: {
 *      lineItemId: // value for 'lineItemId'
 *   },
 * });
 */
export function useDeleteEstimateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEstimateLineItemMutation, IDeleteEstimateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEstimateLineItemMutation, IDeleteEstimateLineItemMutationVariables>(DeleteEstimateLineItemDocument, options);
      }
export type DeleteEstimateLineItemMutationHookResult = ReturnType<typeof useDeleteEstimateLineItemMutation>;
export type DeleteEstimateLineItemMutationResult = Apollo.MutationResult<IDeleteEstimateLineItemMutation>;
export type DeleteEstimateLineItemMutationOptions = Apollo.BaseMutationOptions<IDeleteEstimateLineItemMutation, IDeleteEstimateLineItemMutationVariables>;
export const DeleteEstimateRevisionDocument = gql`
    mutation deleteEstimateRevision($revisionId: ID!) {
  deleteEstimateRevision(id: $revisionId)
}
    `;
export type IDeleteEstimateRevisionMutationFn = Apollo.MutationFunction<IDeleteEstimateRevisionMutation, IDeleteEstimateRevisionMutationVariables>;

/**
 * __useDeleteEstimateRevisionMutation__
 *
 * To run a mutation, you first call `useDeleteEstimateRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstimateRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstimateRevisionMutation, { data, loading, error }] = useDeleteEstimateRevisionMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *   },
 * });
 */
export function useDeleteEstimateRevisionMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEstimateRevisionMutation, IDeleteEstimateRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEstimateRevisionMutation, IDeleteEstimateRevisionMutationVariables>(DeleteEstimateRevisionDocument, options);
      }
export type DeleteEstimateRevisionMutationHookResult = ReturnType<typeof useDeleteEstimateRevisionMutation>;
export type DeleteEstimateRevisionMutationResult = Apollo.MutationResult<IDeleteEstimateRevisionMutation>;
export type DeleteEstimateRevisionMutationOptions = Apollo.BaseMutationOptions<IDeleteEstimateRevisionMutation, IDeleteEstimateRevisionMutationVariables>;
export const DeleteEstimateRoomDocument = gql`
    mutation deleteEstimateRoom($roomId: ID!, $revisionId: ID!) {
  deleteRoom(revisionId: $revisionId, roomId: $roomId)
}
    `;
export type IDeleteEstimateRoomMutationFn = Apollo.MutationFunction<IDeleteEstimateRoomMutation, IDeleteEstimateRoomMutationVariables>;

/**
 * __useDeleteEstimateRoomMutation__
 *
 * To run a mutation, you first call `useDeleteEstimateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstimateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstimateRoomMutation, { data, loading, error }] = useDeleteEstimateRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      revisionId: // value for 'revisionId'
 *   },
 * });
 */
export function useDeleteEstimateRoomMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteEstimateRoomMutation, IDeleteEstimateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteEstimateRoomMutation, IDeleteEstimateRoomMutationVariables>(DeleteEstimateRoomDocument, options);
      }
export type DeleteEstimateRoomMutationHookResult = ReturnType<typeof useDeleteEstimateRoomMutation>;
export type DeleteEstimateRoomMutationResult = Apollo.MutationResult<IDeleteEstimateRoomMutation>;
export type DeleteEstimateRoomMutationOptions = Apollo.BaseMutationOptions<IDeleteEstimateRoomMutation, IDeleteEstimateRoomMutationVariables>;
export const DeleteRoomAttachmentDocument = gql`
    mutation deleteRoomAttachment($roomId: ID!, $attachmentId: ID!) {
  deleteRoomAttachment(roomId: $roomId, attachmentId: $attachmentId)
}
    `;
export type IDeleteRoomAttachmentMutationFn = Apollo.MutationFunction<IDeleteRoomAttachmentMutation, IDeleteRoomAttachmentMutationVariables>;

/**
 * __useDeleteRoomAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteRoomAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomAttachmentMutation, { data, loading, error }] = useDeleteRoomAttachmentMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteRoomAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteRoomAttachmentMutation, IDeleteRoomAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteRoomAttachmentMutation, IDeleteRoomAttachmentMutationVariables>(DeleteRoomAttachmentDocument, options);
      }
export type DeleteRoomAttachmentMutationHookResult = ReturnType<typeof useDeleteRoomAttachmentMutation>;
export type DeleteRoomAttachmentMutationResult = Apollo.MutationResult<IDeleteRoomAttachmentMutation>;
export type DeleteRoomAttachmentMutationOptions = Apollo.BaseMutationOptions<IDeleteRoomAttachmentMutation, IDeleteRoomAttachmentMutationVariables>;
export const EmailJobMediaDocument = gql`
    mutation emailJobMedia($jobId: ID!) {
  emailJobMedia(jobId: $jobId)
}
    `;
export type IEmailJobMediaMutationFn = Apollo.MutationFunction<IEmailJobMediaMutation, IEmailJobMediaMutationVariables>;

/**
 * __useEmailJobMediaMutation__
 *
 * To run a mutation, you first call `useEmailJobMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailJobMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailJobMediaMutation, { data, loading, error }] = useEmailJobMediaMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useEmailJobMediaMutation(baseOptions?: Apollo.MutationHookOptions<IEmailJobMediaMutation, IEmailJobMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IEmailJobMediaMutation, IEmailJobMediaMutationVariables>(EmailJobMediaDocument, options);
      }
export type EmailJobMediaMutationHookResult = ReturnType<typeof useEmailJobMediaMutation>;
export type EmailJobMediaMutationResult = Apollo.MutationResult<IEmailJobMediaMutation>;
export type EmailJobMediaMutationOptions = Apollo.BaseMutationOptions<IEmailJobMediaMutation, IEmailJobMediaMutationVariables>;
export const EmailProviderReceiptDocument = gql`
    mutation emailProviderReceipt($consolidatedJobId: ID!, $sendToInternal: Boolean) {
  emailProviderReceipt(
    consolidatedJobId: $consolidatedJobId
    sendToInternal: $sendToInternal
  )
}
    `;
export type IEmailProviderReceiptMutationFn = Apollo.MutationFunction<IEmailProviderReceiptMutation, IEmailProviderReceiptMutationVariables>;

/**
 * __useEmailProviderReceiptMutation__
 *
 * To run a mutation, you first call `useEmailProviderReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailProviderReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailProviderReceiptMutation, { data, loading, error }] = useEmailProviderReceiptMutation({
 *   variables: {
 *      consolidatedJobId: // value for 'consolidatedJobId'
 *      sendToInternal: // value for 'sendToInternal'
 *   },
 * });
 */
export function useEmailProviderReceiptMutation(baseOptions?: Apollo.MutationHookOptions<IEmailProviderReceiptMutation, IEmailProviderReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IEmailProviderReceiptMutation, IEmailProviderReceiptMutationVariables>(EmailProviderReceiptDocument, options);
      }
export type EmailProviderReceiptMutationHookResult = ReturnType<typeof useEmailProviderReceiptMutation>;
export type EmailProviderReceiptMutationResult = Apollo.MutationResult<IEmailProviderReceiptMutation>;
export type EmailProviderReceiptMutationOptions = Apollo.BaseMutationOptions<IEmailProviderReceiptMutation, IEmailProviderReceiptMutationVariables>;
export const SubmitEstimateDocument = gql`
    mutation submitEstimate($revisionId: ID!) {
  submitEstimate(revisionId: $revisionId)
}
    `;
export type ISubmitEstimateMutationFn = Apollo.MutationFunction<ISubmitEstimateMutation, ISubmitEstimateMutationVariables>;

/**
 * __useSubmitEstimateMutation__
 *
 * To run a mutation, you first call `useSubmitEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEstimateMutation, { data, loading, error }] = useSubmitEstimateMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *   },
 * });
 */
export function useSubmitEstimateMutation(baseOptions?: Apollo.MutationHookOptions<ISubmitEstimateMutation, ISubmitEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISubmitEstimateMutation, ISubmitEstimateMutationVariables>(SubmitEstimateDocument, options);
      }
export type SubmitEstimateMutationHookResult = ReturnType<typeof useSubmitEstimateMutation>;
export type SubmitEstimateMutationResult = Apollo.MutationResult<ISubmitEstimateMutation>;
export type SubmitEstimateMutationOptions = Apollo.BaseMutationOptions<ISubmitEstimateMutation, ISubmitEstimateMutationVariables>;
export const UpdateCompanyDetailsDocument = gql`
    mutation updateCompanyDetails($companyId: ID!, $details: UpdateCompanyDetails) {
  updateCompanyDetails(companyId: $companyId, details: $details) {
    ...CompanyRowFields
    description
    phoneNumber
    phoneNumberAfterHours
    acceptedTermsAndConditions
    servicesCount
    averageRating
    assignee {
      userId
    }
    parent {
      id
      name
    }
    services {
      id
      iconName
      name
    }
    serviceAreas {
      marketId
      marketName
      postalCodes
    }
    owners {
      hubspotId
      status
      isProfileGorilla
      externalId
      isActive
      email
      isGhost
      id
      stripeAccountId
      stripeCustomerId
      userProfile {
        firstName
        lastName
        mobile
      }
    }
    organizations {
      trained
      approved
      name
      organizationId
    }
    bankAccount {
      id
      bankName
      accountNumberLast4
      meetsRequirements
    }
    stripeId
    symbilityId
    flows {
      code
      name
      description
    }
  }
}
    ${CompanyRowFieldsFragmentDoc}`;
export type IUpdateCompanyDetailsMutationFn = Apollo.MutationFunction<IUpdateCompanyDetailsMutation, IUpdateCompanyDetailsMutationVariables>;

/**
 * __useUpdateCompanyDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDetailsMutation, { data, loading, error }] = useUpdateCompanyDetailsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useUpdateCompanyDetailsMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateCompanyDetailsMutation, IUpdateCompanyDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateCompanyDetailsMutation, IUpdateCompanyDetailsMutationVariables>(UpdateCompanyDetailsDocument, options);
      }
export type UpdateCompanyDetailsMutationHookResult = ReturnType<typeof useUpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationResult = Apollo.MutationResult<IUpdateCompanyDetailsMutation>;
export type UpdateCompanyDetailsMutationOptions = Apollo.BaseMutationOptions<IUpdateCompanyDetailsMutation, IUpdateCompanyDetailsMutationVariables>;
export const UpdateEstimateDocument = gql`
    mutation updateEstimate($jobId: ID, $claimId: ID, $estimateId: ID!) {
  updateEstimate(claimId: $claimId, jobId: $jobId, estimateId: $estimateId) {
    id
    claimId
    jobId
  }
}
    `;
export type IUpdateEstimateMutationFn = Apollo.MutationFunction<IUpdateEstimateMutation, IUpdateEstimateMutationVariables>;

/**
 * __useUpdateEstimateMutation__
 *
 * To run a mutation, you first call `useUpdateEstimateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstimateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstimateMutation, { data, loading, error }] = useUpdateEstimateMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      claimId: // value for 'claimId'
 *      estimateId: // value for 'estimateId'
 *   },
 * });
 */
export function useUpdateEstimateMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEstimateMutation, IUpdateEstimateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEstimateMutation, IUpdateEstimateMutationVariables>(UpdateEstimateDocument, options);
      }
export type UpdateEstimateMutationHookResult = ReturnType<typeof useUpdateEstimateMutation>;
export type UpdateEstimateMutationResult = Apollo.MutationResult<IUpdateEstimateMutation>;
export type UpdateEstimateMutationOptions = Apollo.BaseMutationOptions<IUpdateEstimateMutation, IUpdateEstimateMutationVariables>;
export const UpdateEstimateLineItemDocument = gql`
    mutation updateEstimateLineItem($lineItemId: ID!, $reqBody: LineItemBody!) {
  updateLineItem(id: $lineItemId, reqBody: $reqBody) {
    id
    roomId
    quantity
    totalCost
    measurementUnit
    title {
      id
      isNoteMandatory
      measurementsUnitId
      measurementsUnitHint
      measurementsUnit
      name
      noteHint
    }
    ...EstimateLineItemSubfields
  }
}
    ${EstimateLineItemSubfieldsFragmentDoc}`;
export type IUpdateEstimateLineItemMutationFn = Apollo.MutationFunction<IUpdateEstimateLineItemMutation, IUpdateEstimateLineItemMutationVariables>;

/**
 * __useUpdateEstimateLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateEstimateLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstimateLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstimateLineItemMutation, { data, loading, error }] = useUpdateEstimateLineItemMutation({
 *   variables: {
 *      lineItemId: // value for 'lineItemId'
 *      reqBody: // value for 'reqBody'
 *   },
 * });
 */
export function useUpdateEstimateLineItemMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEstimateLineItemMutation, IUpdateEstimateLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEstimateLineItemMutation, IUpdateEstimateLineItemMutationVariables>(UpdateEstimateLineItemDocument, options);
      }
export type UpdateEstimateLineItemMutationHookResult = ReturnType<typeof useUpdateEstimateLineItemMutation>;
export type UpdateEstimateLineItemMutationResult = Apollo.MutationResult<IUpdateEstimateLineItemMutation>;
export type UpdateEstimateLineItemMutationOptions = Apollo.BaseMutationOptions<IUpdateEstimateLineItemMutation, IUpdateEstimateLineItemMutationVariables>;
export const UpdateEstimateRevisionDocument = gql`
    mutation updateEstimateRevision($revisionId: ID!, $revisionName: String, $status: EstimateStatus, $totalCost: Float, $totalCalcType: EstimatePricingModel, $customerTotalCost: Float, $jobId: ID) {
  updateEstimateRevision(
    id: $revisionId
    jobId: $jobId
    revisionName: $revisionName
    status: $status
    totalCost: $totalCost
    totalCalcType: $totalCalcType
    customerTotalCost: $customerTotalCost
  ) {
    id
    revisionNumber
    revisionName
    status
    totalCost
    customerTotalCost
    totalCalcType
    attachments {
      count
      data {
        id
        url
        name
        contentType
        note
        status
      }
    }
    rooms {
      count
      items {
        id
        revisionId
        totalCost
        name
        lineItems {
          count
          items {
            id
            measurementUnit
            roomId
            title {
              id
              isNoteMandatory
              measurementsUnitId
              measurementsUnitHint
              measurementsUnit
              name
              noteHint
            }
            grade {
              id
              name
            }
            type {
              id
              name
            }
            action {
              id
              name
            }
            quantity
            totalCost
            notes {
              id
              note
            }
          }
        }
      }
    }
  }
}
    `;
export type IUpdateEstimateRevisionMutationFn = Apollo.MutationFunction<IUpdateEstimateRevisionMutation, IUpdateEstimateRevisionMutationVariables>;

/**
 * __useUpdateEstimateRevisionMutation__
 *
 * To run a mutation, you first call `useUpdateEstimateRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstimateRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstimateRevisionMutation, { data, loading, error }] = useUpdateEstimateRevisionMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      revisionName: // value for 'revisionName'
 *      status: // value for 'status'
 *      totalCost: // value for 'totalCost'
 *      totalCalcType: // value for 'totalCalcType'
 *      customerTotalCost: // value for 'customerTotalCost'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useUpdateEstimateRevisionMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEstimateRevisionMutation, IUpdateEstimateRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEstimateRevisionMutation, IUpdateEstimateRevisionMutationVariables>(UpdateEstimateRevisionDocument, options);
      }
export type UpdateEstimateRevisionMutationHookResult = ReturnType<typeof useUpdateEstimateRevisionMutation>;
export type UpdateEstimateRevisionMutationResult = Apollo.MutationResult<IUpdateEstimateRevisionMutation>;
export type UpdateEstimateRevisionMutationOptions = Apollo.BaseMutationOptions<IUpdateEstimateRevisionMutation, IUpdateEstimateRevisionMutationVariables>;
export const UpdateEstimateRoomDocument = gql`
    mutation updateEstimateRoom($roomId: ID!, $revisionId: ID!, $name: String, $totalCost: Float!, $note: String, $noteId: ID) {
  updateRoom(
    id: $roomId
    revisionId: $revisionId
    name: $name
    totalCost: $totalCost
    note: $note
    noteId: $noteId
  ) {
    id
    name
    totalCost
    notes {
      count
      items {
        id
        note
      }
    }
  }
}
    `;
export type IUpdateEstimateRoomMutationFn = Apollo.MutationFunction<IUpdateEstimateRoomMutation, IUpdateEstimateRoomMutationVariables>;

/**
 * __useUpdateEstimateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateEstimateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstimateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstimateRoomMutation, { data, loading, error }] = useUpdateEstimateRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      revisionId: // value for 'revisionId'
 *      name: // value for 'name'
 *      totalCost: // value for 'totalCost'
 *      note: // value for 'note'
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useUpdateEstimateRoomMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEstimateRoomMutation, IUpdateEstimateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEstimateRoomMutation, IUpdateEstimateRoomMutationVariables>(UpdateEstimateRoomDocument, options);
      }
export type UpdateEstimateRoomMutationHookResult = ReturnType<typeof useUpdateEstimateRoomMutation>;
export type UpdateEstimateRoomMutationResult = Apollo.MutationResult<IUpdateEstimateRoomMutation>;
export type UpdateEstimateRoomMutationOptions = Apollo.BaseMutationOptions<IUpdateEstimateRoomMutation, IUpdateEstimateRoomMutationVariables>;
export const UpdateEstimateStatusDocument = gql`
    mutation updateEstimateStatus($revisionId: ID!, $status: EstimateStatus) {
  updateEstimateRevision(id: $revisionId, status: $status) {
    id
    status
    revisionNumber
    revisionName
    totalCost
  }
}
    `;
export type IUpdateEstimateStatusMutationFn = Apollo.MutationFunction<IUpdateEstimateStatusMutation, IUpdateEstimateStatusMutationVariables>;

/**
 * __useUpdateEstimateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEstimateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstimateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstimateStatusMutation, { data, loading, error }] = useUpdateEstimateStatusMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEstimateStatusMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateEstimateStatusMutation, IUpdateEstimateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateEstimateStatusMutation, IUpdateEstimateStatusMutationVariables>(UpdateEstimateStatusDocument, options);
      }
export type UpdateEstimateStatusMutationHookResult = ReturnType<typeof useUpdateEstimateStatusMutation>;
export type UpdateEstimateStatusMutationResult = Apollo.MutationResult<IUpdateEstimateStatusMutation>;
export type UpdateEstimateStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateEstimateStatusMutation, IUpdateEstimateStatusMutationVariables>;
export const UploadEstimateAttachmentDocument = gql`
    mutation uploadEstimateAttachment($revisionId: ID!, $file: Upload!, $length: Int!, $note: String, $carrierName: String, $contentType: String) {
  uploadEstimateAttachment(
    id: $revisionId
    file: $file
    length: $length
    note: $note
    carrierName: $carrierName
    contentType: $contentType
  ) {
    attachmentId
    url
  }
}
    `;
export type IUploadEstimateAttachmentMutationFn = Apollo.MutationFunction<IUploadEstimateAttachmentMutation, IUploadEstimateAttachmentMutationVariables>;

/**
 * __useUploadEstimateAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadEstimateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEstimateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEstimateAttachmentMutation, { data, loading, error }] = useUploadEstimateAttachmentMutation({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      file: // value for 'file'
 *      length: // value for 'length'
 *      note: // value for 'note'
 *      carrierName: // value for 'carrierName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useUploadEstimateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<IUploadEstimateAttachmentMutation, IUploadEstimateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUploadEstimateAttachmentMutation, IUploadEstimateAttachmentMutationVariables>(UploadEstimateAttachmentDocument, options);
      }
export type UploadEstimateAttachmentMutationHookResult = ReturnType<typeof useUploadEstimateAttachmentMutation>;
export type UploadEstimateAttachmentMutationResult = Apollo.MutationResult<IUploadEstimateAttachmentMutation>;
export type UploadEstimateAttachmentMutationOptions = Apollo.BaseMutationOptions<IUploadEstimateAttachmentMutation, IUploadEstimateAttachmentMutationVariables>;
export const UploadRoomAttachmentDocument = gql`
    mutation uploadRoomAttachment($id: ID!, $file: Upload!, $length: Int!, $note: String, $carrierName: String!) {
  uploadRoomAttachment(
    id: $id
    file: $file
    length: $length
    note: $note
    carrierName: $carrierName
  ) {
    attachmentId
    url
  }
}
    `;
export type IUploadRoomAttachmentMutationFn = Apollo.MutationFunction<IUploadRoomAttachmentMutation, IUploadRoomAttachmentMutationVariables>;

/**
 * __useUploadRoomAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadRoomAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadRoomAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadRoomAttachmentMutation, { data, loading, error }] = useUploadRoomAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      file: // value for 'file'
 *      length: // value for 'length'
 *      note: // value for 'note'
 *      carrierName: // value for 'carrierName'
 *   },
 * });
 */
export function useUploadRoomAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<IUploadRoomAttachmentMutation, IUploadRoomAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUploadRoomAttachmentMutation, IUploadRoomAttachmentMutationVariables>(UploadRoomAttachmentDocument, options);
      }
export type UploadRoomAttachmentMutationHookResult = ReturnType<typeof useUploadRoomAttachmentMutation>;
export type UploadRoomAttachmentMutationResult = Apollo.MutationResult<IUploadRoomAttachmentMutation>;
export type UploadRoomAttachmentMutationOptions = Apollo.BaseMutationOptions<IUploadRoomAttachmentMutation, IUploadRoomAttachmentMutationVariables>;
export const AvailableProvidersInMarketDocument = gql`
    query availableProvidersInMarket($marketId: ID!, $serviceTypes: [Int!], $startAfter: String) {
  getProviders(
    available: true
    first: 100
    marketId: $marketId
    serviceTypes: $serviceTypes
    startAfter: $startAfter
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      averageRating {
        rating
      }
      companies {
        name
      }
      email
      id
      jobCount
      location {
        lat
        lng
      }
      userProfile {
        firstName
        lastName
        mobile
        veteran
        zipcode
      }
      userServices {
        id
        license
        type
      }
    }
  }
}
    `;

/**
 * __useAvailableProvidersInMarketQuery__
 *
 * To run a query within a React component, call `useAvailableProvidersInMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProvidersInMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProvidersInMarketQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *      serviceTypes: // value for 'serviceTypes'
 *      startAfter: // value for 'startAfter'
 *   },
 * });
 */
export function useAvailableProvidersInMarketQuery(baseOptions: Apollo.QueryHookOptions<IAvailableProvidersInMarketQuery, IAvailableProvidersInMarketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAvailableProvidersInMarketQuery, IAvailableProvidersInMarketQueryVariables>(AvailableProvidersInMarketDocument, options);
      }
export function useAvailableProvidersInMarketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAvailableProvidersInMarketQuery, IAvailableProvidersInMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAvailableProvidersInMarketQuery, IAvailableProvidersInMarketQueryVariables>(AvailableProvidersInMarketDocument, options);
        }
export type AvailableProvidersInMarketQueryHookResult = ReturnType<typeof useAvailableProvidersInMarketQuery>;
export type AvailableProvidersInMarketLazyQueryHookResult = ReturnType<typeof useAvailableProvidersInMarketLazyQuery>;
export type AvailableProvidersInMarketQueryResult = Apollo.QueryResult<IAvailableProvidersInMarketQuery, IAvailableProvidersInMarketQueryVariables>;
export const GenerateTwilioCodeDocument = gql`
    query generateTwilioCode($phoneNumber: String!) {
  generateTwilioCode(phoneNumber: $phoneNumber) {
    code
  }
}
    `;

/**
 * __useGenerateTwilioCodeQuery__
 *
 * To run a query within a React component, call `useGenerateTwilioCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateTwilioCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateTwilioCodeQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGenerateTwilioCodeQuery(baseOptions: Apollo.QueryHookOptions<IGenerateTwilioCodeQuery, IGenerateTwilioCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGenerateTwilioCodeQuery, IGenerateTwilioCodeQueryVariables>(GenerateTwilioCodeDocument, options);
      }
export function useGenerateTwilioCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGenerateTwilioCodeQuery, IGenerateTwilioCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGenerateTwilioCodeQuery, IGenerateTwilioCodeQueryVariables>(GenerateTwilioCodeDocument, options);
        }
export type GenerateTwilioCodeQueryHookResult = ReturnType<typeof useGenerateTwilioCodeQuery>;
export type GenerateTwilioCodeLazyQueryHookResult = ReturnType<typeof useGenerateTwilioCodeLazyQuery>;
export type GenerateTwilioCodeQueryResult = Apollo.QueryResult<IGenerateTwilioCodeQuery, IGenerateTwilioCodeQueryVariables>;
export const GetChildCompaniesDocument = gql`
    query getChildCompanies($id: ID!) {
  getChildCompanies(id: $id) {
    edges {
      ...CompanyRowFields
      addresses {
        physical {
          addressLine1
          addressLine2
          state
          postalCode
          country
          city
        }
        mailing {
          addressLine1
          addressLine2
          state
          postalCode
          country
          city
        }
      }
      employeeCount
      activeJobCount
      serviceAreas {
        postalCodes
        marketName
        marketId
      }
      servicesCount
    }
    totalCount
  }
}
    ${CompanyRowFieldsFragmentDoc}`;

/**
 * __useGetChildCompaniesQuery__
 *
 * To run a query within a React component, call `useGetChildCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildCompaniesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChildCompaniesQuery(baseOptions: Apollo.QueryHookOptions<IGetChildCompaniesQuery, IGetChildCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetChildCompaniesQuery, IGetChildCompaniesQueryVariables>(GetChildCompaniesDocument, options);
      }
export function useGetChildCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetChildCompaniesQuery, IGetChildCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetChildCompaniesQuery, IGetChildCompaniesQueryVariables>(GetChildCompaniesDocument, options);
        }
export type GetChildCompaniesQueryHookResult = ReturnType<typeof useGetChildCompaniesQuery>;
export type GetChildCompaniesLazyQueryHookResult = ReturnType<typeof useGetChildCompaniesLazyQuery>;
export type GetChildCompaniesQueryResult = Apollo.QueryResult<IGetChildCompaniesQuery, IGetChildCompaniesQueryVariables>;
export const GetAssociatedClaimJobsDocument = gql`
    query getAssociatedClaimJobs($consolidatedJobIds: [ID]!) {
  getJobs(consolidatedJobIds: $consolidatedJobIds) {
    edges {
      id
      code
      serviceType
      subBucketLabel
      code
      estimateId
      serviceRequestType {
        name
      }
      consumerRequestId
      workorderId
    }
  }
}
    `;

/**
 * __useGetAssociatedClaimJobsQuery__
 *
 * To run a query within a React component, call `useGetAssociatedClaimJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssociatedClaimJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssociatedClaimJobsQuery({
 *   variables: {
 *      consolidatedJobIds: // value for 'consolidatedJobIds'
 *   },
 * });
 */
export function useGetAssociatedClaimJobsQuery(baseOptions: Apollo.QueryHookOptions<IGetAssociatedClaimJobsQuery, IGetAssociatedClaimJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAssociatedClaimJobsQuery, IGetAssociatedClaimJobsQueryVariables>(GetAssociatedClaimJobsDocument, options);
      }
export function useGetAssociatedClaimJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAssociatedClaimJobsQuery, IGetAssociatedClaimJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAssociatedClaimJobsQuery, IGetAssociatedClaimJobsQueryVariables>(GetAssociatedClaimJobsDocument, options);
        }
export type GetAssociatedClaimJobsQueryHookResult = ReturnType<typeof useGetAssociatedClaimJobsQuery>;
export type GetAssociatedClaimJobsLazyQueryHookResult = ReturnType<typeof useGetAssociatedClaimJobsLazyQuery>;
export type GetAssociatedClaimJobsQueryResult = Apollo.QueryResult<IGetAssociatedClaimJobsQuery, IGetAssociatedClaimJobsQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments($commentThreadId: ID!) {
  getComments(commentThreadId: $commentThreadId) {
    id
    userId
    userName
    userRoles
    body
    updatedAt
    createdAt
    deleted
    isInternalOnly
    hiddenBy
    hiddenByName
    replies {
      id
      userId
      userName
      userRoles
      body
      updatedAt
      createdAt
      deleted
      isInternalOnly
      hiddenBy
      hiddenByName
    }
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      commentThreadId: // value for 'commentThreadId'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<IGetCommentsQuery, IGetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCommentsQuery, IGetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCommentsQuery, IGetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCommentsQuery, IGetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<IGetCommentsQuery, IGetCommentsQueryVariables>;
export const GetCommentsIdDocument = gql`
    query getCommentsId($commentThreadId: ID!) {
  getComments(commentThreadId: $commentThreadId) {
    id
    deleted
    isInternalOnly
    replies {
      id
      deleted
      isInternalOnly
    }
  }
}
    `;

/**
 * __useGetCommentsIdQuery__
 *
 * To run a query within a React component, call `useGetCommentsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsIdQuery({
 *   variables: {
 *      commentThreadId: // value for 'commentThreadId'
 *   },
 * });
 */
export function useGetCommentsIdQuery(baseOptions: Apollo.QueryHookOptions<IGetCommentsIdQuery, IGetCommentsIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCommentsIdQuery, IGetCommentsIdQueryVariables>(GetCommentsIdDocument, options);
      }
export function useGetCommentsIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCommentsIdQuery, IGetCommentsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCommentsIdQuery, IGetCommentsIdQueryVariables>(GetCommentsIdDocument, options);
        }
export type GetCommentsIdQueryHookResult = ReturnType<typeof useGetCommentsIdQuery>;
export type GetCommentsIdLazyQueryHookResult = ReturnType<typeof useGetCommentsIdLazyQuery>;
export type GetCommentsIdQueryResult = Apollo.QueryResult<IGetCommentsIdQuery, IGetCommentsIdQueryVariables>;
export const GetCompaniesV2ListDocument = gql`
    query getCompaniesV2List($status: CompanyStatus, $availability: CompanyAvailability, $services: [String], $limit: Int, $offset: Int, $companyIds: [ID], $orderBy: CompanyOrderByType, $hasXactimateAddress: Boolean) {
  getCompaniesV2(
    status: $status
    availability: $availability
    services: $services
    limit: $limit
    offset: $offset
    companyIds: $companyIds
    orderBy: $orderBy
    hasXactimateAddress: $hasXactimateAddress
  ) {
    edges {
      ...CompanyRowFields
      serviceAreas {
        postalCodes
        marketName
        marketId
      }
      servicesCount
    }
    totalCount
  }
}
    ${CompanyRowFieldsFragmentDoc}`;

/**
 * __useGetCompaniesV2ListQuery__
 *
 * To run a query within a React component, call `useGetCompaniesV2ListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesV2ListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesV2ListQuery({
 *   variables: {
 *      status: // value for 'status'
 *      availability: // value for 'availability'
 *      services: // value for 'services'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      companyIds: // value for 'companyIds'
 *      orderBy: // value for 'orderBy'
 *      hasXactimateAddress: // value for 'hasXactimateAddress'
 *   },
 * });
 */
export function useGetCompaniesV2ListQuery(baseOptions?: Apollo.QueryHookOptions<IGetCompaniesV2ListQuery, IGetCompaniesV2ListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompaniesV2ListQuery, IGetCompaniesV2ListQueryVariables>(GetCompaniesV2ListDocument, options);
      }
export function useGetCompaniesV2ListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompaniesV2ListQuery, IGetCompaniesV2ListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompaniesV2ListQuery, IGetCompaniesV2ListQueryVariables>(GetCompaniesV2ListDocument, options);
        }
export type GetCompaniesV2ListQueryHookResult = ReturnType<typeof useGetCompaniesV2ListQuery>;
export type GetCompaniesV2ListLazyQueryHookResult = ReturnType<typeof useGetCompaniesV2ListLazyQuery>;
export type GetCompaniesV2ListQueryResult = Apollo.QueryResult<IGetCompaniesV2ListQuery, IGetCompaniesV2ListQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  getCompany(id: $id) {
    externalId
    employeeCount
    name
    address
    marketId
    website
    description
    createdAt
    code
    codeNumber
    updatedAt
    accountId
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<IGetCompanyQuery, IGetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompanyQuery, IGetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyQuery, IGetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompanyQuery, IGetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<IGetCompanyQuery, IGetCompanyQueryVariables>;
export const GetCompanyEmployeesDocument = gql`
    query getCompanyEmployees($id: ID!) {
  getCompanyEmployees(id: $id) {
    userId
    roles
  }
}
    `;

/**
 * __useGetCompanyEmployeesQuery__
 *
 * To run a query within a React component, call `useGetCompanyEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyEmployeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyEmployeesQuery(baseOptions: Apollo.QueryHookOptions<IGetCompanyEmployeesQuery, IGetCompanyEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompanyEmployeesQuery, IGetCompanyEmployeesQueryVariables>(GetCompanyEmployeesDocument, options);
      }
export function useGetCompanyEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyEmployeesQuery, IGetCompanyEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompanyEmployeesQuery, IGetCompanyEmployeesQueryVariables>(GetCompanyEmployeesDocument, options);
        }
export type GetCompanyEmployeesQueryHookResult = ReturnType<typeof useGetCompanyEmployeesQuery>;
export type GetCompanyEmployeesLazyQueryHookResult = ReturnType<typeof useGetCompanyEmployeesLazyQuery>;
export type GetCompanyEmployeesQueryResult = Apollo.QueryResult<IGetCompanyEmployeesQuery, IGetCompanyEmployeesQueryVariables>;
export const GetCompanyNameDocument = gql`
    query getCompanyName($id: ID) {
  getCompanyV2(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetCompanyNameQuery__
 *
 * To run a query within a React component, call `useGetCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyNameQuery(baseOptions?: Apollo.QueryHookOptions<IGetCompanyNameQuery, IGetCompanyNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompanyNameQuery, IGetCompanyNameQueryVariables>(GetCompanyNameDocument, options);
      }
export function useGetCompanyNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyNameQuery, IGetCompanyNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompanyNameQuery, IGetCompanyNameQueryVariables>(GetCompanyNameDocument, options);
        }
export type GetCompanyNameQueryHookResult = ReturnType<typeof useGetCompanyNameQuery>;
export type GetCompanyNameLazyQueryHookResult = ReturnType<typeof useGetCompanyNameLazyQuery>;
export type GetCompanyNameQueryResult = Apollo.QueryResult<IGetCompanyNameQuery, IGetCompanyNameQueryVariables>;
export const GetCompanyOptionsDocument = gql`
    query getCompanyOptions($status: CompanyStatus, $availability: CompanyAvailability, $services: [String], $limit: Int, $offset: Int, $serviceAreas: [String], $name: String, $orderBy: CompanyOrderByType, $hasSymbilityId: Boolean, $flows: [CompanyFlowLabel], $organizationIds: [String]) {
  getCompaniesV2(
    status: $status
    availability: $availability
    services: $services
    limit: $limit
    offset: $offset
    name: $name
    serviceAreas: $serviceAreas
    orderBy: $orderBy
    hasSymbilityId: $hasSymbilityId
    flows: $flows
    organizationIds: $organizationIds
  ) {
    edges {
      id
      name
    }
    totalCount
  }
}
    `;

/**
 * __useGetCompanyOptionsQuery__
 *
 * To run a query within a React component, call `useGetCompanyOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyOptionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      availability: // value for 'availability'
 *      services: // value for 'services'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      serviceAreas: // value for 'serviceAreas'
 *      name: // value for 'name'
 *      orderBy: // value for 'orderBy'
 *      hasSymbilityId: // value for 'hasSymbilityId'
 *      flows: // value for 'flows'
 *      organizationIds: // value for 'organizationIds'
 *   },
 * });
 */
export function useGetCompanyOptionsQuery(baseOptions?: Apollo.QueryHookOptions<IGetCompanyOptionsQuery, IGetCompanyOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompanyOptionsQuery, IGetCompanyOptionsQueryVariables>(GetCompanyOptionsDocument, options);
      }
export function useGetCompanyOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyOptionsQuery, IGetCompanyOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompanyOptionsQuery, IGetCompanyOptionsQueryVariables>(GetCompanyOptionsDocument, options);
        }
export type GetCompanyOptionsQueryHookResult = ReturnType<typeof useGetCompanyOptionsQuery>;
export type GetCompanyOptionsLazyQueryHookResult = ReturnType<typeof useGetCompanyOptionsLazyQuery>;
export type GetCompanyOptionsQueryResult = Apollo.QueryResult<IGetCompanyOptionsQuery, IGetCompanyOptionsQueryVariables>;
export const GetCompanyV2Document = gql`
    query getCompanyV2($id: ID!) {
  getCompanyV2(id: $id) {
    ...CompanyRowFields
    description
    phoneNumber
    phoneNumberAfterHours
    acceptedTermsAndConditions
    servicesCount
    averageRating
    assignee {
      userId
    }
    parent {
      id
      name
    }
    services {
      id
      iconName
      name
    }
    serviceAreas {
      marketId
      marketName
      postalCodes
    }
    owners {
      hubspotId
      status
      isProfileGorilla
      externalId
      isActive
      email
      isGhost
      id
      stripeAccountId
      stripeCustomerId
      userProfile {
        firstName
        lastName
        mobile
      }
    }
    organizations {
      trained
      approved
      name
      organizationId
    }
    bankAccount {
      id
      bankName
      accountNumberLast4
      meetsRequirements
    }
    stripeId
    symbilityId
    flows {
      code
      name
      description
    }
  }
}
    ${CompanyRowFieldsFragmentDoc}`;

/**
 * __useGetCompanyV2Query__
 *
 * To run a query within a React component, call `useGetCompanyV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyV2Query({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyV2Query(baseOptions: Apollo.QueryHookOptions<IGetCompanyV2Query, IGetCompanyV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetCompanyV2Query, IGetCompanyV2QueryVariables>(GetCompanyV2Document, options);
      }
export function useGetCompanyV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetCompanyV2Query, IGetCompanyV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetCompanyV2Query, IGetCompanyV2QueryVariables>(GetCompanyV2Document, options);
        }
export type GetCompanyV2QueryHookResult = ReturnType<typeof useGetCompanyV2Query>;
export type GetCompanyV2LazyQueryHookResult = ReturnType<typeof useGetCompanyV2LazyQuery>;
export type GetCompanyV2QueryResult = Apollo.QueryResult<IGetCompanyV2Query, IGetCompanyV2QueryVariables>;
export const GetConsumerRequestDocument = gql`
    query getConsumerRequest($code: ID, $id: ID, $utcOffset: Int) {
  getConsumerRequest(code: $code, id: $id) {
    acceptedProviderRequest {
      id
    }
    appointmentDate
    scheduledDate
    assignedCompanyId
    bucket
    bucketLabel
    code
    commentThreadId
    consolidatedJobId
    contacts {
      userId
      name
      mobile
      email
      label
      role
    }
    internalAssignee {
      name
      email
      mobile
      userId
    }
    siteAccessNote {
      note
    }
    subBucket
    subBucketLabel
    serviceType
    serviceTypeLabel
    providerName
    consumerName
    statusDescription(utcOffset: $utcOffset)
    createdAt
    declineReason
    diagnostic
    estimateId
    flatRate
    following
    id
    media {
      contentType
      createdAt
      id
      url
      thumbnailUrl
    }
    jobs {
      id
      code
      status
    }
    lat
    lng
    note {
      note
      updatedAt
    }
    organization {
      id
      name
    }
    referenceNumber
    releaseDate
    serviceType
    status
    tags
    consumerId
    consumer {
      ...userFields
    }
    property {
      id
      name
      user {
        ...userFields
      }
    }
    propertyId
    providerRequests(statusCodes: 20) {
      edges {
        id
        providerId
        status
      }
    }
    address
    networks
    updatedAt
    workorder {
      id
      attachments {
        id
        contentType
        url
      }
      priority
      residentName
      residentMobile
      serviceRequestType {
        id
        name
      }
      workorderConsumerRequest {
        networkType
        tags
        serviceType
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetConsumerRequestQuery__
 *
 * To run a query within a React component, call `useGetConsumerRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerRequestQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *      utcOffset: // value for 'utcOffset'
 *   },
 * });
 */
export function useGetConsumerRequestQuery(baseOptions?: Apollo.QueryHookOptions<IGetConsumerRequestQuery, IGetConsumerRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetConsumerRequestQuery, IGetConsumerRequestQueryVariables>(GetConsumerRequestDocument, options);
      }
export function useGetConsumerRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetConsumerRequestQuery, IGetConsumerRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetConsumerRequestQuery, IGetConsumerRequestQueryVariables>(GetConsumerRequestDocument, options);
        }
export type GetConsumerRequestQueryHookResult = ReturnType<typeof useGetConsumerRequestQuery>;
export type GetConsumerRequestLazyQueryHookResult = ReturnType<typeof useGetConsumerRequestLazyQuery>;
export type GetConsumerRequestQueryResult = Apollo.QueryResult<IGetConsumerRequestQuery, IGetConsumerRequestQueryVariables>;
export const GetEstimateDocument = gql`
    query getEstimate($jobId: ID, $claimId: ID) {
  getEstimate(claimId: $claimId, jobId: $jobId) {
    id
    status
    claimId
    jobId
    revision {
      id
      revisionNumber
      revisionName
      totalCost
      totalCalcType
      status
      attachments {
        count
        data {
          ...EstimateAttachmentSubFields
        }
      }
      rooms {
        count
        items {
          id
          revisionId
          totalCost
          name
          attachments {
            count
            data {
              ...EstimateAttachmentSubFields
            }
          }
          notes {
            items {
              id
              note
            }
            count
          }
          lineItems {
            count
            items {
              id
              roomId
              quantity
              totalCost
              measurementUnit
              title {
                id
                isNoteMandatory
                measurementsUnitId
                measurementsUnitHint
                measurementsUnit
                name
                noteHint
              }
              ...EstimateLineItemSubfields
            }
          }
        }
      }
    }
  }
}
    ${EstimateAttachmentSubFieldsFragmentDoc}
${EstimateLineItemSubfieldsFragmentDoc}`;

/**
 * __useGetEstimateQuery__
 *
 * To run a query within a React component, call `useGetEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useGetEstimateQuery(baseOptions?: Apollo.QueryHookOptions<IGetEstimateQuery, IGetEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimateQuery, IGetEstimateQueryVariables>(GetEstimateDocument, options);
      }
export function useGetEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimateQuery, IGetEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimateQuery, IGetEstimateQueryVariables>(GetEstimateDocument, options);
        }
export type GetEstimateQueryHookResult = ReturnType<typeof useGetEstimateQuery>;
export type GetEstimateLazyQueryHookResult = ReturnType<typeof useGetEstimateLazyQuery>;
export type GetEstimateQueryResult = Apollo.QueryResult<IGetEstimateQuery, IGetEstimateQueryVariables>;
export const GetEstimateAttachmentsDownloadDocument = gql`
    query getEstimateAttachmentsDownload($email: String, $id: ID!) {
  getEstimateAttachmentsDownload(email: $email, id: $id)
}
    `;

/**
 * __useGetEstimateAttachmentsDownloadQuery__
 *
 * To run a query within a React component, call `useGetEstimateAttachmentsDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateAttachmentsDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateAttachmentsDownloadQuery({
 *   variables: {
 *      email: // value for 'email'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstimateAttachmentsDownloadQuery(baseOptions: Apollo.QueryHookOptions<IGetEstimateAttachmentsDownloadQuery, IGetEstimateAttachmentsDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimateAttachmentsDownloadQuery, IGetEstimateAttachmentsDownloadQueryVariables>(GetEstimateAttachmentsDownloadDocument, options);
      }
export function useGetEstimateAttachmentsDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimateAttachmentsDownloadQuery, IGetEstimateAttachmentsDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimateAttachmentsDownloadQuery, IGetEstimateAttachmentsDownloadQueryVariables>(GetEstimateAttachmentsDownloadDocument, options);
        }
export type GetEstimateAttachmentsDownloadQueryHookResult = ReturnType<typeof useGetEstimateAttachmentsDownloadQuery>;
export type GetEstimateAttachmentsDownloadLazyQueryHookResult = ReturnType<typeof useGetEstimateAttachmentsDownloadLazyQuery>;
export type GetEstimateAttachmentsDownloadQueryResult = Apollo.QueryResult<IGetEstimateAttachmentsDownloadQuery, IGetEstimateAttachmentsDownloadQueryVariables>;
export const GetEstimatePdfDownloadDocument = gql`
    query getEstimatePdfDownload($revisionId: ID!, $pdfType: EstimateRevisionDocumentType) {
  getEstimatePdf(id: $revisionId, pdfType: $pdfType) {
    url
  }
}
    `;

/**
 * __useGetEstimatePdfDownloadQuery__
 *
 * To run a query within a React component, call `useGetEstimatePdfDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatePdfDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatePdfDownloadQuery({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *      pdfType: // value for 'pdfType'
 *   },
 * });
 */
export function useGetEstimatePdfDownloadQuery(baseOptions: Apollo.QueryHookOptions<IGetEstimatePdfDownloadQuery, IGetEstimatePdfDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimatePdfDownloadQuery, IGetEstimatePdfDownloadQueryVariables>(GetEstimatePdfDownloadDocument, options);
      }
export function useGetEstimatePdfDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimatePdfDownloadQuery, IGetEstimatePdfDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimatePdfDownloadQuery, IGetEstimatePdfDownloadQueryVariables>(GetEstimatePdfDownloadDocument, options);
        }
export type GetEstimatePdfDownloadQueryHookResult = ReturnType<typeof useGetEstimatePdfDownloadQuery>;
export type GetEstimatePdfDownloadLazyQueryHookResult = ReturnType<typeof useGetEstimatePdfDownloadLazyQuery>;
export type GetEstimatePdfDownloadQueryResult = Apollo.QueryResult<IGetEstimatePdfDownloadQuery, IGetEstimatePdfDownloadQueryVariables>;
export const GetEstimateRevisionStatusDocument = gql`
    query getEstimateRevisionStatus($revisionId: ID!) {
  getEstimateRevision(id: $revisionId) {
    status
  }
}
    `;

/**
 * __useGetEstimateRevisionStatusQuery__
 *
 * To run a query within a React component, call `useGetEstimateRevisionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateRevisionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateRevisionStatusQuery({
 *   variables: {
 *      revisionId: // value for 'revisionId'
 *   },
 * });
 */
export function useGetEstimateRevisionStatusQuery(baseOptions: Apollo.QueryHookOptions<IGetEstimateRevisionStatusQuery, IGetEstimateRevisionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimateRevisionStatusQuery, IGetEstimateRevisionStatusQueryVariables>(GetEstimateRevisionStatusDocument, options);
      }
export function useGetEstimateRevisionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimateRevisionStatusQuery, IGetEstimateRevisionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimateRevisionStatusQuery, IGetEstimateRevisionStatusQueryVariables>(GetEstimateRevisionStatusDocument, options);
        }
export type GetEstimateRevisionStatusQueryHookResult = ReturnType<typeof useGetEstimateRevisionStatusQuery>;
export type GetEstimateRevisionStatusLazyQueryHookResult = ReturnType<typeof useGetEstimateRevisionStatusLazyQuery>;
export type GetEstimateRevisionStatusQueryResult = Apollo.QueryResult<IGetEstimateRevisionStatusQuery, IGetEstimateRevisionStatusQueryVariables>;
export const GetEstimateRoomAttachmentsDocument = gql`
    query getEstimateRoomAttachments($id: ID!) {
  getRoomAttachments(id: $id) {
    count
    data {
      ...EstimateAttachmentSubFields
    }
  }
}
    ${EstimateAttachmentSubFieldsFragmentDoc}`;

/**
 * __useGetEstimateRoomAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetEstimateRoomAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateRoomAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateRoomAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstimateRoomAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<IGetEstimateRoomAttachmentsQuery, IGetEstimateRoomAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimateRoomAttachmentsQuery, IGetEstimateRoomAttachmentsQueryVariables>(GetEstimateRoomAttachmentsDocument, options);
      }
export function useGetEstimateRoomAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimateRoomAttachmentsQuery, IGetEstimateRoomAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimateRoomAttachmentsQuery, IGetEstimateRoomAttachmentsQueryVariables>(GetEstimateRoomAttachmentsDocument, options);
        }
export type GetEstimateRoomAttachmentsQueryHookResult = ReturnType<typeof useGetEstimateRoomAttachmentsQuery>;
export type GetEstimateRoomAttachmentsLazyQueryHookResult = ReturnType<typeof useGetEstimateRoomAttachmentsLazyQuery>;
export type GetEstimateRoomAttachmentsQueryResult = Apollo.QueryResult<IGetEstimateRoomAttachmentsQuery, IGetEstimateRoomAttachmentsQueryVariables>;
export const GetEstimateRoomDocument = gql`
    query getEstimateRoom($id: ID!) {
  getRooms(id: $id) {
    items {
      id
      name
      revisionId
    }
    count
  }
}
    `;

/**
 * __useGetEstimateRoomQuery__
 *
 * To run a query within a React component, call `useGetEstimateRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimateRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimateRoomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEstimateRoomQuery(baseOptions: Apollo.QueryHookOptions<IGetEstimateRoomQuery, IGetEstimateRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetEstimateRoomQuery, IGetEstimateRoomQueryVariables>(GetEstimateRoomDocument, options);
      }
export function useGetEstimateRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetEstimateRoomQuery, IGetEstimateRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetEstimateRoomQuery, IGetEstimateRoomQueryVariables>(GetEstimateRoomDocument, options);
        }
export type GetEstimateRoomQueryHookResult = ReturnType<typeof useGetEstimateRoomQuery>;
export type GetEstimateRoomLazyQueryHookResult = ReturnType<typeof useGetEstimateRoomLazyQuery>;
export type GetEstimateRoomQueryResult = Apollo.QueryResult<IGetEstimateRoomQuery, IGetEstimateRoomQueryVariables>;
export const GetItemActionsDocument = gql`
    query getItemActions($id: ID!) {
  getItemActions(id: $id) {
    count
    items {
      id
      name
      types {
        count
        items {
          id
          name
          grades {
            count
            items {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetItemActionsQuery__
 *
 * To run a query within a React component, call `useGetItemActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemActionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItemActionsQuery(baseOptions: Apollo.QueryHookOptions<IGetItemActionsQuery, IGetItemActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetItemActionsQuery, IGetItemActionsQueryVariables>(GetItemActionsDocument, options);
      }
export function useGetItemActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetItemActionsQuery, IGetItemActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetItemActionsQuery, IGetItemActionsQueryVariables>(GetItemActionsDocument, options);
        }
export type GetItemActionsQueryHookResult = ReturnType<typeof useGetItemActionsQuery>;
export type GetItemActionsLazyQueryHookResult = ReturnType<typeof useGetItemActionsLazyQuery>;
export type GetItemActionsQueryResult = Apollo.QueryResult<IGetItemActionsQuery, IGetItemActionsQueryVariables>;
export const GetJobDocument = gql`
    query getJob($code: ID, $id: ID) {
  getJob(code: $code, id: $id) {
    repairJob {
      code
    }
    estimateJob {
      code
    }
    address
    appointmentDate
    scheduledDate
    scheduledDateTimezone
    assignedCompanyId
    company {
      id
      name
    }
    bucket
    bucketLabel
    following
    subBucket
    subBucketLabel
    serviceType
    serviceTypeLabel
    providerName
    consumerName
    statusDescription
    code
    consolidatedJobId
    consumer {
      ...userFields
      customMaterialsFee
    }
    companyId
    consumerId
    consumerRequestId
    consumerRequest {
      createdAt
      id
      media {
        contentType
        createdAt
        id
        url
        thumbnailUrl
      }
      networks
      note {
        note
        updatedAt
      }
      releaseDate
      status
      updatedAt
    }
    commentThreadId
    contacts {
      userId
      name
      mobile
      email
      label
      role
    }
    claims {
      homeeClaimId
      attachments {
        attachmentId
        contentType
        filename
        documentType
        externalId
        location
        s3Location {
          bucket
          path
        }
        s3Path
        type
        visibility
        dateAdded
      }
    }
    createdAt
    diagnostic
    diagnosticStatus
    diagnosticNote {
      createdAt
      note
      noteEn
      noteEs
      scopeOfWork
      scopeOfWorkEn
      scopeOfWorkEs
      updatedAt
    }
    estimate {
      id
      estimateJobId
      estimateStatus
    }
    estimateV2 {
      id
      status
      jobId
      claimId
      lastUpdatedAt
      revision {
        id
        revisionNumber
        revisionName
        totalCost
        totalCalcType
        customerTotalCost
        status
        attachments {
          count
          data {
            ...EstimateAttachmentSubFields
          }
        }
        rooms {
          count
          items {
            id
            totalCost
            name
            notes {
              items {
                id
                note
              }
              count
            }
            attachments {
              count
              data {
                ...EstimateAttachmentSubFields
              }
            }
            lineItems {
              count
              items {
                id
                roomId
                measurementUnit
                title {
                  id
                  isNoteMandatory
                  measurementsUnitId
                  measurementsUnitHint
                  measurementsUnit
                  name
                  noteHint
                }
                grade {
                  id
                  name
                }
                type {
                  id
                  name
                }
                action {
                  id
                  name
                }
                quantity
                totalCost
                notes {
                  id
                  note
                }
              }
            }
          }
        }
      }
    }
    id
    internalAssignee {
      name
      email
      mobile
      userId
    }
    media {
      contentType
      createdAt
      id
      url
      thumbnailUrl
    }
    invoice {
      consumerFlatRate
      consumerRateBase
      consumerRateHour
      consumerTotalCost
      consumerTotalHourly
      consumerTotalMaterials
      coteriePremium
      discount
      elapsedTime
      promocode
      providerFlatRate
      providerRateBase
      providerRateHour
      providerTotalCost
      providerTotalHourly
      providerTotalMaterials
      subsidyFlatRate
      subsidyLevel
      subsidyRateBase
      subsidyRateHour
      subsidyTotalHourly
      tip
    }
    lineItems {
      id
      lineItemType
      description
      consumerTotal
      providerTotal
      jobMaterialId
    }
    lat
    limitExtensions {
      consumerNote
      createdAt
      currencyIncrease
      id
      minutesIncrease
      providerNote
      status
      updatedAt
    }
    limitReached
    limitTotal
    linkedJobs {
      id
      code
    }
    lng
    locked
    marketId
    market {
      id
      name
    }
    materials {
      id
      consumerPrice
      createdAt
      description
      providerPrice
      quantity
      rapidpassCode
      skipReimbursement
      updatedAt
    }
    note {
      note
      updatedAt
    }
    partsStop
    property {
      id
      name
      user {
        ...userFields
      }
    }
    propertyId
    provider {
      ...userFields
    }
    providerId
    organizationId
    organization {
      id
      name
    }
    referenceNumber
    resolutionAccepted
    resolutionSuggested
    serviceRequestType {
      id
      name
    }
    status
    tags
    transfers {
      id
      amount
      status
      type
      createdAt
      updatedAt
    }
    workorderId
    workorder {
      property {
        id
        name
        user {
          ...userFields
        }
      }
      id
      serviceRequestType {
        id
        name
      }
      attachments {
        contentType
        id
        url
      }
      media {
        contentType
        createdAt
        id
        url
        thumbnailUrl
      }
      note {
        note
        updatedAt
      }
      priority
      residentName
      residentMobile
      workorderJob {
        assignReason
      }
    }
    updatedAt
    userService {
      id
      experience
    }
  }
}
    ${UserFieldsFragmentDoc}
${EstimateAttachmentSubFieldsFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions?: Apollo.QueryHookOptions<IGetJobQuery, IGetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobQuery, IGetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobQuery, IGetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobQuery, IGetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<IGetJobQuery, IGetJobQueryVariables>;
export const GetJobTimerDocument = gql`
    query getJobTimer($id: ID!) {
  getJob(id: $id) {
    id
    timeAdjustment
    invoice {
      elapsedTime
    }
  }
}
    `;

/**
 * __useGetJobTimerQuery__
 *
 * To run a query within a React component, call `useGetJobTimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobTimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobTimerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobTimerQuery(baseOptions: Apollo.QueryHookOptions<IGetJobTimerQuery, IGetJobTimerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobTimerQuery, IGetJobTimerQueryVariables>(GetJobTimerDocument, options);
      }
export function useGetJobTimerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobTimerQuery, IGetJobTimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobTimerQuery, IGetJobTimerQueryVariables>(GetJobTimerDocument, options);
        }
export type GetJobTimerQueryHookResult = ReturnType<typeof useGetJobTimerQuery>;
export type GetJobTimerLazyQueryHookResult = ReturnType<typeof useGetJobTimerLazyQuery>;
export type GetJobTimerQueryResult = Apollo.QueryResult<IGetJobTimerQuery, IGetJobTimerQueryVariables>;
export const GetJobsListDocument = gql`
    query getJobsList($bucket: WorkbenchBucket, $companyId: ID, $companyIds: [ID], $consumerId: ID, $consumerRequestStatuses: [Int!], $createdDateEnd: String, $createdDateStart: String, $completedDateEnd: String, $completedDateStart: String, $appointmentDateEnd: String, $appointmentDateStart: String, $dateEnd: String, $dateStart: String, $first: Int, $following: Boolean, $includeTestResults: Boolean, $internalAssigneeId: ID, $internalAssigneeIds: [ID], $jobStatuses: [Int!], $laborCostMax: Float, $laborCostMin: Float, $marketId: ID, $materialCostMax: Float, $materialCostMin: Float, $networkTypes: [Int!], $orderBy: GetWorkbenchListOrderBy, $jobOrigin: JobOrigin, $organizationIds: [ID!], $priority: Int, $propertyId: ID, $providerId: ID, $providerIds: [ID], $regionId: ID, $residentId: ID, $roles: [Int!], $serviceTypes: [Int!], $startAfter: String, $sortOrder: SortOrder, $subBuckets: [SubBucket!], $thirdPartyOrigin: Boolean, $totalCostMax: Float, $totalCostMin: Float, $utcOffset: Int, $workorderStatuses: [Int!], $estimateStatuses: [JobEstimateStatus!], $scheduledDateEnd: String, $scheduledDateStart: String, $nullScheduledDate: Boolean, $nullAppointmentDate: Boolean) {
  getWorkbenchList(
    bucket: $bucket
    companyId: $companyId
    consumerId: $consumerId
    consumerRequestStatuses: $consumerRequestStatuses
    createdDateEnd: $createdDateEnd
    createdDateStart: $createdDateStart
    appointmentDateEnd: $appointmentDateEnd
    appointmentDateStart: $appointmentDateStart
    completedDateEnd: $completedDateEnd
    completedDateStart: $completedDateStart
    dateEnd: $dateEnd
    dateStart: $dateStart
    first: $first
    following: $following
    includeTestResults: $includeTestResults
    internalAssigneeId: $internalAssigneeId
    internalAssigneeIds: $internalAssigneeIds
    jobStatuses: $jobStatuses
    laborCostMax: $laborCostMax
    laborCostMin: $laborCostMin
    marketId: $marketId
    materialCostMax: $materialCostMax
    materialCostMin: $materialCostMin
    networkTypes: $networkTypes
    orderBy: $orderBy
    jobOrigin: $jobOrigin
    organizationIds: $organizationIds
    priority: $priority
    propertyId: $propertyId
    providerId: $providerId
    providerIds: $providerIds
    regionId: $regionId
    residentId: $residentId
    roles: $roles
    serviceTypes: $serviceTypes
    startAfter: $startAfter
    sortOrder: $sortOrder
    subBuckets: $subBuckets
    thirdPartyOrigin: $thirdPartyOrigin
    totalCostMax: $totalCostMax
    totalCostMin: $totalCostMin
    workorderStatuses: $workorderStatuses
    estimateStatuses: $estimateStatuses
    scheduledDateStart: $scheduledDateStart
    scheduledDateEnd: $scheduledDateEnd
    nullScheduledDate: $nullScheduledDate
    nullAppointmentDate: $nullAppointmentDate
    companyIds: $companyIds
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      __typename
      address
      assignedCompanyId
      company {
        id
        name
      }
      bucket
      bucketLabel
      createdAt
      appointmentDate
      scheduledDate
      scheduledDateTimezone
      consumerId
      following
      id
      lat
      lng
      priority
      referenceNumber
      requestNote {
        note
        updatedAt
      }
      serviceType
      serviceTypeLabel
      status
      subBucket
      subBucketLabel
      ... on ConsumerRequest {
        code
        statusDescription(utcOffset: $utcOffset)
        tags
        releaseDate
        consumerReqStatus: status
        internalAssignee {
          name
          email
          mobile
          userId
        }
        acceptedProviderRequest {
          id
        }
        workorder {
          id
          priority
          serviceRequestType {
            id
            name
          }
          type
          workorderConsumerRequest {
            tags
          }
        }
        updatedAt
        consumerName
        contactsMap {
          manager {
            name
            label
            role
            mobile
            email
            userId
          }
          propertyManager {
            name
            label
            role
            mobile
            email
            userId
          }
          consumer {
            name
            label
            role
            mobile
            email
            userId
          }
          resident {
            name
            label
            role
            mobile
            email
            userId
          }
          provider {
            name
            label
            role
            mobile
            email
            userId
          }
        }
        property {
          id
          name
          user {
            ...userFields
          }
        }
      }
      ... on Job {
        statusDescription
        tags
        code
        internalAssignee {
          name
          email
          mobile
          userId
        }
        estimate {
          id
          estimateJobId
        }
        limitReached
        consumerRequestId
        consumerRequest {
          id
          status
        }
        finalizedAt
        jobStatus: status
        property {
          id
          name
          user {
            ...userFields
          }
        }
        workorder {
          id
          priority
          serviceRequestType {
            id
            name
          }
          type
        }
        updatedAt
        consumerName
        contactsMap {
          manager {
            name
            label
            role
            mobile
            email
            userId
          }
          propertyManager {
            name
            label
            role
            mobile
            email
            userId
          }
          consumer {
            name
            label
            role
            mobile
            email
            userId
          }
          resident {
            name
            label
            role
            mobile
            email
            userId
          }
          provider {
            name
            label
            role
            mobile
            email
            userId
          }
        }
      }
      ... on Workorder {
        statusDescription
        internalAssignee {
          name
          email
          mobile
          userId
        }
        type
        consumerName
        consumer {
          ...userFields
        }
        property {
          id
          name
          class
          user {
            ...userFields
          }
        }
        market {
          id
          name
          status
        }
        organization {
          id
          name
        }
        serviceRequestType {
          id
          name
        }
        workorderConsumerRequest {
          id
          serviceType
          tags
        }
        workorderJob {
          id
          serviceType
          provider {
            ...userFields
          }
        }
        zipcode
        residentName
        workorderStatus: status
        updatedAt
        integrationOrganizationId
        integrationOrganizationName
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetJobsListQuery__
 *
 * To run a query within a React component, call `useGetJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsListQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      companyId: // value for 'companyId'
 *      companyIds: // value for 'companyIds'
 *      consumerId: // value for 'consumerId'
 *      consumerRequestStatuses: // value for 'consumerRequestStatuses'
 *      createdDateEnd: // value for 'createdDateEnd'
 *      createdDateStart: // value for 'createdDateStart'
 *      completedDateEnd: // value for 'completedDateEnd'
 *      completedDateStart: // value for 'completedDateStart'
 *      appointmentDateEnd: // value for 'appointmentDateEnd'
 *      appointmentDateStart: // value for 'appointmentDateStart'
 *      dateEnd: // value for 'dateEnd'
 *      dateStart: // value for 'dateStart'
 *      first: // value for 'first'
 *      following: // value for 'following'
 *      includeTestResults: // value for 'includeTestResults'
 *      internalAssigneeId: // value for 'internalAssigneeId'
 *      internalAssigneeIds: // value for 'internalAssigneeIds'
 *      jobStatuses: // value for 'jobStatuses'
 *      laborCostMax: // value for 'laborCostMax'
 *      laborCostMin: // value for 'laborCostMin'
 *      marketId: // value for 'marketId'
 *      materialCostMax: // value for 'materialCostMax'
 *      materialCostMin: // value for 'materialCostMin'
 *      networkTypes: // value for 'networkTypes'
 *      orderBy: // value for 'orderBy'
 *      jobOrigin: // value for 'jobOrigin'
 *      organizationIds: // value for 'organizationIds'
 *      priority: // value for 'priority'
 *      propertyId: // value for 'propertyId'
 *      providerId: // value for 'providerId'
 *      providerIds: // value for 'providerIds'
 *      regionId: // value for 'regionId'
 *      residentId: // value for 'residentId'
 *      roles: // value for 'roles'
 *      serviceTypes: // value for 'serviceTypes'
 *      startAfter: // value for 'startAfter'
 *      sortOrder: // value for 'sortOrder'
 *      subBuckets: // value for 'subBuckets'
 *      thirdPartyOrigin: // value for 'thirdPartyOrigin'
 *      totalCostMax: // value for 'totalCostMax'
 *      totalCostMin: // value for 'totalCostMin'
 *      utcOffset: // value for 'utcOffset'
 *      workorderStatuses: // value for 'workorderStatuses'
 *      estimateStatuses: // value for 'estimateStatuses'
 *      scheduledDateEnd: // value for 'scheduledDateEnd'
 *      scheduledDateStart: // value for 'scheduledDateStart'
 *      nullScheduledDate: // value for 'nullScheduledDate'
 *      nullAppointmentDate: // value for 'nullAppointmentDate'
 *   },
 * });
 */
export function useGetJobsListQuery(baseOptions?: Apollo.QueryHookOptions<IGetJobsListQuery, IGetJobsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetJobsListQuery, IGetJobsListQueryVariables>(GetJobsListDocument, options);
      }
export function useGetJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetJobsListQuery, IGetJobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetJobsListQuery, IGetJobsListQueryVariables>(GetJobsListDocument, options);
        }
export type GetJobsListQueryHookResult = ReturnType<typeof useGetJobsListQuery>;
export type GetJobsListLazyQueryHookResult = ReturnType<typeof useGetJobsListLazyQuery>;
export type GetJobsListQueryResult = Apollo.QueryResult<IGetJobsListQuery, IGetJobsListQueryVariables>;
export const GetMarketsDocument = gql`
    query getMarkets($regionId: ID, $status: [Int!]) {
  getMarkets(regionId: $regionId, status: $status) {
    id
    regionId
    name
    coli
    adjustedColi
    subsidized
    status
  }
}
    `;

/**
 * __useGetMarketsQuery__
 *
 * To run a query within a React component, call `useGetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetMarketsQuery(baseOptions?: Apollo.QueryHookOptions<IGetMarketsQuery, IGetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMarketsQuery, IGetMarketsQueryVariables>(GetMarketsDocument, options);
      }
export function useGetMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMarketsQuery, IGetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMarketsQuery, IGetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export type GetMarketsQueryHookResult = ReturnType<typeof useGetMarketsQuery>;
export type GetMarketsLazyQueryHookResult = ReturnType<typeof useGetMarketsLazyQuery>;
export type GetMarketsQueryResult = Apollo.QueryResult<IGetMarketsQuery, IGetMarketsQueryVariables>;
export const GetMatchingCompanyV2Document = gql`
    query getMatchingCompanyV2($postalCode: String!, $serviceId: String!, $latitude: String!, $longitude: String!, $organizationId: String, $flow: CompanyFlowLabel) {
  getMatchingCompanyV2(
    postalCode: $postalCode
    serviceId: $serviceId
    latitude: $latitude
    longitude: $longitude
    organizationId: $organizationId
    flow: $flow
  ) {
    id
    name
  }
}
    `;

/**
 * __useGetMatchingCompanyV2Query__
 *
 * To run a query within a React component, call `useGetMatchingCompanyV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchingCompanyV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchingCompanyV2Query({
 *   variables: {
 *      postalCode: // value for 'postalCode'
 *      serviceId: // value for 'serviceId'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      organizationId: // value for 'organizationId'
 *      flow: // value for 'flow'
 *   },
 * });
 */
export function useGetMatchingCompanyV2Query(baseOptions: Apollo.QueryHookOptions<IGetMatchingCompanyV2Query, IGetMatchingCompanyV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMatchingCompanyV2Query, IGetMatchingCompanyV2QueryVariables>(GetMatchingCompanyV2Document, options);
      }
export function useGetMatchingCompanyV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMatchingCompanyV2Query, IGetMatchingCompanyV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMatchingCompanyV2Query, IGetMatchingCompanyV2QueryVariables>(GetMatchingCompanyV2Document, options);
        }
export type GetMatchingCompanyV2QueryHookResult = ReturnType<typeof useGetMatchingCompanyV2Query>;
export type GetMatchingCompanyV2LazyQueryHookResult = ReturnType<typeof useGetMatchingCompanyV2LazyQuery>;
export type GetMatchingCompanyV2QueryResult = Apollo.QueryResult<IGetMatchingCompanyV2Query, IGetMatchingCompanyV2QueryVariables>;
export const GetMeasurementUnitsDocument = gql`
    query getMeasurementUnits {
  getMeasurementUnits {
    count
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useGetMeasurementUnitsQuery__
 *
 * To run a query within a React component, call `useGetMeasurementUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeasurementUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeasurementUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeasurementUnitsQuery(baseOptions?: Apollo.QueryHookOptions<IGetMeasurementUnitsQuery, IGetMeasurementUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMeasurementUnitsQuery, IGetMeasurementUnitsQueryVariables>(GetMeasurementUnitsDocument, options);
      }
export function useGetMeasurementUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMeasurementUnitsQuery, IGetMeasurementUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMeasurementUnitsQuery, IGetMeasurementUnitsQueryVariables>(GetMeasurementUnitsDocument, options);
        }
export type GetMeasurementUnitsQueryHookResult = ReturnType<typeof useGetMeasurementUnitsQuery>;
export type GetMeasurementUnitsLazyQueryHookResult = ReturnType<typeof useGetMeasurementUnitsLazyQuery>;
export type GetMeasurementUnitsQueryResult = Apollo.QueryResult<IGetMeasurementUnitsQuery, IGetMeasurementUnitsQueryVariables>;
export const GetMetadataDocument = gql`
    query getMetadata {
  getMetadata {
    id
    name
    isNoteMandatory
    measurementsUnitHint
    measurementsUnitId
    measurementsUnitName
    actions {
      count
      data {
        id
        name
        types {
          count
          data {
            id
            name
            grades {
              count
              data {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMetadataQuery__
 *
 * To run a query within a React component, call `useGetMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMetadataQuery(baseOptions?: Apollo.QueryHookOptions<IGetMetadataQuery, IGetMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMetadataQuery, IGetMetadataQueryVariables>(GetMetadataDocument, options);
      }
export function useGetMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMetadataQuery, IGetMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMetadataQuery, IGetMetadataQueryVariables>(GetMetadataDocument, options);
        }
export type GetMetadataQueryHookResult = ReturnType<typeof useGetMetadataQuery>;
export type GetMetadataLazyQueryHookResult = ReturnType<typeof useGetMetadataLazyQuery>;
export type GetMetadataQueryResult = Apollo.QueryResult<IGetMetadataQuery, IGetMetadataQueryVariables>;
export const GetPhoneTypeDocument = gql`
    query getPhoneType($phoneNumber: String!) {
  getPhoneType(phoneNumber: $phoneNumber) {
    type
  }
}
    `;

/**
 * __useGetPhoneTypeQuery__
 *
 * To run a query within a React component, call `useGetPhoneTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhoneTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhoneTypeQuery({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useGetPhoneTypeQuery(baseOptions: Apollo.QueryHookOptions<IGetPhoneTypeQuery, IGetPhoneTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPhoneTypeQuery, IGetPhoneTypeQueryVariables>(GetPhoneTypeDocument, options);
      }
export function useGetPhoneTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPhoneTypeQuery, IGetPhoneTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPhoneTypeQuery, IGetPhoneTypeQueryVariables>(GetPhoneTypeDocument, options);
        }
export type GetPhoneTypeQueryHookResult = ReturnType<typeof useGetPhoneTypeQuery>;
export type GetPhoneTypeLazyQueryHookResult = ReturnType<typeof useGetPhoneTypeLazyQuery>;
export type GetPhoneTypeQueryResult = Apollo.QueryResult<IGetPhoneTypeQuery, IGetPhoneTypeQueryVariables>;
export const GetRoomAttachmentDownloadDocument = gql`
    query getRoomAttachmentDownload($roomId: ID!, $attachmentId: ID!) {
  getRoomAttachmentDownload(roomId: $roomId, attachmentId: $attachmentId) {
    url
  }
}
    `;

/**
 * __useGetRoomAttachmentDownloadQuery__
 *
 * To run a query within a React component, call `useGetRoomAttachmentDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomAttachmentDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomAttachmentDownloadQuery({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useGetRoomAttachmentDownloadQuery(baseOptions: Apollo.QueryHookOptions<IGetRoomAttachmentDownloadQuery, IGetRoomAttachmentDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRoomAttachmentDownloadQuery, IGetRoomAttachmentDownloadQueryVariables>(GetRoomAttachmentDownloadDocument, options);
      }
export function useGetRoomAttachmentDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRoomAttachmentDownloadQuery, IGetRoomAttachmentDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRoomAttachmentDownloadQuery, IGetRoomAttachmentDownloadQueryVariables>(GetRoomAttachmentDownloadDocument, options);
        }
export type GetRoomAttachmentDownloadQueryHookResult = ReturnType<typeof useGetRoomAttachmentDownloadQuery>;
export type GetRoomAttachmentDownloadLazyQueryHookResult = ReturnType<typeof useGetRoomAttachmentDownloadLazyQuery>;
export type GetRoomAttachmentDownloadQueryResult = Apollo.QueryResult<IGetRoomAttachmentDownloadQuery, IGetRoomAttachmentDownloadQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!) {
  getUser(id: $id) {
    ...userFields
    isProfileGorilla
    externalId
    registrationStatus
    jobCount
    verified
    status
    createdAt
    availability {
      available
    }
    isActive
    taxationNumbers {
      id
      taxationNumber
      description
      administrativeArea
    }
    userMarket {
      name
      id
    }
    userPreferences {
      language
    }
    userLegalEntity {
      dobDay
      dobMonth
      dobYear
    }
    userServices {
      id
      status
      legacyService
      experience
      startYear
      service {
        id
        name
        iconName
        legacyId
      }
      serviceLicenses {
        id
        license
        jurisdiction
      }
      subUserServices {
        id
        status
        legacyService
        service {
          id
          name
          iconName
        }
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<IGetUserQuery, IGetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserQuery, IGetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserQuery, IGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserQuery, IGetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<IGetUserQuery, IGetUserQueryVariables>;
export const GetUserContactDocument = gql`
    query getUserContact($id: ID!) {
  getUser(id: $id) {
    email
    userProfile {
      firstName
      lastName
      mobile
    }
  }
}
    `;

/**
 * __useGetUserContactQuery__
 *
 * To run a query within a React component, call `useGetUserContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserContactQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserContactQuery(baseOptions: Apollo.QueryHookOptions<IGetUserContactQuery, IGetUserContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserContactQuery, IGetUserContactQueryVariables>(GetUserContactDocument, options);
      }
export function useGetUserContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserContactQuery, IGetUserContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserContactQuery, IGetUserContactQueryVariables>(GetUserContactDocument, options);
        }
export type GetUserContactQueryHookResult = ReturnType<typeof useGetUserContactQuery>;
export type GetUserContactLazyQueryHookResult = ReturnType<typeof useGetUserContactLazyQuery>;
export type GetUserContactQueryResult = Apollo.QueryResult<IGetUserContactQuery, IGetUserContactQueryVariables>;
export const GetUserPropertiesDocument = gql`
    query getUserProperties($userId: ID!, $propertyTypes: [Int!]) {
  getUserProperties(userId: $userId, propertyTypes: $propertyTypes) {
    address
    id
    lat
    lng
    name
    imageUrl
  }
}
    `;

/**
 * __useGetUserPropertiesQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      propertyTypes: // value for 'propertyTypes'
 *   },
 * });
 */
export function useGetUserPropertiesQuery(baseOptions: Apollo.QueryHookOptions<IGetUserPropertiesQuery, IGetUserPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserPropertiesQuery, IGetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
      }
export function useGetUserPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserPropertiesQuery, IGetUserPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserPropertiesQuery, IGetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
        }
export type GetUserPropertiesQueryHookResult = ReturnType<typeof useGetUserPropertiesQuery>;
export type GetUserPropertiesLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesLazyQuery>;
export type GetUserPropertiesQueryResult = Apollo.QueryResult<IGetUserPropertiesQuery, IGetUserPropertiesQueryVariables>;
export const GetWorkbenchBucketTotalDocument = gql`
    query getWorkbenchBucketTotal($bucket: WorkbenchBucket, $marketId: ID, $regionId: ID, $roles: [Int!], $thirdPartyOrigin: Boolean) {
  getWorkbenchList(
    bucket: $bucket
    marketId: $marketId
    regionId: $regionId
    roles: $roles
    thirdPartyOrigin: $thirdPartyOrigin
  ) {
    totalCount
  }
}
    `;

/**
 * __useGetWorkbenchBucketTotalQuery__
 *
 * To run a query within a React component, call `useGetWorkbenchBucketTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkbenchBucketTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkbenchBucketTotalQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      marketId: // value for 'marketId'
 *      regionId: // value for 'regionId'
 *      roles: // value for 'roles'
 *      thirdPartyOrigin: // value for 'thirdPartyOrigin'
 *   },
 * });
 */
export function useGetWorkbenchBucketTotalQuery(baseOptions?: Apollo.QueryHookOptions<IGetWorkbenchBucketTotalQuery, IGetWorkbenchBucketTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorkbenchBucketTotalQuery, IGetWorkbenchBucketTotalQueryVariables>(GetWorkbenchBucketTotalDocument, options);
      }
export function useGetWorkbenchBucketTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorkbenchBucketTotalQuery, IGetWorkbenchBucketTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorkbenchBucketTotalQuery, IGetWorkbenchBucketTotalQueryVariables>(GetWorkbenchBucketTotalDocument, options);
        }
export type GetWorkbenchBucketTotalQueryHookResult = ReturnType<typeof useGetWorkbenchBucketTotalQuery>;
export type GetWorkbenchBucketTotalLazyQueryHookResult = ReturnType<typeof useGetWorkbenchBucketTotalLazyQuery>;
export type GetWorkbenchBucketTotalQueryResult = Apollo.QueryResult<IGetWorkbenchBucketTotalQuery, IGetWorkbenchBucketTotalQueryVariables>;
export const GetWorkbenchListDocument = gql`
    query getWorkbenchList($bucket: WorkbenchBucket, $companyId: ID, $consumerId: ID, $consumerRequestStatuses: [Int!], $dateEnd: String, $dateStart: String, $first: Int, $following: Boolean, $includeTestResults: Boolean, $internalAssigneeId: ID, $jobStatuses: [Int!], $laborCostMax: Float, $laborCostMin: Float, $marketId: ID, $materialCostMax: Float, $materialCostMin: Float, $networkTypes: [Int!], $orderBy: GetWorkbenchListOrderBy, $jobOrigin: JobOrigin, $organizationIds: [ID!], $propertyId: ID, $providerId: ID, $regionId: ID, $residentId: ID, $roles: [Int!], $serviceTypes: [Int!], $startAfter: String, $sortOrder: SortOrder, $subBuckets: [SubBucket!], $thirdPartyOrigin: Boolean, $totalCostMax: Float, $totalCostMin: Float, $utcOffset: Int, $workorderStatuses: [Int!], $scheduledDateEnd: String, $scheduledDateStart: String, $nullScheduledDate: Boolean, $nullAppointmentDate: Boolean, $companyIds: [ID]) {
  getWorkbenchList(
    bucket: $bucket
    companyId: $companyId
    consumerId: $consumerId
    consumerRequestStatuses: $consumerRequestStatuses
    dateEnd: $dateEnd
    dateStart: $dateStart
    first: $first
    following: $following
    includeTestResults: $includeTestResults
    internalAssigneeId: $internalAssigneeId
    jobStatuses: $jobStatuses
    laborCostMax: $laborCostMax
    laborCostMin: $laborCostMin
    marketId: $marketId
    materialCostMax: $materialCostMax
    materialCostMin: $materialCostMin
    networkTypes: $networkTypes
    orderBy: $orderBy
    jobOrigin: $jobOrigin
    organizationIds: $organizationIds
    propertyId: $propertyId
    providerId: $providerId
    regionId: $regionId
    residentId: $residentId
    roles: $roles
    serviceTypes: $serviceTypes
    startAfter: $startAfter
    sortOrder: $sortOrder
    subBuckets: $subBuckets
    thirdPartyOrigin: $thirdPartyOrigin
    totalCostMax: $totalCostMax
    totalCostMin: $totalCostMin
    workorderStatuses: $workorderStatuses
    scheduledDateEnd: $scheduledDateEnd
    scheduledDateStart: $scheduledDateStart
    nullScheduledDate: $nullScheduledDate
    nullAppointmentDate: $nullAppointmentDate
    companyIds: $companyIds
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      __typename
      address
      bucket
      bucketLabel
      consumerName
      createdAt
      following
      id
      lat
      lng
      priority
      propertyId
      providerName
      referenceNumber
      serviceType
      serviceTypeLabel
      status
      subBucket
      subBucketColor
      subBucketLabel
      scheduledDate
      ... on ConsumerRequest {
        code
        statusDescription(utcOffset: $utcOffset)
        releaseDate
        consumerReqStatus: status
        consumer {
          ...userFields
        }
        workorder {
          id
          priority
        }
        updatedAt
        property {
          id
          name
          class
          user {
            ...userFields
          }
        }
        providerRequests(statusCodes: 20) {
          edges {
            id
            providerId
            status
          }
        }
        note {
          note
          updatedAt
        }
      }
      ... on Job {
        statusDescription
        code
        consumerRequestId
        consumerRequest {
          id
          status
        }
        finalizedAt
        limitReached
        invoice {
          consumerFlatRate
          consumerRateBase
          consumerRateHour
          consumerTotalCost
          consumerTotalHourly
          consumerTotalMaterials
          coteriePremium
          elapsedTime
          providerFlatRate
          providerRateBase
          providerRateHour
          providerTotalCost
          providerTotalHourly
          providerTotalMaterials
          subsidyFlatRate
          subsidyLevel
          subsidyRateBase
          subsidyRateHour
          subsidyTotalHourly
          tip
        }
        locked
        jobStatus: status
        consumer {
          id
          ...userFields
        }
        property {
          id
          name
          user {
            ...userFields
          }
        }
        provider {
          id
          ...userFields
        }
        workorder {
          id
          priority
        }
        updatedAt
        property {
          id
          class
        }
        partsStop
        note {
          note
          updatedAt
        }
      }
      ... on Workorder {
        statusDescription
        consumer {
          ...userFields
        }
        property {
          id
          name
          class
          user {
            ...userFields
          }
        }
        market {
          id
          name
          status
        }
        organization {
          id
          name
        }
        workorderConsumerRequest {
          id
          serviceType
        }
        workorderJob {
          id
          serviceType
          provider {
            ...userFields
          }
        }
        zipcode
        occupied
        residentName
        residentMobile
        workorderStatus: status
        updatedAt
        note {
          note
          updatedAt
        }
        integrationOrganizationId
        integrationOrganizationName
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetWorkbenchListQuery__
 *
 * To run a query within a React component, call `useGetWorkbenchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkbenchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkbenchListQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      companyId: // value for 'companyId'
 *      consumerId: // value for 'consumerId'
 *      consumerRequestStatuses: // value for 'consumerRequestStatuses'
 *      dateEnd: // value for 'dateEnd'
 *      dateStart: // value for 'dateStart'
 *      first: // value for 'first'
 *      following: // value for 'following'
 *      includeTestResults: // value for 'includeTestResults'
 *      internalAssigneeId: // value for 'internalAssigneeId'
 *      jobStatuses: // value for 'jobStatuses'
 *      laborCostMax: // value for 'laborCostMax'
 *      laborCostMin: // value for 'laborCostMin'
 *      marketId: // value for 'marketId'
 *      materialCostMax: // value for 'materialCostMax'
 *      materialCostMin: // value for 'materialCostMin'
 *      networkTypes: // value for 'networkTypes'
 *      orderBy: // value for 'orderBy'
 *      jobOrigin: // value for 'jobOrigin'
 *      organizationIds: // value for 'organizationIds'
 *      propertyId: // value for 'propertyId'
 *      providerId: // value for 'providerId'
 *      regionId: // value for 'regionId'
 *      residentId: // value for 'residentId'
 *      roles: // value for 'roles'
 *      serviceTypes: // value for 'serviceTypes'
 *      startAfter: // value for 'startAfter'
 *      sortOrder: // value for 'sortOrder'
 *      subBuckets: // value for 'subBuckets'
 *      thirdPartyOrigin: // value for 'thirdPartyOrigin'
 *      totalCostMax: // value for 'totalCostMax'
 *      totalCostMin: // value for 'totalCostMin'
 *      utcOffset: // value for 'utcOffset'
 *      workorderStatuses: // value for 'workorderStatuses'
 *      scheduledDateEnd: // value for 'scheduledDateEnd'
 *      scheduledDateStart: // value for 'scheduledDateStart'
 *      nullScheduledDate: // value for 'nullScheduledDate'
 *      nullAppointmentDate: // value for 'nullAppointmentDate'
 *      companyIds: // value for 'companyIds'
 *   },
 * });
 */
export function useGetWorkbenchListQuery(baseOptions?: Apollo.QueryHookOptions<IGetWorkbenchListQuery, IGetWorkbenchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorkbenchListQuery, IGetWorkbenchListQueryVariables>(GetWorkbenchListDocument, options);
      }
export function useGetWorkbenchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorkbenchListQuery, IGetWorkbenchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorkbenchListQuery, IGetWorkbenchListQueryVariables>(GetWorkbenchListDocument, options);
        }
export type GetWorkbenchListQueryHookResult = ReturnType<typeof useGetWorkbenchListQuery>;
export type GetWorkbenchListLazyQueryHookResult = ReturnType<typeof useGetWorkbenchListLazyQuery>;
export type GetWorkbenchListQueryResult = Apollo.QueryResult<IGetWorkbenchListQuery, IGetWorkbenchListQueryVariables>;
export const GetWorkorderDocument = gql`
    query getWorkorder($id: ID!) {
  getWorkorder(id: $id) {
    appointmentDate
    scheduledDate
    scheduledDateTimezone
    assignedCompanyId
    consolidatedJobId
    attachments {
      contentType
      id
      url
    }
    company {
      name
    }
    claims {
      homeeClaimId
      attachments {
        attachmentId
        contentType
        dateAdded
        thumbnailUrl
        attachmentUrl
        type
      }
    }
    createdAt
    commentThreadId
    consumerId
    following
    id
    internalAssignee {
      name
      email
      mobile
      userId
    }
    media {
      contentType
      createdAt
      id
      url
    }
    lat
    limitTotal
    lng
    note {
      updatedAt
      note
    }
    organization {
      id
      name
    }
    referenceNumber
    serviceId
    serviceType
    serviceTypeLabel
    status
    statusDescription
    subBucketLabel
    consumer {
      ...userFields
    }
    workorderConsumerRequest {
      createdAt
      id
      networkType
      releaseDate
      serviceType
    }
    workorderJob {
      assignReason
      createdAt
      id
      providerId
      serviceType
    }
    priority
    propertyId
    providerName
    address
    residentName
    residentMobile
    integrationOrganizationId
    integrationOrganizationName
    serviceRequestType {
      id
      name
    }
    updatedAt
    zipcode
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetWorkorderQuery__
 *
 * To run a query within a React component, call `useGetWorkorderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkorderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkorderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkorderQuery(baseOptions: Apollo.QueryHookOptions<IGetWorkorderQuery, IGetWorkorderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetWorkorderQuery, IGetWorkorderQueryVariables>(GetWorkorderDocument, options);
      }
export function useGetWorkorderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetWorkorderQuery, IGetWorkorderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetWorkorderQuery, IGetWorkorderQueryVariables>(GetWorkorderDocument, options);
        }
export type GetWorkorderQueryHookResult = ReturnType<typeof useGetWorkorderQuery>;
export type GetWorkorderLazyQueryHookResult = ReturnType<typeof useGetWorkorderLazyQuery>;
export type GetWorkorderQueryResult = Apollo.QueryResult<IGetWorkorderQuery, IGetWorkorderQueryVariables>;
export const JobEstimateDocument = gql`
    query jobEstimate($where: JobEstimateInputWhere!) {
  jobEstimate(where: $where) {
    deductible
    recoverableDepreciation
    nonRecoverableDepreciation
    estimateJob {
      code
      id
      consumerId
      providerId
      provider {
        id
        email
        userProfile {
          firstName
          lastName
          mobile
        }
      }
    }
    estimateConsumerRequest {
      code
      id
      consumerId
    }
    completionJob {
      id
      code
    }
    id
    estimateStatus
    estimateStatusDescription
    updatedAt
    proTotal
    consumerTotal
    laborMargin
    materialsMargin
    totalMargin
    canStartToday
    laborTimeRange {
      min
      max
    }
    comparedEarningsRange {
      min
      max
    }
    expiresAt
    assets {
      id
      thumbnailUrl
      url
      scanned
      contentType
    }
    items {
      id
      name
      proLaborPrice
      consumerLaborPrice
      totalProMaterialPrice
      totalConsumerMaterialPrice
      materials {
        id
        quantity
        name
        proPricePerUnit
        proTotal
        consumerPricePerUnit
        consumerTotal
      }
      recommendedSolution
      laborTimeRange {
        min
        max
      }
      measurements
      additionalNotes
      assets {
        id
        thumbnailUrl
        url
        contentType
      }
    }
  }
}
    `;

/**
 * __useJobEstimateQuery__
 *
 * To run a query within a React component, call `useJobEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobEstimateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useJobEstimateQuery(baseOptions: Apollo.QueryHookOptions<IJobEstimateQuery, IJobEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IJobEstimateQuery, IJobEstimateQueryVariables>(JobEstimateDocument, options);
      }
export function useJobEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IJobEstimateQuery, IJobEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IJobEstimateQuery, IJobEstimateQueryVariables>(JobEstimateDocument, options);
        }
export type JobEstimateQueryHookResult = ReturnType<typeof useJobEstimateQuery>;
export type JobEstimateLazyQueryHookResult = ReturnType<typeof useJobEstimateLazyQuery>;
export type JobEstimateQueryResult = Apollo.QueryResult<IJobEstimateQuery, IJobEstimateQueryVariables>;
export const MarketMetaDocument = gql`
    query marketMeta($id: ID!) {
  marketMeta(id: $id) {
    activeJobs
    enRouteJobs
    inProgressJobs
    pausedJobs
    suspendedJobs
    completedJobs
    onlinePros
    handymanPros
    plumbingPros
    hvacPros
    electricalPros
    smartHomePros
  }
}
    `;

/**
 * __useMarketMetaQuery__
 *
 * To run a query within a React component, call `useMarketMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketMetaQuery(baseOptions: Apollo.QueryHookOptions<IMarketMetaQuery, IMarketMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMarketMetaQuery, IMarketMetaQueryVariables>(MarketMetaDocument, options);
      }
export function useMarketMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMarketMetaQuery, IMarketMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMarketMetaQuery, IMarketMetaQueryVariables>(MarketMetaDocument, options);
        }
export type MarketMetaQueryHookResult = ReturnType<typeof useMarketMetaQuery>;
export type MarketMetaLazyQueryHookResult = ReturnType<typeof useMarketMetaLazyQuery>;
export type MarketMetaQueryResult = Apollo.QueryResult<IMarketMetaQuery, IMarketMetaQueryVariables>;
export const MentionsDocument = gql`
    query mentions($roles: [UserRoles!]!) {
  mentions(roles: $roles) {
    email
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useMentionsQuery__
 *
 * To run a query within a React component, call `useMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionsQuery({
 *   variables: {
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useMentionsQuery(baseOptions: Apollo.QueryHookOptions<IMentionsQuery, IMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IMentionsQuery, IMentionsQueryVariables>(MentionsDocument, options);
      }
export function useMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IMentionsQuery, IMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IMentionsQuery, IMentionsQueryVariables>(MentionsDocument, options);
        }
export type MentionsQueryHookResult = ReturnType<typeof useMentionsQuery>;
export type MentionsLazyQueryHookResult = ReturnType<typeof useMentionsLazyQuery>;
export type MentionsQueryResult = Apollo.QueryResult<IMentionsQuery, IMentionsQueryVariables>;
export const NotificationsDocument = gql`
    query notifications($first: Int, $startAfter: String, $sortOrder: SortOrder) {
  notifications(first: $first, startAfter: $startAfter, sortOrder: $sortOrder) {
    edges {
      actionUrl
      createdAt
      iconName
      id
      message
      readAt
      updatedAt
      userId
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      startAfter: // value for 'startAfter'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<INotificationsQuery, INotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<INotificationsQuery, INotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<INotificationsQuery, INotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<INotificationsQuery, INotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<INotificationsQuery, INotificationsQueryVariables>;
export const OrganizationDocument = gql`
    query organization($id: ID!) {
  organization: Organization(id: $id) {
    id
    networkInhouse
    networkOpen
    networkPreferred
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<IOrganizationQuery, IOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrganizationQuery, IOrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrganizationQuery, IOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrganizationQuery, IOrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<IOrganizationQuery, IOrganizationQueryVariables>;
export const ProsThatRecievedRequestDocument = gql`
    query prosThatRecievedRequest($consumerRequestId: ID!) {
  getProviderRequests(consumerRequestId: $consumerRequestId) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      provider {
        ...userFields
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProsThatRecievedRequestQuery__
 *
 * To run a query within a React component, call `useProsThatRecievedRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useProsThatRecievedRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProsThatRecievedRequestQuery({
 *   variables: {
 *      consumerRequestId: // value for 'consumerRequestId'
 *   },
 * });
 */
export function useProsThatRecievedRequestQuery(baseOptions: Apollo.QueryHookOptions<IProsThatRecievedRequestQuery, IProsThatRecievedRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IProsThatRecievedRequestQuery, IProsThatRecievedRequestQueryVariables>(ProsThatRecievedRequestDocument, options);
      }
export function useProsThatRecievedRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IProsThatRecievedRequestQuery, IProsThatRecievedRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IProsThatRecievedRequestQuery, IProsThatRecievedRequestQueryVariables>(ProsThatRecievedRequestDocument, options);
        }
export type ProsThatRecievedRequestQueryHookResult = ReturnType<typeof useProsThatRecievedRequestQuery>;
export type ProsThatRecievedRequestLazyQueryHookResult = ReturnType<typeof useProsThatRecievedRequestLazyQuery>;
export type ProsThatRecievedRequestQueryResult = Apollo.QueryResult<IProsThatRecievedRequestQuery, IProsThatRecievedRequestQueryVariables>;
export const ServiceRequestTypesDocument = gql`
    query serviceRequestTypes {
  serviceRequestTypes {
    id
    name
  }
}
    `;

/**
 * __useServiceRequestTypesQuery__
 *
 * To run a query within a React component, call `useServiceRequestTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceRequestTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceRequestTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceRequestTypesQuery(baseOptions?: Apollo.QueryHookOptions<IServiceRequestTypesQuery, IServiceRequestTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IServiceRequestTypesQuery, IServiceRequestTypesQueryVariables>(ServiceRequestTypesDocument, options);
      }
export function useServiceRequestTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IServiceRequestTypesQuery, IServiceRequestTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IServiceRequestTypesQuery, IServiceRequestTypesQueryVariables>(ServiceRequestTypesDocument, options);
        }
export type ServiceRequestTypesQueryHookResult = ReturnType<typeof useServiceRequestTypesQuery>;
export type ServiceRequestTypesLazyQueryHookResult = ReturnType<typeof useServiceRequestTypesLazyQuery>;
export type ServiceRequestTypesQueryResult = Apollo.QueryResult<IServiceRequestTypesQuery, IServiceRequestTypesQueryVariables>;
export const UserOrganizationsDocument = gql`
    query userOrganizations($userId: ID!) {
  userOrganizations: UserOrganizations(userId: $userId) {
    id
    name
    networkInhouse
    networkOpen
    networkPreferred
    internalName
  }
}
    `;

/**
 * __useUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOrganizationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<IUserOrganizationsQuery, IUserOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserOrganizationsQuery, IUserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
      }
export function useUserOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserOrganizationsQuery, IUserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserOrganizationsQuery, IUserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
export type UserOrganizationsQueryHookResult = ReturnType<typeof useUserOrganizationsQuery>;
export type UserOrganizationsLazyQueryHookResult = ReturnType<typeof useUserOrganizationsLazyQuery>;
export type UserOrganizationsQueryResult = Apollo.QueryResult<IUserOrganizationsQuery, IUserOrganizationsQueryVariables>;
export const UserPermissionsDocument = gql`
    query userPermissions($userId: ID!) {
  userPermissions(userId: $userId)
}
    `;

/**
 * __useUserPermissionsQuery__
 *
 * To run a query within a React component, call `useUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<IUserPermissionsQuery, IUserPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserPermissionsQuery, IUserPermissionsQueryVariables>(UserPermissionsDocument, options);
      }
export function useUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserPermissionsQuery, IUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserPermissionsQuery, IUserPermissionsQueryVariables>(UserPermissionsDocument, options);
        }
export type UserPermissionsQueryHookResult = ReturnType<typeof useUserPermissionsQuery>;
export type UserPermissionsLazyQueryHookResult = ReturnType<typeof useUserPermissionsLazyQuery>;
export type UserPermissionsQueryResult = Apollo.QueryResult<IUserPermissionsQuery, IUserPermissionsQueryVariables>;
export const UserServicesDocument = gql`
    query userServices($providerId: ID!) {
  userServices(providerId: $providerId) {
    id
    type
  }
}
    `;

/**
 * __useUserServicesQuery__
 *
 * To run a query within a React component, call `useUserServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserServicesQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useUserServicesQuery(baseOptions: Apollo.QueryHookOptions<IUserServicesQuery, IUserServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserServicesQuery, IUserServicesQueryVariables>(UserServicesDocument, options);
      }
export function useUserServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserServicesQuery, IUserServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserServicesQuery, IUserServicesQueryVariables>(UserServicesDocument, options);
        }
export type UserServicesQueryHookResult = ReturnType<typeof useUserServicesQuery>;
export type UserServicesLazyQueryHookResult = ReturnType<typeof useUserServicesLazyQuery>;
export type UserServicesQueryResult = Apollo.QueryResult<IUserServicesQuery, IUserServicesQueryVariables>;
export const ZipGeoDocument = gql`
    query zipGeo($zipCode: String!) {
  getZipGeo(zipCode: $zipCode) {
    zipCode
    timeZone
    tzName
  }
}
    `;

/**
 * __useZipGeoQuery__
 *
 * To run a query within a React component, call `useZipGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useZipGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZipGeoQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useZipGeoQuery(baseOptions: Apollo.QueryHookOptions<IZipGeoQuery, IZipGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IZipGeoQuery, IZipGeoQueryVariables>(ZipGeoDocument, options);
      }
export function useZipGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IZipGeoQuery, IZipGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IZipGeoQuery, IZipGeoQueryVariables>(ZipGeoDocument, options);
        }
export type ZipGeoQueryHookResult = ReturnType<typeof useZipGeoQuery>;
export type ZipGeoLazyQueryHookResult = ReturnType<typeof useZipGeoLazyQuery>;
export type ZipGeoQueryResult = Apollo.QueryResult<IZipGeoQuery, IZipGeoQueryVariables>;